/* eslint-disable */
// @ts-nocheck
/**
 * GÉNÉRÉ par tools/legacy/build.mjs à partir du HTML de référence : ne pas modifier à la main.
 *
 * Écrans de la maquette repris tels quels : fiche détail (onglets, calculs de moyennes, bilan annuel…), pages de module et de groupe,
 * rapports de la caisse (soldes, relances, échéances datées, inscriptions en attente, états), listes déroulantes de la maquette.
 * Les fonctions ci-dessous sont celles du HTML, sans retouche (une seule, déclarée dans build.mjs : le bouton PDF des états par classe). Ce que le HTML tenait dans des variables globales
 * (base de données, entités, rendu…) est fourni par ./runtime.
 */
import { ENUMS, MODULES, REPORTS } from '~/data/maquette'
import { STATUT_BADGE, SEXE_COLOR } from '~/data/entities'
import { ENTITIES, closeModal, currentEcoleId, db, entityRows, icon, render, setRecuInscriptionContext, tablePage, tableSearch, todayISO } from './runtime'

/** État du parcours d'inscription (écran à convertir) : « Traiter » de la Caisse l'initialise avant d'ouvrir le parcours. */
let wizard = null

/* ============ Code de la maquette (repris tel quel) ============ */

let detailActiveRecord = null;

let detailActiveTab = null;

let notesFilterPeriodeId = null;

let notesFilterMatiereId = null;

let soldesFilterClasse = '';

let soldesFilterDateDebut = '';

let soldesFilterDateFin = '';

let relancesFilterDate = '';

let relancesFilterDateDebut = '';

let relancesFilterDateFin = '';

let relancesFilterCycleId = null;

let relancesFilterNiveauId = null;

let relancesFilterClasseId = null;

let relancesFilterEtudiantId = null;

let relancesSelection = new Set();

let relanceBulkIds = [];

let echeancesDateesFilter = '';

let caisseSelection = new Set();

let caisseEtatsAnneeId = null;

let caisseEtatsClasseId = null;

let caisseEtatsMoisKey = null;

let caisseEtatsDateDebut = '';

let caisseEtatsDateFin = '';

let viewMode = 'cards';

let matieresPicker = {offreId:null, niveauId:null, periodeId:null};

let notesPicker = {classeId:null, matiereId:null, periodeId:null, pendingColumns:[]};

let bulletinsPicker = {classeId:null, periodeId:null};

let recuInscriptionContext = null;

const DETAIL_SECTIONS = {
  niveauOffreInfo(no){
    const offre = findById('offres', no.offreId);
    const niveau = findById('niveaux', no.niveauId);
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Informations</h3><button class="btn-icon" onclick="openForm('niveauOffre', '${no.id}')" title="Modifier">${icon('pencil')}</button></div>
        <div class="detail-grid">
          <div class="kv"><div class="k">Offre de formation</div><div class="v">${offre ? offre.libelle : '—'}</div></div>
          <div class="kv"><div class="k">Niveau</div><div class="v">${niveau ? niveau.libelle : '—'}</div></div>
          <div class="kv"><div class="k">Libellé local</div><div class="v">${no.libelleLocal || '—'}</div></div>
          <div class="kv"><div class="k">Volume horaire</div><div class="v">${no.volumeHoraire!=null && no.volumeHoraire!=='' ? no.volumeHoraire : '—'}</div></div>
          <div class="kv"><div class="k">Ordre dans la formation</div><div class="v">${no.ordreDansOffre}</div></div>
        </div>
      </div>`;
  },

  niveauOffreClasses(no){
    const classes = db.classes.filter(c=>c.offreId===no.offreId && c.niveauId===no.niveauId);
    const rowsHtml = classes.length ? classes.map(c=>{
      const annee = findById('annees', c.anneeId);
      return `<tr>
        <td><a class="fk-link" onclick="goTo('detail','classes', '${c.id}')">${c.libelle}</a></td>
        <td>${annee ? annee.libelle : '—'}</td>
        <td>${c.capaciteMax}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('classes', '${c.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="4">Aucune classe ouverte pour cette offre et ce niveau pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Classes pour cette offre et ce niveau (${classes.length})</h3></div>
        <table class="data">
          <thead><tr><th>Libellé</th><th>Année académique</th><th>Capacité</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  typesDocumentOffres(td){
    const offres = (td.offreIds||[]).map(id=>findById('offres', id)).filter(Boolean)
      .sort((a,b)=>a.libelle.localeCompare(b.libelle));
    const rowsHtml = offres.length ? offres.map(o=>`<tr>
        <td class="mono">${o.code}</td>
        <td><a class="fk-link" onclick="goTo('detail','offres', '${o.id}')">${o.libelle}</a></td>
        <td>${offreCyclesLabel(o.id)}</td>
      </tr>`).join('') : `<tr class="empty-row"><td colspan="3">Aucune offre de formation rattachée pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Offres de formation concernées (${offres.length})</h3></div>
        <table class="data">
          <thead><tr><th>Code</th><th>Offre</th><th>Cycle(s)</th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  niveauxOffres(niveau){
    const liens = db.niveauOffre.filter(no=>no.niveauId===niveau.id);
    const rowsHtml = liens.length ? liens.map(no=>{
      const offre = findById('offres', no.offreId);
      return `<tr>
        <td>${offre ? offre.libelle : '—'}</td>
        <td>${no.libelleLocal || '—'}</td>
        <td>${no.volumeHoraire!=null && no.volumeHoraire!=='' ? no.volumeHoraire : '—'}</td>
        <td>${no.ordreDansOffre}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('niveauOffre', '${no.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucune offre de formation rattachée à ce niveau pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Offres de formation avec ce niveau (${liens.length})</h3></div>
        <table class="data">
          <thead><tr><th>Offre</th><th>Libellé local</th><th>Volume horaire</th><th>Ordre</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  niveauxClasses(niveau){
    const classes = db.classes.filter(c=>c.niveauId===niveau.id);
    const rowsHtml = classes.length ? classes.map(c=>{
      const offre = findById('offres', c.offreId);
      const annee = findById('annees', c.anneeId);
      return `<tr>
        <td><a class="fk-link" onclick="goTo('detail','classes', '${c.id}')">${c.libelle}</a></td>
        <td>${offre ? offre.libelle : '—'}</td>
        <td>${annee ? annee.libelle : '—'}</td>
        <td>${c.capaciteMax}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('classes', '${c.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucune classe ouverte à ce niveau pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Classes à ce niveau (${classes.length})</h3></div>
        <table class="data">
          <thead><tr><th>Libellé</th><th>Offre</th><th>Année académique</th><th>Capacité</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  niveauxTarifications(niveau){
    const tarifs = db.tarifications.filter(t=>t.niveauId===niveau.id);
    const rowsHtml = tarifs.length ? tarifs.map(t=>{
      const annee = findById('annees', t.anneeId);
      return `<tr>
        <td>${t.libelle}</td>
        <td>${annee ? annee.libelle : '—'}</td>
        <td>${fmtMoney(t.montant)}</td>
        <td>${t.nombreTranches}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('tarifications', '${t.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucune tarification rattachée à ce niveau pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Tarifications de ce niveau (${tarifs.length})</h3></div>
        <table class="data">
          <thead><tr><th>Type de frais</th><th>Année académique</th><th>Montant</th><th>Tranches</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  niveauxUnitesEnseignement(niveau){
    const ues = db.unitesEnseignement.filter(u=>(u.niveauIds||[]).includes(niveau.id));
    const ueRow = u=>`<tr>
        <td class="mono">${u.code || '—'}</td>
        <td><a class="fk-link" onclick="goTo('detail','unitesEnseignement', '${u.id}')">${u.libelle}</a></td>
        <td>${(u.offreIds||[]).map(id=>{ const o=findById('offres', id); return o?o.libelle:''; }).filter(Boolean).join(', ') || '—'}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('unitesEnseignement', '${u.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    const groupPanel = (title, us)=>`
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>${title} (${us.length})</h3></div>
        <table class="data">
          <thead><tr><th>Code</th><th>Libellé</th><th>Offres</th><th></th></tr></thead>
          <tbody>${us.length ? us.map(ueRow).join('') : `<tr class="empty-row"><td colspan="4">Aucune unité d'enseignement dans cette période.</td></tr>`}</tbody>
        </table>
      </div>`;
    if(!ues.length){
      return groupPanel('Unités d\'enseignement à ce niveau', []);
    }
    const periodes = [...new Set(ues.flatMap(u=>u.periodeIds||[]))]
      .map(id=>findById('periodes', id)).filter(Boolean)
      .sort((a,b)=>Number(a.ordre)-Number(b.ordre));
    const sectionsHtml = periodes.map(p=>groupPanel(p.libelle, ues.filter(u=>(u.periodeIds||[]).includes(p.id)))).join('');
    const sansPeriode = ues.filter(u=>!(u.periodeIds||[]).length);
    return sectionsHtml + (sansPeriode.length ? groupPanel('Sans période', sansPeriode) : '');
  },

  niveauxMatieres(niveau){
    const matieres = db.matieres.filter(m=>(m.niveauIds||[]).includes(niveau.id));
    const matiereRow = m=>`<tr>
        <td class="mono">${m.code}</td>
        <td><a class="fk-link" onclick="openForm('matieres', '${m.id}')">${m.libelle}</a></td>
        <td>${m.coefficient}</td>
        <td>${m.credits}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('matieres', '${m.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    const groupPanel = (title, ms)=>`
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>${title} (${ms.length})</h3></div>
        <table class="data">
          <thead><tr><th>Code</th><th>Libellé</th><th>Coefficient</th><th>Crédits</th><th></th></tr></thead>
          <tbody>${ms.length ? ms.map(matiereRow).join('') : `<tr class="empty-row"><td colspan="5">Aucune matière dans cette période.</td></tr>`}</tbody>
        </table>
      </div>`;
    if(!matieres.length){
      return groupPanel('Matières (ECUE) à ce niveau', []);
    }
    const periodes = [...new Set(matieres.flatMap(m=>m.periodeIds||[]))]
      .map(id=>findById('periodes', id)).filter(Boolean)
      .sort((a,b)=>Number(a.ordre)-Number(b.ordre));
    const sectionsHtml = periodes.map(p=>groupPanel(p.libelle, matieres.filter(m=>(m.periodeIds||[]).includes(p.id)))).join('');
    const sansPeriode = matieres.filter(m=>!(m.periodeIds||[]).length);
    return sectionsHtml + (sansPeriode.length ? groupPanel('Sans période', sansPeriode) : '');
  },

  niveauxDocuments(niveau){
    const docs = db.typesDocument.filter(d=>(d.niveauIds||[]).includes(niveau.id));
    const rowsHtml = docs.length ? docs.map(d=>`<tr>
        <td><a class="fk-link" onclick="openForm('typesDocument', '${d.id}')">${d.libelle}</a></td>
        <td>${d.obligatoire ? '<span class="badge b-success">Oui</span>' : '<span class="badge">Non</span>'}</td>
        <td>${d.formatAccepte || '—'}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('typesDocument', '${d.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`).join('') : `<tr class="empty-row"><td colspan="4">Aucun type de document requis pour ce niveau pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Documents requis pour ce niveau (${docs.length})</h3></div>
        <table class="data">
          <thead><tr><th>Libellé</th><th>Obligatoire</th><th>Format accepté</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  cyclesNiveaux(cycle){
    const niveaux = db.niveaux.filter(n=>n.cycleId===cycle.id).sort((a,b)=>Number(a.ordre)-Number(b.ordre));
    const rowsHtml = niveaux.length ? niveaux.map(n=>`<tr>
        <td>${n.libelle}</td>
        <td>${n.ordre}</td>
        <td>${n.moyennePassage!=null && n.moyennePassage!=='' ? n.moyennePassage : '—'}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('niveaux', '${n.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`).join('') : `<tr class="empty-row"><td colspan="4">Aucun niveau rattaché à ce cycle pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Niveaux de ce cycle (${niveaux.length})</h3><button class="btn btn-primary btn-sm" onclick="openForm('niveaux', null, {cycleId:'${cycle.id}', ecoleId:'${cycle.ecoleId}'})">${icon('plus','icon-sm')} Ajouter un niveau</button></div>
        <table class="data">
          <thead><tr><th>Libellé</th><th>Ordre</th><th>Moyenne de passage</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  cyclesTarifications(cycle){
    const tarifs = db.tarifications.filter(t=>t.cycleId===cycle.id);
    const rowsHtml = tarifs.length ? tarifs.map(t=>{
      const niveau = findById('niveaux', t.niveauId);
      const annee = findById('annees', t.anneeId);
      return `<tr>
        <td>${t.libelle}</td>
        <td>${niveau ? niveau.libelle : '—'}</td>
        <td>${annee ? annee.libelle : '—'}</td>
        <td>${fmtMoney(t.montant)}</td>
        <td>${t.nombreTranches}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('tarifications', '${t.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="6">Aucune tarification rattachée à ce cycle pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Tarifications de ce cycle (${tarifs.length})</h3></div>
        <table class="data">
          <thead><tr><th>Type de frais</th><th>Niveau</th><th>Année académique</th><th>Montant</th><th>Tranches</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  offresNiveaux(offre){
    const liens = db.niveauOffre.filter(no=>no.offreId===offre.id).sort((a,b)=>Number(a.ordreDansOffre)-Number(b.ordreDansOffre));
    const rowsHtml = liens.length ? liens.map(no=>{
      const niveau = findById('niveaux', no.niveauId);
      return `<tr>
        <td>${niveau ? niveau.libelle : '—'}</td>
        <td>${no.libelleLocal || '—'}</td>
        <td>${no.volumeHoraire!=null && no.volumeHoraire!=='' ? no.volumeHoraire : '—'}</td>
        <td>${no.ordreDansOffre}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('niveauOffre', '${no.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucun niveau rattaché à cette offre pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Niveaux de cette offre (${liens.length})</h3></div>
        <table class="data">
          <thead><tr><th>Niveau</th><th>Libellé local</th><th>Volume horaire</th><th>Ordre</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  offresClasses(offre){
    const classes = db.classes.filter(c=>c.offreId===offre.id);
    const rowsHtml = classes.length ? classes.map(c=>{
      const niveau = findById('niveaux', c.niveauId);
      const annee = findById('annees', c.anneeId);
      return `<tr>
        <td><a class="fk-link" onclick="goTo('detail','classes', '${c.id}')">${c.libelle}</a></td>
        <td>${niveau ? niveau.libelle : '—'}</td>
        <td>${annee ? annee.libelle : '—'}</td>
        <td>${c.capaciteMax}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('classes', '${c.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucune classe ouverte pour cette offre pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Classes de cette offre (${classes.length})</h3></div>
        <table class="data">
          <thead><tr><th>Libellé</th><th>Niveau</th><th>Année académique</th><th>Capacité</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  offresUnitesEnseignement(offre){
    const ues = db.unitesEnseignement.filter(u=>(u.offreIds||[]).includes(offre.id));
    const rowsHtml = ues.length ? ues.map(u=>`<tr>
        <td class="mono">${u.code || '—'}</td>
        <td><a class="fk-link" onclick="goTo('detail','unitesEnseignement', '${u.id}')">${u.libelle}</a></td>
        <td>${(u.niveauIds||[]).map(id=>{ const n=findById('niveaux', id); return n?n.libelle:''; }).filter(Boolean).join(', ') || '—'}</td>
        <td>${(u.periodeIds||[]).map(id=>{ const p=findById('periodes', id); return p?p.libelle:''; }).filter(Boolean).join(', ') || '—'}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('unitesEnseignement', '${u.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`).join('') : `<tr class="empty-row"><td colspan="5">Aucune unité d'enseignement rattachée à cette offre pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Unités d'enseignement de cette offre (${ues.length})</h3></div>
        <table class="data">
          <thead><tr><th>Code</th><th>Libellé</th><th>Niveaux</th><th>Périodes</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  offresMatieres(offre){
    const matieres = db.matieres.filter(m=>(m.offreIds||[]).includes(offre.id));
    const rowsHtml = matieres.length ? matieres.map(m=>`<tr>
        <td class="mono">${m.code}</td>
        <td><a class="fk-link" onclick="openForm('matieres', '${m.id}')">${m.libelle}</a></td>
        <td>${m.coefficient}</td>
        <td>${m.credits}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('matieres', '${m.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`).join('') : `<tr class="empty-row"><td colspan="5">Aucune matière (ECUE) rattachée à cette offre pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Matières (ECUE) de cette offre (${matieres.length})</h3></div>
        <table class="data">
          <thead><tr><th>Code</th><th>Libellé</th><th>Coefficient</th><th>Crédits</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  unitesEnseignement(ue){
    const matieres = db.matieres.filter(m=>m.ueId===ue.id);
    const totalCredits = matieres.reduce((s,m)=>s+Number(m.credits||0),0);
    const rowsHtml = matieres.length ? matieres.map(m=>`<tr>
        <td class="mono">${m.code}</td>
        <td><a class="fk-link" onclick="openForm('matieres', '${m.id}')">${m.libelle}</a></td>
        <td>${m.coefficient}</td>
        <td>${m.credits}</td>
        <td class="row-actions"><button class="btn-icon" onclick="openForm('matieres', '${m.id}')" title="Modifier">${icon('pencil')}</button></td>
      </tr>`).join('') : `<tr class="empty-row"><td colspan="5">Aucune matière (ECUE) rattachée à cette UE pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>ECUE de cette UE (${matieres.length} · ${totalCredits} crédit${totalCredits>1?'s':''})</h3>
          <button class="btn btn-primary btn-sm" onclick="openAddEcueModal('${ue.id}')">${icon('plus','icon-sm')} Ajouter une matière</button>
        </div>
        <table class="data">
          <thead><tr><th>Code</th><th>Libellé</th><th>Coefficient</th><th>Crédits</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  classes(classe){
    const inscriptions = db.inscriptions.filter(i=>i.classeId===classe.id);
    const rowsHtml = inscriptions.length ? inscriptions.map(i=>{
      const etu = findById('personnes', i.etudiantId);
      if(!etu) return '';
      return `<tr>
        <td><a class="fk-link" onclick="goTo('detail','etudiants', '${etu.id}')">${etu.prenoms} ${etu.nom}</a></td>
        <td class="mono">${etu.numeroEtudiant || '—'}</td>
        <td class="mono">${i.numero}</td>
        <td><span class="badge ${STATUT_BADGE[i.statut]||''}"><span class="dot"></span>${titleCase(i.statut)}</span></td>
        <td class="row-actions"><button class="btn btn-ghost btn-sm" onclick="goTo('detail','inscriptions', '${i.id}')">Voir l'inscription</button></td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucun étudiant inscrit dans cette classe pour l'instant.</td></tr>`;
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Étudiants de la classe (${inscriptions.length})</h3><div class="toolbar"><button class="btn btn-sm" onclick="exportListeClasseExcel('${classe.id}')">${icon('file-spreadsheet','icon-sm')} Excel</button><button class="btn btn-sm" onclick="goTo('liste-classe','classes', '${classe.id}')">${icon('printer','icon-sm')} Imprimer la liste</button></div></div>
        <table class="data">
          <thead><tr><th>Étudiant</th><th>N° étudiant</th><th>N° inscription</th><th>Statut</th><th></th></tr></thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  },

  versements(versement){
    const inscription = findById('inscriptions', versement.inscriptionId);
    if(!inscription) return `<div class="panel" style="margin-top:18px;"><div class="panel-head"><h3>Inscription</h3></div><div class="detail-grid"><div class="kv span2"><div class="v muted">Aucune inscription liée à ce versement.</div></div></div></div>`;
    const etudiant = findById('personnes', inscription.etudiantId);
    const classe = inscription.classeId ? findById('classes', inscription.classeId) : null;

    const classeHtml = classe ? `
      <div class="kv"><div class="k">Classe</div><div class="v">${classe.libelle}</div></div>
      <div class="kv"><div class="k">Niveau</div><div class="v">${findById('niveaux',classe.niveauId) ? findById('niveaux',classe.niveauId).libelle : '—'}</div></div>
      <div class="kv"><div class="k">Année académique</div><div class="v">${findById('annees',classe.anneeId) ? findById('annees',classe.anneeId).libelle : '—'}</div></div>
      <div class="kv"><div class="k">Salle</div><div class="v">${classe.salle || '—'}</div></div>
    ` : `<div class="kv span2"><div class="v muted">Cette inscription n'est rattachée à aucune classe.</div></div>`;
    const classeBtn = classe ? `<button class="btn btn-ghost btn-sm" onclick="goTo('detail','classes', '${classe.id}')">Voir la classe</button>` : '';

    const inscriptionIds = etudiant ? db.inscriptions.filter(i=>i.etudiantId===etudiant.id).map(i=>i.id) : [inscription.id];
    const paiements = db.versements.filter(v=>inscriptionIds.includes(v.inscriptionId));
    const table = paymentsTableHtml(paiements, versement.id);
    const [tableHtml, totalStr] = table.split('__TOTAL__');

    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Classe de l'étudiant</h3>${classeBtn}</div>
        <div class="detail-grid">${classeHtml}</div>
      </div>
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head">
          <h3>Paiements de ${etudiant ? etudiant.prenoms+' '+etudiant.nom : "l'étudiant"}</h3>
          <span class="ctx-pill">Total encaissé : <b>${fmtMoney(Number(totalStr))}</b></span>
        </div>
        ${tableHtml}
      </div>`;
  },

  echeanciers(echeancier){
    const lignes = db.lignesEcheance.filter(l=>l.echeancierId===echeancier.id).slice().sort((a,b)=>a.numeroTranche-b.numeroTranche);
    const totalDu = lignes.reduce((s,l)=>s+Number(l.montantDu||0),0);
    const lignesHtml = lignes.length ? lignes.map(l=>{
      const reste = Math.max(Number(l.montantDu)-Number(l.montantPaye||0), 0);
      return `<tr>
        <td>${l.libelle}</td>
        <td>${fmtMoney(l.montantDu)}</td>
        <td>${fmtMoney(l.montantPaye||0)}</td>
        <td>${fmtDate(l.dateEcheance)}</td>
        <td><span class="badge ${STATUT_BADGE[l.statut]||''}"><span class="dot"></span>${titleCase(l.statut)}</span></td>
        <td class="row-actions" style="text-align:right; white-space:nowrap;">
          ${reste>0 ? `<button class="btn btn-primary btn-sm" onclick="openPayLigneModal('${l.id}')">Payer</button>` : ''}
          <button class="btn btn-ghost btn-sm" onclick="goTo('detail','lignesEcheance', '${l.id}')">Détails</button>
        </td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="6">Aucune ligne d'échéance générée pour cet échéancier.</td></tr>`;
    const inscription = findById('inscriptions', echeancier.inscriptionId);
    const paiements = inscription ? db.versements.filter(v=>v.inscriptionId===inscription.id) : [];
    const table = paymentsTableHtml(paiements, null);
    const [tableHtml, totalStr] = table.split('__TOTAL__');
    const resteAPayer = Number(echeancier.montantNet||0) - Number(totalStr||0);
    return `
      <div class="panel">
        <div class="panel-head"><h3>Lignes d'échéance (${lignes.length})</h3><span class="ctx-pill">Total dû : <b>${fmtMoney(totalDu)}</b></span></div>
        <table class="data"><thead><tr><th>Tranche</th><th>Montant dû</th><th>Payé</th><th>Échéance</th><th>Statut</th><th></th></tr></thead><tbody>${lignesHtml}</tbody></table>
      </div>
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head">
          <h3>Versements liés</h3>
          <span class="ctx-pill">Encaissé : <b>${fmtMoney(Number(totalStr))}</b> · Reste : <b>${fmtMoney(Math.max(resteAPayer,0))}</b></span>
        </div>
        ${tableHtml}
      </div>`;
  },

  inscriptions(inscription){
    const paiements = db.versements.filter(v=>v.inscriptionId===inscription.id);
    const table = paymentsTableHtml(paiements, null);
    const [tableHtml, totalStr] = table.split('__TOTAL__');
    const echeancier = db.echeanciers.find(e=>e.inscriptionId===inscription.id);
    let echeancierHtml = '';
    if(echeancier){
      const lignes = db.lignesEcheance.filter(l=>l.echeancierId===echeancier.id).slice().sort((a,b)=>a.numeroTranche-b.numeroTranche);
      const rows = lignes.map(l=>{
        const reste = Math.max(Number(l.montantDu)-Number(l.montantPaye||0), 0);
        return `<tr>
          <td>${l.libelle}</td><td>${fmtMoney(l.montantDu)}</td><td>${fmtMoney(l.montantPaye||0)}</td><td>${fmtDate(l.dateEcheance)}</td>
          <td><span class="badge ${STATUT_BADGE[l.statut]||''}"><span class="dot"></span>${titleCase(l.statut)}</span></td>
          <td style="text-align:right;">${reste>0 ? `<button class="btn btn-primary btn-sm" onclick="openPayLigneModal('${l.id}')">Payer</button>` : ''}</td>
        </tr>`;
      }).join('');
      echeancierHtml = `<div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Échéancier</h3><button class="btn btn-ghost btn-sm" onclick="goTo('detail','echeanciers', '${echeancier.id}')">Voir le détail</button></div>
        <table class="data"><thead><tr><th>Tranche</th><th>Montant dû</th><th>Payé</th><th>Échéance</th><th>Statut</th><th></th></tr></thead><tbody>${rows}</tbody></table>
      </div>`;
    } else {
      const tarif = inscription.classeId ? wizardTarifForClasse(inscription.classeId) : null;
      const tarifNote = tarif ? `Tarif de base pour cette classe : <b>${fmtMoney(tarif.montant)}</b> en ${tarif.nombreTranches} tranche${tarif.nombreTranches>1?'s':''}.` : `Aucune tarification configurée pour cette classe.`;
      const canTraiter = inscription.statut==='EN_ATTENTE_PAIEMENT';
      echeancierHtml = `<div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Échéancier</h3></div>
        <div class="detail-grid"><div class="kv span2"><div class="v muted">Aucun échéancier généré pour cette inscription. ${tarifNote}</div></div></div>
        ${canTraiter ? `<div style="padding:0 19px 19px;"><button class="btn btn-primary btn-sm" onclick="startCaisseTraitement('${inscription.id}')">Traiter en Caisse (réduction, échéancier, versement) →</button></div>` : ''}
      </div>`;
    }
    const reductions = db.reductionsAppliquees.filter(r=>r.inscriptionId===inscription.id);
    const reductionsHtml = reductions.length ? `<div class="panel" style="margin-top:18px;">
      <div class="panel-head"><h3>Réductions appliquées</h3><button class="btn btn-ghost btn-sm" onclick="openForm('reductionsAppliquees')">+ Ajouter</button></div>
      <table class="data"><thead><tr><th>Réduction</th><th>Montant</th><th>Date</th><th>Justificatif</th></tr></thead><tbody>
        ${reductions.map(r=>{
          const red = findById('reductions', r.reductionId);
          return `<tr><td>${red?red.libelle:'—'}</td><td>${fmtMoney(r.montantCalcule)}</td><td>${fmtDate(r.dateApplication)}</td><td>${r.justificatif||'—'}</td></tr>`;
        }).join('')}
      </tbody></table>
    </div>` : '';
    return `
      <div class="panel" style="margin-top:18px;">
        <div class="panel-head"><h3>Paiements liés à cette inscription</h3><span class="ctx-pill">Total : <b>${fmtMoney(Number(totalStr))}</b></span></div>
        ${tableHtml}
      </div>
      ${echeancierHtml}
      ${reductionsHtml}`;
  },

  documents(inscription){
    const types = inscription.classeId ? typesDocumentForClasse(inscription.classeId) : db.typesDocument;
    const rows = types.map(t=>{
      const doc = db.documentsDossier.find(d=>d.inscriptionId===inscription.id && d.typeDocumentId===t.id);
      const statut = doc ? doc.statut : null;
      const badgeCls = statut ? (STATUT_BADGE[statut]||'') : 'b-danger';
      const badgeText = statut ? titleCase(statut) : 'Manquant';
      return `<tr>
        <td>${t.libelle}${t.obligatoire?' <span class="req">*</span>':''}</td>
        <td class="muted">${t.formatAccepte||'—'}</td>
        <td><span class="badge ${badgeCls}"><span class="dot"></span>${badgeText}</span></td>
        <td style="text-align:right;">
          ${doc ? `<button class="btn btn-ghost btn-sm" onclick="openForm('documentsDossier', '${doc.id}')">Gérer</button>`
                : `<button class="btn btn-primary btn-sm" onclick="quickAddDocument('${inscription.id}', '${t.id}')">+ Ajouter</button>`}
        </td>
      </tr>`;
    }).join('');
    const rowsOrEmpty = rows || `<tr><td colspan="4" style="text-align:center; color:#777;">Aucun type de document configuré pour cette offre et ce niveau.</td></tr>`;
    const missing = missingRequiredDocuments(inscription.id);
    const note = missing.length
      ? `<div class="doc-note warn" style="margin:0 0 16px;">Validation de l'inscription bloquée (RG-06) tant que ces documents obligatoires ne sont pas à l'état « Validé » : ${missing.join(', ')}.</div>`
      : `<div class="doc-note ok" style="margin:0 0 16px;">Tous les documents obligatoires sont validés, l'inscription peut être validée.</div>`;
    return `<div class="panel">
      <div class="panel-head"><h3>Dossier documentaire</h3></div>
      <div style="padding:16px 19px 0;">${note}</div>
      <table class="data"><thead><tr><th>Document</th><th>Format</th><th>Statut</th><th></th></tr></thead><tbody>${rowsOrEmpty}</tbody></table>
    </div>`;
  },

  historique(inscription){
    const rows = db.historiqueStatutInscription
      .filter(h=>h.inscriptionId===inscription.id)
      .slice().sort((a,b)=> new Date(b.dateChangement) - new Date(a.dateChangement));
    const trs = rows.length ? rows.map(h=>`<tr>
        <td>${fmtDate(h.dateChangement)}</td>
        <td>${h.statutPrecedent ? `<span class="badge ${STATUT_BADGE[h.statutPrecedent]||''}"><span class="dot"></span>${titleCase(h.statutPrecedent)}</span>` : `<span class="muted">, (création)</span>`}</td>
        <td>→</td>
        <td><span class="badge ${STATUT_BADGE[h.statutNouveau]||''}"><span class="dot"></span>${titleCase(h.statutNouveau)}</span></td>
        <td class="muted">${h.motif||'—'}</td>
      </tr>`).join('') : `<tr><td colspan="5" style="text-align:center; color:#777;">Aucun changement de statut enregistré.</td></tr>`;
    return `<div class="panel">
      <div class="panel-head"><h3>Historique des statuts</h3><span class="ctx-pill">${rows.length} changement${rows.length>1?'s':''}</span></div>
      <table class="data"><thead><tr><th>Date</th><th>Statut précédent</th><th></th><th>Nouveau statut</th><th>Motif</th></tr></thead><tbody>${trs}</tbody></table>
    </div>`;
  },

  bulletins(inscription){
    const classe = inscription.classeId ? findById('classes', inscription.classeId) : null;
    if(!classe){
      return `<div class="panel"><div class="panel-head"><h3>Bulletins</h3></div><div class="detail-grid"><div class="kv span2"><div class="v muted">Aucune classe affectée à cette inscription, impossible de générer un bulletin.</div></div></div></div>`;
    }
    const niveau = findById('niveaux', classe.niveauId);
    const periodes = db.periodes.filter(p=>p.anneeId===inscription.anneeId).slice().sort((a,b)=>a.ordre-b.ordre);
    const rows = periodes.length ? periodes.map(p=>{
      const existing = db.bulletins.find(b=>b.inscriptionId===inscription.id && b.periodeId===p.id);
      const live = computeBulletinMoyenne(inscription.id, p.id, classe.id);
      const moyText = existing ? existing.moyenne+'/20' : (live!=null ? live.toFixed(2)+'/20 (non généré)' : '—');
      const offered = creditsOffered(p.id, classe.id);
      const creditsText = existing ? `${existing.creditsValides ?? 0} / ${offered}` : '—';
      return `<tr>
        <td>${p.libelle}</td>
        <td>${moyText}</td>
        <td>${creditsText}</td>
        <td>${existing && existing.rang ? existing.rang : '—'}</td>
        <td style="text-align:right; white-space:nowrap;">
          <button class="btn btn-primary btn-sm" onclick="handleGenerateBulletin('${inscription.id}', '${p.id}')">${existing?'Recalculer':'Générer'}</button>
          ${existing ? `<button class="btn btn-ghost btn-sm" onclick="openForm('bulletins', '${existing.id}')">Modifier</button>` : ''}
        </td>
      </tr>`;
    }).join('') : `<tr class="empty-row"><td colspan="5">Aucune période définie pour cette année académique.</td></tr>`;
    const bilan = computeBilanAnnuel(inscription);
    const bilanHtml = bilan
      ? `<div class="doc-note ${bilan.decision==='ADMIS'?'ok':'warn'}" style="margin-top:16px;">
          Bilan annuel : <b>${bilan.moyenneAnnuelle}/20</b>, Mention <b>${bilan.mention}</b> (moyenne de passage ${niveau?niveau.libelle:''} : ${bilan.seuil}/20), <b>${bilan.decision==='ADMIS' ? 'Admis(e) en classe supérieure' : 'Redouble'}</b>
        </div>`
      : `<div class="doc-note" style="margin-top:16px;">Bilan annuel indisponible, génère le bulletin de chaque période pour l'obtenir.</div>`;
    return `<div class="panel">
      <div class="panel-head">
        <h3>Bulletins par période</h3>
        <button class="btn btn-ghost btn-sm" onclick="goTo('releve-notes','inscriptions', '${inscription.id}')">${icon('printer')} Relevé de notes officiel</button>
      </div>
      <table class="data"><thead><tr><th>Période</th><th>Moyenne</th><th>Crédits</th><th>Rang</th><th></th></tr></thead><tbody>${rows}</tbody></table>
    </div>
    ${bilanHtml}
    ${semestreManquantHtml(new Set([inscription.anneeId]))}`;
  }
};

const PAGE_SIZE = 15;

function fieldDisplayValue(field, row){
  const v = row[field.key];
  if(field.type==='multiselect'){
    const arr = Array.isArray(v) ? v : [];
    if(!arr.length) return '<span class="muted">—</span>';
    return arr.map(id=>{
      const t = findById(field.ref, id);
      if(!t) return '';
      const label = typeof field.display==='function' ? field.display(t) : t[field.display];
      return `<span class="badge b-accent">${label}</span>`;
    }).filter(Boolean).join(' ');
  }
  if(field.key==='sexe'){
    if(!v) return '<span class="muted">—</span>';
    return `<span style="color:${SEXE_COLOR[v]||'inherit'}; font-weight:600;">${titleCase(v)}</span>`;
  }
  if(field.type==='image') return v ? `<img src="${v}" alt="" style="max-width:80px; max-height:80px; border-radius:8px; object-fit:contain;">` : '<span class="muted">—</span>';
  if(field.type==='boolean') return v ? '<span class="badge b-success">Oui</span>' : '<span class="badge">Non</span>';
  if(field.type==='select'){
    const cls = STATUT_BADGE[v] ? STATUT_BADGE[v] : '';
    return `<span class="badge ${cls}"><span class="dot"></span>${titleCase(v)}</span>`;
  }
  if(field.type==='fk'){
    const target = findById(field.ref, v);
    if(!target) return '<span class="muted">—</span>';
    const label = typeof field.display==='function' ? field.display(target) : target[field.display];
    if(ENTITIES[field.ref] && field.ref!=='niveaux' && field.ref!=='offres'){
      return `<a class="fk-link" onclick="event.stopPropagation(); goTo('detail','${field.ref}', '${target.id}')">${label}</a>`;
    }
    return label;
  }
  if(field.key.toLowerCase().includes('montant')) return v!==undefined && v!==null && v!=='' ? fmtMoney(v) : '—';
  if(field.type==='date') return fmtDate(v);
  return (v===undefined || v==='' || v===null) ? '<span class="muted">—</span>' : v;
}

function renderDetailPage(key, id){
  const entity = ENTITIES[key];
  const storeKey = entity.storageKey || entity.key;
  const row = findById(storeKey, id);
  if(!row){
    return `<div class="page-head"><h2>Introuvable</h2><p>Cet enregistrement n'existe plus.</p></div>
      <button class="btn" onclick="history.back()">← Retour</button>`;
  }
  const recordKey = key+':'+id;
  if(detailActiveRecord !== recordKey){ detailActiveRecord = recordKey; detailActiveTab = null; }

  const identLabel = row.libelle || row.numero || row.code || row.numeroCarte || (row.nom ? row.prenoms+' '+row.nom : ('#'+row.id));
  const subtitle = row.role ? titleCase(row.role) : entity.label;
  const quickFields = pickQuickFacts(entity, row);
  const quickHtml = quickFields.map(f=>`<div><span class="pf-k">${f.label}</span><span class="pf-v">${fieldDisplayValue(f,row)}</span></div>`).join('');

  const isPersonne = entity.storageKey === 'personnes';
  const tabs = isPersonne
    ? [{id:'profil', label:'Profil', render:(r)=>profileInfoCards(entity,r)}, ...extraTabsFor(key,row)]
    : extraTabsFor(key,row);
  if(tabs.length && (!detailActiveTab || !tabs.find(t=>t.id===detailActiveTab))) detailActiveTab = tabs[0].id;
  if(!tabs.length) detailActiveTab = null;
  const tabsHtml = tabs.map(t=>`<div class="dtab ${t.id===detailActiveTab?'active':''}" onclick="setDetailTab('${t.id}')">${t.label}</div>`).join('');
  const activeTab = tabs.find(t=>t.id===detailActiveTab);

  return `
    <div class="page-head">
      <p style="margin-top:0;">
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="goTo('entity','${key}')">← ${entity.labelPlural}</a>
        <span class="crumb-sep">/</span> <span class="crumb-here">${identLabel}</span>
      </p>
    </div>
    <div class="profile-card">
      <div class="pf-avatar">${initialsOf(identLabel)}</div>
      <div class="pf-id">
        <div class="pf-name">${identLabel}</div>
        <div class="pf-sub">${subtitle}</div>
      </div>
      <div class="pf-facts">${quickHtml}</div>
      <div class="pf-actions">
        ${row.role==='ETUDIANT' ? `
          <button class="btn btn-sm" onclick="goTo('relance','${key}', '${row.id}')">Lettre de relance</button>
          <button class="btn btn-sm" onclick="goTo('attestation','${key}', '${row.id}')">Attestation de solde</button>
        ` : ''}
        ${key==='versements' ? `<button class="btn btn-primary btn-sm" onclick="printRecu('${row.id}')">${icon('printer','icon-sm')} Imprimer le reçu</button>
        <button class="btn btn-sm" onclick="openOrPrintRecu('${row.id}')">Voir le reçu</button>` : ''}
        ${key==='classes' ? `<button class="btn btn-primary btn-sm" onclick="goTo('liste-classe','classes', '${row.id}')">${icon('printer','icon-sm')} Imprimer la liste de classe</button>` : ''}
        ${key==='lignesEcheance' && (Number(row.montantDu)-Number(row.montantPaye||0))>0 ? `<button class="btn btn-primary btn-sm" onclick="openPayLigneModal('${row.id}')">Payer cette échéance</button>` : ''}
        <button class="btn btn-sm" onclick="openForm('${key}', '${row.id}')">Modifier</button>
        <button class="btn btn-danger-ghost btn-sm" onclick="deleteRow('${key}', '${row.id}')">Supprimer</button>
      </div>
    </div>
    ${tabs.length ? `<div class="dtabs">${tabsHtml}</div>
    <div class="dtab-content">${activeTab.render(row)}</div>` : ''}
  `;
}

function pickQuickFacts(entity, row){
  let fields;
  if(row.nom!==undefined && row.prenoms!==undefined){
    fields = entity.fields.filter(f=>f.key!=='nom' && f.key!=='prenoms');
  } else {
    fields = entity.fields.slice(1);
  }
  if(entity.key==='typesDocument') fields = fields.filter(f=>f.key!=='offreIds');
  return fields.slice(0,4);
}

function profileInfoCards(entity, row){
  const fields = entity.fields.filter(f=>!f.virtual);
  const mid = Math.ceil(fields.length/2);
  const left = fields.slice(0,mid), right = fields.slice(mid);
  function card(title, flds){
    if(!flds.length) return '';
    const kv = flds.map(f=>`<div class="kv"><div class="k">${f.label}</div><div class="v">${fieldDisplayValue(f,row)}</div></div>`).join('');
    return `<div class="panel">
      <div class="panel-head"><h3>${title}</h3><button class="btn-icon" onclick="openForm('${entity.key}', '${row.id}')" title="Modifier">${icon('pencil')}</button></div>
      <div class="detail-grid">${kv}</div>
    </div>`;
  }
  const cycleCard = entity.key==='offres' ? `<div class="panel">
      <div class="panel-head"><h3>Cycle(s) &amp; niveaux</h3></div>
      <div class="detail-grid">
        <div class="kv span2"><div class="k">Cycle(s), déduit des niveaux rattachés</div><div class="v">${offreCyclesLabel(row.id)}</div></div>
        <div class="kv span2"><div class="k">Niveaux de la formation</div><div class="v">${offreNiveauxLabel(row.id)}</div></div>
      </div>
    </div>` : '';
  return `<div class="profile-grid">${card('Informations générales', left)}${card('Détails complémentaires', right)}${cycleCard}</div>`;
}

function offreNiveauxLabel(offreId){
  const niveaux = db.niveauOffre.filter(no=>no.offreId===offreId).map(no=>findById('niveaux', no.niveauId)).filter(Boolean);
  return niveaux.length ? niveaux.map(n=>n.libelle).join(', ') : '—';
}

function extraTabsFor(key, row){
  const tabs = [];
  if(key==='typesDocument'){
    tabs.push({id:'offres', label:'Offres de formation', render:DETAIL_SECTIONS.typesDocumentOffres});
  }
  if(key==='cycles'){
    tabs.push({id:'niveaux', label:'Niveaux', render:DETAIL_SECTIONS.cyclesNiveaux});
    tabs.push({id:'tarifications', label:'Tarifications', render:DETAIL_SECTIONS.cyclesTarifications});
  }
  if(key==='niveauOffre'){
    tabs.push({id:'infos', label:'Informations', render:DETAIL_SECTIONS.niveauOffreInfo});
    tabs.push({id:'classes', label:'Classes', render:DETAIL_SECTIONS.niveauOffreClasses});
  }
  if(key==='niveaux'){
    tabs.push({id:'offres', label:'Offres', render:DETAIL_SECTIONS.niveauxOffres});
    tabs.push({id:'classes', label:'Classes', render:DETAIL_SECTIONS.niveauxClasses});
    tabs.push({id:'tarifications', label:'Tarifications', render:DETAIL_SECTIONS.niveauxTarifications});
    tabs.push({id:'ue', label:'Unités d\'enseignement', render:DETAIL_SECTIONS.niveauxUnitesEnseignement});
    tabs.push({id:'matieres', label:'Matières', render:DETAIL_SECTIONS.niveauxMatieres});
    tabs.push({id:'documents', label:'Documents requis', render:DETAIL_SECTIONS.niveauxDocuments});
  }
  if(key==='offres'){
    tabs.push({id:'niveaux', label:'Niveaux', render:DETAIL_SECTIONS.offresNiveaux});
    tabs.push({id:'classes', label:'Classes', render:DETAIL_SECTIONS.offresClasses});
    tabs.push({id:'ue', label:'Unités d\'enseignement', render:DETAIL_SECTIONS.offresUnitesEnseignement});
    tabs.push({id:'matieres', label:'Matières', render:DETAIL_SECTIONS.offresMatieres});
  }
  if(key==='classes') tabs.push({id:'etudiants', label:'Étudiants', render:DETAIL_SECTIONS.classes});
  if(key==='versements') tabs.push({id:'classe-paiements', label:'Classe & paiements', render:DETAIL_SECTIONS.versements});
  if(key==='inscriptions'){
    tabs.push({id:'paiements', label:'Paiements', render:DETAIL_SECTIONS.inscriptions});
    tabs.push({id:'documents', label:'Documents', render:DETAIL_SECTIONS.documents});
    tabs.push({id:'bulletins', label:'Bulletins', render:DETAIL_SECTIONS.bulletins});
    tabs.push({id:'historique', label:'Historique', render:DETAIL_SECTIONS.historique});
  }
  if(key==='unitesEnseignement') tabs.push({id:'ecue', label:'ECUE', render:DETAIL_SECTIONS.unitesEnseignement});
  if(key==='echeanciers') tabs.push({id:'lignes', label:'Lignes & paiements', render:DETAIL_SECTIONS.echeanciers});
  if(row.role==='ETUDIANT'){
    tabs.push({id:'inscriptions-etu', label:'Inscriptions', render:studentInscriptionsTab});
    tabs.push({id:'paiements-etu', label:'Paiements', render:studentPaymentsTab});
    tabs.push({id:'parents-etu', label:'Parents', render:studentParentsTab});
    tabs.push({id:'notes-etu', label:'Notes', render:studentNotesTab});
    tabs.push({id:'bulletins-etu', label:'Bulletins', render:studentBulletinsTab});
  }
  if(row.role==='PARENT'){
    tabs.push({id:'enfants-parent', label:'Enfants', render:parentChildrenTab});
  }
  return tabs;
}

function paymentsTableHtml(list, highlightId){
  const sorted = list.slice().sort((a,b)=> new Date(b.datePaiement) - new Date(a.datePaiement));
  const rowsHtml = sorted.length ? sorted.map(v=>{
    const style = (highlightId && v.id===highlightId) ? ' style="background:var(--accent-soft);"' : '';
    return `<tr${style}>
      <td class="mono">${v.numero}</td>
      <td>${fmtDate(v.datePaiement)}</td>
      <td>${fmtMoney(v.montant)}</td>
      <td><span class="badge b-accent">${titleCase(v.modePaiement)}</span></td>
      <td><span class="badge ${STATUT_BADGE[v.statut]||''}"><span class="dot"></span>${v.statut}</span></td>
      <td style="text-align:right;"><button class="btn-icon" onclick="printRecu('${v.id}')" title="Imprimer le reçu" aria-label="Imprimer le reçu">${icon('printer')}</button></td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="6">Aucun versement enregistré.</td></tr>`;
  const total = list.filter(v=>v.statut==='ENREGISTRE').reduce((s,v)=>s+Number(v.montant),0);
  return `<table class="data"><thead><tr><th>Numéro</th><th>Date</th><th>Montant</th><th>Mode</th><th>Statut</th><th></th></tr></thead><tbody>${rowsHtml}</tbody></table>`
    + `__TOTAL__${total}`;
}

function computeBulletinMoyenne(inscriptionId, periodeId, classeId){
  const matieres = matieresForClasse(classeId, periodeId);
  let sumPond = 0, sumCoef = 0;
  matieres.forEach(m=>{
    const moy = matiereMoyenne(inscriptionId, m.id, periodeId);
    if(moy!=null){ sumPond += moy * Number(m.coefficient); sumCoef += Number(m.coefficient); }
  });
  return sumCoef>0 ? sumPond/sumCoef : null;
}

function matieresForClasse(classeId, periodeId){
  const classe = findById('classes', classeId);
  if(!classe) return [];
  return matieresForOffreNiveauPeriode(classe.offreId, classe.niveauId, periodeId);
}

function matieresForOffreNiveauPeriode(offreId, niveauId, periodeId){
  return db.matieres.filter(m=>
    (m.offreIds||[]).includes(offreId) &&
    (m.niveauIds||[]).includes(niveauId) &&
    (m.periodeIds||[]).includes(periodeId)
  );
}

function matiereMoyenne(inscriptionId, matiereId, periodeId){
  const notes = db.notes.filter(n=>n.inscriptionId===inscriptionId && n.matiereId===matiereId && n.periodeId===periodeId);
  if(!notes.length) return null;
  return notes.reduce((s,n)=>s+Number(n.valeur),0) / notes.length;
}

function creditsOffered(periodeId, classeId){
  return matieresForClasse(classeId, periodeId).reduce((s,m)=>s+Number(m.credits||0),0);
}

function computeBilanAnnuel(inscription){
  if(!inscription) return null;
  const bulletins = db.bulletins.filter(b=>b.inscriptionId===inscription.id);
  if(!bulletins.length) return null;
  const moyenneAnnuelle = bulletins.reduce((s,b)=>s+Number(b.moyenne),0) / bulletins.length;
  const classe = inscription.classeId ? findById('classes', inscription.classeId) : null;
  const niveau = classe ? findById('niveaux', classe.niveauId) : null;
  const seuil = niveau ? Number(niveau.moyennePassage||10) : 10;
  return {moyenneAnnuelle: Math.round(moyenneAnnuelle*100)/100, seuil, decision: moyenneAnnuelle>=seuil?'ADMIS':'REDOUBLE', mention: computeMention(moyenneAnnuelle), bulletins};
}

function computeMention(moyenne){
  if(moyenne==null) return null;
  if(moyenne<10) return 'Ajourné(e)';
  if(moyenne<12) return 'Passable';
  if(moyenne<14) return 'Assez Bien';
  if(moyenne<16) return 'Bien';
  return 'Très Bien';
}

function semestreManquantHtml(anneeIds){
  let out = '';
  Array.from(anneeIds).forEach(aid => {
    const ps = db.periodes.filter(p => p.anneeId === aid);
    const annee = findById('annees', aid);
    if(annee && ps.length === 1 && Number(ps[0].ordre) === 1){
      out += `<div class="doc-note warn" style="margin:12px 20px; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap;">
        <span>Seul le <b>${ps[0].libelle}</b> existe pour l'année <b>${annee.libelle}</b> : une année compte normalement deux semestres.</span>
        <button class="btn btn-primary btn-sm" onclick="createSecondSemestre('${aid}')">Créer le 2e Semestre</button></div>`;
    }
  });
  return out;
}

function studentInscriptionsTab(etu){
  const inscriptions = db.inscriptions.filter(i=>i.etudiantId===etu.id);
  const rowsHtml = inscriptions.length ? inscriptions.map(i=>{
    const classe = i.classeId ? findById('classes', i.classeId) : null;
    const annee = findById('annees', i.anneeId);
    return `<tr>
      <td class="mono">${i.numero}</td>
      <td>${classe ? `<a class="fk-link" onclick="goTo('detail','classes', '${classe.id}')">${classe.libelle}</a>` : '<span class="muted">—</span>'}</td>
      <td>${annee ? annee.libelle : '—'}</td>
      <td><span class="badge ${STATUT_BADGE[i.statut]||''}"><span class="dot"></span>${titleCase(i.statut)}</span></td>
      <td style="text-align:right;"><button class="btn btn-ghost btn-sm" onclick="goTo('detail','inscriptions', '${i.id}')">Voir</button></td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="5">Aucune inscription enregistrée.</td></tr>`;
  return `<div class="panel">
    <div class="panel-head"><h3>Inscriptions (${inscriptions.length})</h3></div>
    <table class="data"><thead><tr><th>N° inscription</th><th>Classe</th><th>Année</th><th>Statut</th><th></th></tr></thead><tbody>${rowsHtml}</tbody></table>
  </div>`;
}

function studentPaymentsTab(etu){
  const inscriptionIds = db.inscriptions.filter(i=>i.etudiantId===etu.id).map(i=>i.id);
  const paiements = db.versements.filter(v=>inscriptionIds.includes(v.inscriptionId));
  const table = paymentsTableHtml(paiements, null);
  const [tableHtml, totalStr] = table.split('__TOTAL__');

  const inscriptions = db.inscriptions.filter(i=>i.etudiantId===etu.id);
  const annee = currentAnnee();
  const inscription = inscriptions.find(i=>annee && i.anneeId===annee.id) || inscriptions[inscriptions.length-1];

  let planHtml = '';
  if(inscription){
    const row = computeSoldeRow(inscription);
    const echeancier = db.echeanciers.find(e=>e.inscriptionId===inscription.id);
    const lignes = echeancier ? db.lignesEcheance.filter(l=>l.echeancierId===echeancier.id).slice().sort((a,b)=>a.numeroTranche-b.numeroTranche) : [];
    const nbPayees = lignes.filter(l=>l.statut==='PAYE').length;
    const STATUT_DOT = {
      PAYE:{fg:'var(--success)', ic:'check-circle'},
      PARTIEL:{fg:'var(--warn)', ic:'clock'},
      EN_RETARD:{fg:'var(--danger)', ic:'alert-triangle'},
      ATTENDU:{fg:'var(--ink-faint)', ic:'circle'}
    };

    let allPriorPaid = true;
    const rows = lignes.map(l=>{
      const paye = Number(l.montantPaye||0);
      const reste = Math.max(Number(l.montantDu) - paye, 0);
      const d = STATUT_DOT[l.statut] || STATUT_DOT.ATTENDU;
      let sub;
      if(l.statut==='PAYE') sub = `Réglée · échéance ${fmtDate(l.dateEcheance)}`;
      else if(l.statut==='PARTIEL') sub = `${fmtMoney(paye)} / ${fmtMoney(l.montantDu)} versés`;
      else if(l.statut==='EN_RETARD') sub = `En retard depuis le ${fmtDate(l.dateEcheance)}`;
      else sub = `Échéance le ${fmtDate(l.dateEcheance)}`;
      const payInputId = `pay-inline-${l.id}`;
      const canPay = reste>0 && allPriorPaid;
      const blocked = reste>0 && !allPriorPaid;
      if(l.statut!=='PAYE') allPriorPaid = false;
      let rightHtml;
      if(canPay){
        rightHtml = `<div class="t-pay-row">
            <input type="number" class="t-pay-input tnum" id="${payInputId}" value="${reste}" min="1" max="${reste}" title="Montant à verser">
            <button class="btn btn-primary btn-sm" onclick="openPayLigneModal('${l.id}', document.getElementById('${payInputId}').value)">Verser</button>
          </div>`;
      } else if(blocked){
        rightHtml = `<div class="t-locked">${icon('lock','icon-sm')} après la tranche précédente</div>`;
      } else {
        rightHtml = `<div class="t-amount tnum">${fmtMoney(l.montantDu)}</div>`;
      }
      return `<div class="tranche-item">
        <div class="t-dot" style="--fg:${d.fg};">${icon(d.ic)}</div>
        <div class="t-body">
          <div class="t-title">${l.libelle}</div>
          <div class="t-sub" style="${l.statut==='PARTIEL'?'color:var(--warn);':l.statut==='EN_RETARD'?'color:var(--danger);':''}">${sub}</div>
        </div>
        <div class="t-right">${rightHtml}</div>
      </div>`;
    }).join('');

    planHtml = `<div class="panel" style="margin-bottom:14px;">
      <div class="panel-head">
        <h3>Plan de paiement</h3>
        ${lignes.length ? `<span class="ctx-pill">${nbPayees} / ${lignes.length} tranche${lignes.length>1?'s':''} réglée${nbPayees>1?'s':''}</span>` : ''}
      </div>
      <div class="plan-paiement">
        <div class="plan-amounts">
          <div class="item"><div class="k">Montant dû</div><div class="v tnum">${fmtMoney(row.scolarite)}</div></div>
          <div class="item"><div class="k">Déjà payé</div><div class="v tnum" style="color:var(--success);">${fmtMoney(row.dejaPaye)}</div></div>
          <div class="item"><div class="k">Solde restant</div><div class="v tnum" style="color:${row.solde>0?'var(--danger)':'var(--success)'};">${fmtMoney(Math.max(row.solde,0))}</div></div>
        </div>
        <div class="plan-progress"><div class="fill" style="width:${Math.max(0,Math.min(row.taux,100)).toFixed(1)}%; background:${tauxFill(row.taux)};"></div></div>
        ${lignes.length ? `<div class="tranche-list">${rows}</div>` : `<p style="font-size:12.5px; color:var(--ink-faint);">Aucun échéancier généré pour cette inscription.</p>`}
      </div>
    </div>`;
  }

  return `${planHtml}<div class="panel">
    <div class="panel-head">
      <h3>Paiements</h3>
      <div class="toolbar">
        <span class="ctx-pill">Total encaissé : <b>${fmtMoney(Number(totalStr))}</b></span>
        ${inscription ? `<button class="btn btn-primary btn-sm" onclick="openQuickVersement('${inscription.id}')">${icon('plus','icon-sm')} Nouveau versement</button>` : ''}
      </div>
    </div>
    ${tableHtml}
  </div>`;
}

function tauxFill(t){ if(t>=90) return 'var(--success-f)'; if(t>=50) return 'var(--warn-f)'; return 'var(--danger-f)'; }

function studentParentsTab(etu){
  const liens = db.liensParentaux.filter(l=>l.etudiantId===etu.id);
  const rows = liens.length ? liens.map(l=>{
    const parent = findById('personnes', l.parentId);
    if(!parent) return '';
    return `<tr>
      <td><a class="fk-link" onclick="goTo('detail','parents', '${parent.id}')">${parent.prenoms} ${parent.nom}</a></td>
      <td>${titleCase(l.typeLien)}</td>
      <td>${l.estPayeur ? '<span class="badge b-success"><span class="dot"></span>Payeur</span>' : ''}</td>
      <td>${l.estContactUrgence ? '<span class="badge b-warn"><span class="dot"></span>Urgence</span>' : ''}</td>
      <td>${l.ordrePriorite ?? '—'}</td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="5">Aucun parent rattaché.</td></tr>`;
  return `<div class="panel">
    <div class="panel-head"><h3>Parents / tuteurs (${liens.length})</h3><button class="btn btn-ghost btn-sm" onclick="openForm('liensParentaux')">+ Ajouter</button></div>
    <table class="data"><thead><tr><th>Parent</th><th>Type de lien</th><th>Payeur</th><th>Contact urgence</th><th>Priorité</th></tr></thead><tbody>${rows}</tbody></table>
  </div>`;
}

function studentNotesTab(etu){
  const inscIds = db.inscriptions.filter(i=>i.etudiantId===etu.id).map(i=>i.id);
  const allNotes = db.notes.filter(n=>inscIds.includes(n.inscriptionId)).slice().sort((a,b)=>new Date(b.dateEvaluation)-new Date(a.dateEvaluation));

  const periodeIds = new Set(allNotes.map(n=>n.periodeId));
  const anneesEtu = new Set(db.inscriptions.filter(i=>i.etudiantId===etu.id).map(i=>i.anneeId));
  const anneeDebut = p => (findById('annees', p.anneeId)||{}).dateDebut || '';
  const periodes = db.periodes.filter(p=>periodeIds.has(p.id) || anneesEtu.has(p.anneeId)).slice().sort((a,b)=>anneeDebut(a).localeCompare(anneeDebut(b)) || (a.ordre-b.ordre));
  if(periodes.length && (notesFilterPeriodeId===null || !periodes.some(p=>p.id===notesFilterPeriodeId))){
    notesFilterPeriodeId = (periodes.find(p=>periodeIds.has(p.id)) || periodes[0]).id;
  }
  const periodeTabsHtml = periodes.length ? `<div class="periode-tabs">${periodes.map(p=>`
    <div class="p-tab ${notesFilterPeriodeId===p.id?'active':''}" onclick="setNotesFilterPeriode('${p.id}')">${p.libelle}</div>`).join('')}</div>` : '';

  const notesPeriode = periodes.length ? allNotes.filter(n=>n.periodeId===notesFilterPeriodeId) : allNotes;

  const activePeriode = periodes.find(p=>p.id===notesFilterPeriodeId);
  const inscForPeriode = activePeriode ? db.inscriptions.find(i=>i.etudiantId===etu.id && i.anneeId===activePeriode.anneeId) : null;
  let bulletinBarHtml = '';
  if(activePeriode && inscForPeriode){
    const classePeriode = inscForPeriode.classeId ? findById('classes', inscForPeriode.classeId) : null;
    const existing = db.bulletins.find(b=>b.inscriptionId===inscForPeriode.id && b.periodeId===activePeriode.id);
    const live = classePeriode ? computeBulletinMoyenne(inscForPeriode.id, activePeriode.id, classePeriode.id) : null;
    const moyenne = existing ? existing.moyenne : live;
    const mention = computeMention(moyenne);
    bulletinBarHtml = moyenne!=null ? `
      <div class="bulletin-import-bar filled">
        <div class="bi-file">${icon('calculator')}<span>Moyenne ${activePeriode.libelle} : <b>${Number(moyenne).toFixed(2)}/20</b>${mention ? ' · '+mention : ''}</span>${!existing ? `<span class="bi-date">non généré</span>` : ''}</div>
        <div class="bi-actions">
          <button class="btn btn-primary btn-sm" onclick="setDetailTab('bulletins-etu')">${existing ? 'Voir le bulletin' : 'Générer le bulletin'}</button>
        </div>
      </div>` : `
      <div class="bulletin-import-bar">
        <div class="bi-empty">${icon('calculator')}<span>Pas encore assez de notes pour calculer la moyenne du ${activePeriode.libelle}</span></div>
        <div class="bi-actions"><button class="btn btn-sm" onclick="openForm('notes')">+ Ajouter une note</button></div>
      </div>`;
  }

  const byMatiere = {};
  notesPeriode.forEach(n=>{
    if(!byMatiere[n.matiereId]) byMatiere[n.matiereId] = [];
    byMatiere[n.matiereId].push(n);
  });
  const matiereCards = Object.keys(byMatiere).map(mid=>{
    const m = findById('matieres', mid);
    const ns = byMatiere[mid];
    const avg = ns.reduce((s,n)=>s+Number(n.valeur),0) / ns.length;
    return {id:mid, label:m ? m.libelle : '—', avg, count:ns.length};
  }).sort((a,b)=>a.label.localeCompare(b.label));

  const activeId = notesFilterMatiereId;
  const cardsHtml = `
    <div class="matiere-card ${activeId===null?'active':''}" onclick="setNotesFilterMatiere(null)">
      <div class="m-label">Toutes</div>
      <div class="m-avg">${notesPeriode.length}<span> note${notesPeriode.length>1?'s':''}</span></div>
      <div class="m-count">${matiereCards.length} matière${matiereCards.length>1?'s':''}</div>
    </div>
    ${matiereCards.map(m=>`
    <div class="matiere-card ${activeId===m.id?'active':''}" onclick="setNotesFilterMatiere('${m.id}')">
      <div class="m-label">${m.label}</div>
      <div class="m-avg">${m.avg.toFixed(1)}<span>/20</span></div>
      <div class="m-count">${m.count} note${m.count>1?'s':''}</div>
    </div>`).join('')}
  `;

  const notes = activeId===null ? notesPeriode : notesPeriode.filter(n=>n.matiereId===activeId);
  const rows = notes.length ? notes.map(n=>{
    const m = findById('matieres', n.matiereId);
    return `<tr>
      <td>${m ? m.libelle : '—'}</td>
      <td>${titleCase(n.typeEvaluation)}</td>
      <td><b>${n.valeur}/20</b></td>
      <td>${fmtDate(n.dateEvaluation)}</td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="4">Aucune note enregistrée${activeId!==null ? ' pour cette matière' : ''}.</td></tr>`;
  return `<div class="panel">
    <div class="panel-head"><h3>Notes (${allNotes.length})</h3><button class="btn btn-ghost btn-sm" onclick="openForm('notes')">+ Ajouter</button></div>
    ${periodeTabsHtml}
    ${semestreManquantHtml(anneesEtu)}
    ${bulletinBarHtml}
    ${matiereCards.length ? `<div class="matiere-row">${cardsHtml}</div>` : ''}
    <table class="data"><thead><tr><th>Matière</th><th>Type</th><th>Note</th><th>Date</th></tr></thead><tbody>${rows}</tbody></table>
  </div>`;
}

function setNotesFilterPeriode(id){ notesFilterPeriodeId = id; notesFilterMatiereId = null; render(); }

function setDetailTab(id){ detailActiveTab = id; render(); }

function setNotesFilterMatiere(id){ notesFilterMatiereId = id || null; render(); }

function studentBulletinsTab(etu){
  const inscriptions = db.inscriptions.filter(i=>i.etudiantId===etu.id);
  const annee = currentAnnee();
  const inscription = inscriptions.find(i=>annee && i.anneeId===annee.id) || inscriptions[inscriptions.length-1];
  if(!inscription){
    return `<div class="panel"><div class="panel-head"><h3>Bulletins</h3></div>
      <div class="detail-grid"><div class="kv span2"><div class="v muted">Aucune inscription trouvée pour cet étudiant.</div></div></div>
    </div>`;
  }
  return DETAIL_SECTIONS.bulletins(inscription);
}

function parentChildrenTab(parent){
  const liens = db.liensParentaux.filter(l=>l.parentId===parent.id);
  const rows = liens.length ? liens.map(l=>{
    const etu = findById('personnes', l.etudiantId);
    if(!etu) return '';
    return `<tr>
      <td><a class="fk-link" onclick="goTo('detail','etudiants', '${etu.id}')">${etu.prenoms} ${etu.nom}</a></td>
      <td>${titleCase(l.typeLien)}</td>
      <td>${l.estPayeur ? '<span class="badge b-success"><span class="dot"></span>Payeur</span>' : ''}</td>
      <td>${l.estContactUrgence ? '<span class="badge b-warn"><span class="dot"></span>Urgence</span>' : ''}</td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="4">Aucun enfant rattaché.</td></tr>`;
  return `<div class="panel">
    <div class="panel-head"><h3>Enfants (${liens.length})</h3><button class="btn btn-ghost btn-sm" onclick="openForm('liensParentaux')">+ Ajouter</button></div>
    <table class="data"><thead><tr><th>Étudiant</th><th>Type de lien</th><th>Payeur</th><th>Contact urgence</th></tr></thead><tbody>${rows}</tbody></table>
  </div>`;
}

function initialsOf(text){
  const words = (text||'').toString().trim().split(/\s+/).filter(Boolean);
  if(words.length===0) return '?';
  if(words.length===1) return words[0].slice(0,2).toUpperCase();
  return (words[0][0]+words[1][0]).toUpperCase();
}

function renderGuidePage(){
  const sections = [
    {id:'vue', title:"Vue d'ensemble", body:`
      <p>L'application est organisée en modules dans le menu de gauche. Voici l'ordre logique pour démarrer, du paramétrage initial au suivi quotidien :</p>
      <ol class="doc-list">
        <li><b>Paramètres</b>, renseigne d'abord la fiche École et crée l'année académique en cours.</li>
        <li><b>Offre de formation</b>, cycles, niveaux, filières (offres) et classes.</li>
        <li><b>Finance</b>, types de frais, tarifications par niveau/année.</li>
        <li><b>Personnes</b>, étudiants, parents, personnel.</li>
        <li><b>Inscription</b>, inscris un étudiant dans une classe.</li>
        <li><b>Caisse</b>, traite le dossier (réduction, échéancier, premier versement).</li>
        <li><b>Pédagogie</b>, unités d'enseignement (UE), matières (ECUE), notes, relevés.</li>
      </ol>
      <p>Les sections ci-dessous détaillent chaque étape. Le sommaire en haut permet d'y aller directement.</p>`},
    {id:'etudiant', title:'Créer un étudiant, de A à Z', body:`
      <p>Voici le circuit complet, du dossier vide jusqu'à l'étudiant inscrit et à jour de paiement.</p>
      <ol class="doc-list">
        <li><b>Vérifie les pré-requis</b> : la classe visée doit déjà exister (<i>Offre de formation → Classes</i>) et une tarification doit être définie pour son niveau et l'année en cours (<i>Finance → Tarifications</i>), sinon l'échéancier ne pourra pas être généré plus tard.</li>
        <li><b>Crée la fiche de l'étudiant</b> : <i>Personnes → Étudiants → + Nouveau</i>. Renseigne nom, prénoms, sexe, date et lieu de naissance, nationalité, téléphone, e-mail. Le matricule (ex. ET-2025-0001) est généré automatiquement.</li>
        <li><b>Rattache un parent</b> (facultatif mais conseillé) : depuis la fiche de l'étudiant, onglet <i>Parents</i>, ajoute ou lie un parent existant, précise s'il est le payeur et/ou le contact d'urgence.</li>
        <li><b>Inscris-le dans une classe</b> : bouton <i>« Inscrire un étudiant »</i> (en haut de la liste Inscriptions, ou depuis le tableau de bord). Le parcours guidé te fait choisir l'étudiant (ou le créer à la volée), puis la classe. Une fois validé, le statut de l'inscription est <b>« En attente de paiement »</b>, l'étudiant apparaît alors dans la pastille orange de <i>Caisse → Inscriptions en attente</i>.</li>
        <li><b>Traite le dossier en Caisse</b> : ouvre <i>Caisse → Inscriptions en attente</i>, clique <i>« Traiter »</i> sur la ligne de l'étudiant. Ce parcours en une page permet d'appliquer une réduction si besoin, de générer l'échéancier (calculé à partir de la tarification), puis d'enregistrer le premier versement.</li>
        <li><b>Le statut passe à « Validée »</b> automatiquement dès que le dossier est traité, l'étudiant n'apparaît plus dans les inscriptions en attente.</li>
        <li><b>Le reçu s'imprime tout seul</b> après l'enregistrement du versement (avec code-barres, montant en lettres, et le détail des frais).</li>
        <li><b>Pour un versement suivant</b> : depuis la fiche de l'étudiant (onglet <i>Paiements</i>) ou depuis <i>Finance → Versements → + Nouveau</i>, cherche l'étudiant, le montant se pré-remplit avec la prochaine échéance, il ne reste qu'à confirmer.</li>
      </ol>`},
    {id:'parametres', title:'Paramètres, à faire en premier', body:`
      <ol class="doc-list">
        <li><b>École</b> : code, sigle, libellé, ville, adresse, téléphone, fax, site web, e-mail, agrément ministériel, et les comptes bancaires (versement et virement), toutes ces informations apparaissent sur les documents imprimés (reçus, relevés, attestations, relances).</li>
        <li><b>Années académiques</b> : crée l'année en cours (ex. 2025-2026) et marque-la comme <i>courante</i>, c'est elle qui détermine, entre autres, quels semestres apparaissent dans les listes de sélection.</li>
        <li><b>Utilisateurs et Rôles</b> : crée les comptes du personnel et les rôles qui encadrent leurs droits d'accès.</li>
      </ol>`},
    {id:'offre', title:'Offre de formation', body:`
      <p>La hiérarchie complète, du plus large au plus précis :</p>
      <p style="text-align:center; font-weight:700; margin:10px 0;">Cycle → Niveau → Offre (filière) → Classe</p>
      <ol class="doc-list">
        <li><b>Cycle</b> (ex. « Premier cycle, Licence/BTS ») : un simple regroupement administratif des niveaux.</li>
        <li><b>Niveau</b> (ex. « 1ère année ») : rattaché à un cycle, avec sa moyenne de passage.</li>
        <li><b>Offre</b> (ex. « Licence Marketing Management ») : la filière, avec son diplôme préparé et sa durée.</li>
        <li><b>Classe</b> (ex. « Licence 1 Marketing Management A ») : rattache une offre, un niveau et une année académique précise, c'est elle qu'on choisit à l'inscription.</li>
      </ol>`},
    {id:'personnes', title:'Personnes', body:`
      <p>Regroupe trois types de fiches, toutes basées sur les mêmes informations (nom, sexe, naissance, contact) :</p>
      <ul class="doc-list">
        <li><b>Étudiants</b>, matricule généré automatiquement, historique complet (inscriptions, paiements, notes, bulletins) accessible depuis leur fiche.</li>
        <li><b>Parents</b>, profession, employeur ; reliés à un ou plusieurs étudiants via l'onglet Parents de la fiche étudiant.</li>
        <li><b>Personnel administratif</b>, fonction, service (secrétariat, comptabilité, direction…).</li>
      </ul>`},
    {id:'inscription', title:'Inscription', body:`
      <p>Le bouton <b>« Inscrire un étudiant »</b> lance un parcours guidé : choix de l'étudiant (existant ou nouveau), puis de la classe, puis validation.</p>
      <p>Une inscription passe par les statuts :</p>
      <p style="text-align:center; font-weight:700; margin:10px 0;">En attente de paiement → Validée <span style="color:var(--ink-faint); font-weight:400;">(ou Annulée)</span></p>
      <p>Le reçu d'inscription (PDF, avec code-barres, récapitulant tous les frais) est disponible une fois le dossier traité en Caisse.</p>`},
    {id:'finance', title:'Finance', body:`
      <p>C'est ici qu'on <b>paramètre</b> les règles et qu'on <b>consulte l'historique</b>, le traitement au jour le jour se fait dans Caisse.</p>
      <p><b>Paramètres :</b></p>
      <ul class="doc-list">
        <li><b>Types de frais</b>, ex. Frais de scolarité, Frais d'inscription, Frais annexes.</li>
        <li><b>Tarifications</b>, le montant de chaque type de frais, par niveau et par année académique. C'est ce qui alimente le calcul de l'échéancier.</li>
        <li><b>Tranches</b>, le calendrier des échéances (ex. Octobre, Novembre, Décembre…).</li>
        <li><b>Réductions</b>, les barèmes disponibles (bourse, fratrie…), appliqués ensuite au cas par cas sur un dossier.</li>
      </ul>
      <p><b>Historique :</b> Réductions appliquées, Versements, Reçus.</p>
      <p>Pour ajouter un versement : <i>+ Nouveau</i>, cherche l'étudiant, le montant se pré-remplit avec la prochaine échéance, un reçu s'ouvre automatiquement après l'enregistrement.</p>`},
    {id:'caisse', title:'Caisse', body:`
      <p>Le poste de travail quotidien du comptable, elle n'a aucune fiche à elle, uniquement des rapports construits à partir des données de Finance :</p>
      <ul class="doc-list">
        <li><b>Inscriptions en attente</b>, les dossiers à traiter (bouton « Traiter » : réduction, échéancier, premier versement). Le nombre en attente s'affiche en badge orange, ici et sur la cloche 🔔 du haut.</li>
        <li><b>États par classe</b>, le suivi des soldes (réduction, scolarité, déjà payé, taux, reste à payer), filtré sur une seule classe.</li>
        <li><b>Suivi des soldes</b>, la même chose, mais toutes classes confondues (ou filtrable).</li>
        <li><b>État des relances</b>, génère les lettres de rappel de paiement, une par une ou groupées pour tous les étudiants en retard.</li>
        <li><b>État des échéances</b>, les prochaines dates limites de paiement à venir, tous étudiants confondus.</li>
      </ul>`},
    {id:'pedagogie', title:'Pédagogie, Unités d\'enseignement (UE) et matières (ECUE)', body:`
      <p>Une <b>UE</b> (Unité d'Enseignement) regroupe plusieurs <b>ECUE</b> (matières). Le calcul se fait en pondérant systématiquement par les crédits, à chaque étage :</p>
      <ul class="doc-list">
        <li>Moyenne d'une UE = moyenne de ses ECUE, pondérée par les crédits de chaque ECUE.</li>
        <li>Moyenne d'un semestre = moyenne de ses UE, pondérée par les crédits de chaque UE.</li>
        <li>Moyenne annuelle = moyenne des deux semestres, pondérée par leurs crédits respectifs.</li>
      </ul>
      <p><b>Étapes pour mettre en place un semestre :</b></p>
      <ol class="doc-list">
        <li><i>Pédagogie → Unités d'enseignement → + Nouveau</i> : intitulé, offre, niveau, période (semestre), le code (UE1, UE2…) est généré automatiquement si tu le laisses vide. Tu peux rattacher des matières existantes directement dans ce même formulaire.</li>
        <li><i>Pédagogie → Matières (ECUE) → + Nouveau</i> (ou depuis la fiche d'une UE, bouton « Ajouter une matière ») : chaque matière a son coefficient et ses propres crédits, et doit être rattachée à une UE.</li>
        <li><i>Pédagogie → Notes</i> : saisis la note de chaque étudiant, matière par matière, pour la période concernée.</li>
        <li>Le <b>Relevé de notes</b> (accessible depuis la fiche de l'étudiant) calcule alors tout automatiquement : moyennes UE et semestre, crédits obtenus, moyenne annuelle, mention et décision du jury (Admis / Admis avec crédits / Ajourné).</li>
      </ol>
      <p><b>Bulletins</b> reste un système séparé, par période, pour un suivi plus classique classe par classe.</p>`}
  ];
  const toc = sections.map(s=>`<a class="guide-toc-link" onclick="document.getElementById('guide-${s.id}').scrollIntoView({behavior:'smooth', block:'start'})">${s.title}</a>`).join('');
  const body = sections.map(s=>`
    <div class="panel" id="guide-${s.id}" style="margin-bottom:16px; scroll-margin-top:16px;">
      <div class="panel-head"><h3>${s.title}</h3></div>
      <div style="padding:16px 18px; font-size:14px; line-height:1.65; color:var(--ink);">${s.body}</div>
    </div>`).join('');
  return `
    <div class="page-head">
      <h2>Mode d'emploi</h2>
      <p>Un guide complet, étape par étape, pour retrouver comment fonctionne chaque module de l'application.</p>
    </div>
    <div class="guide-toc">${toc}</div>
    ${body}
  `;
}

function renderModulePage(modKey){
  const mod = MODULES[modKey];
  const groupCards = (mod.groups||[]).map(g=>{
    const count = g.entities.reduce((s,ek)=>s+entityRows(ENTITIES[ek]).length,0);
    return `<div class="module-card" onclick="goTo('group','${modKey}','${g.key}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon(g.icon)}</div>
      <h4>${g.label}</h4>
      <p>${count} enregistrement${count>1?'s':''} · ${g.entities.length} rubriques</p>
    </div>`;
  }).join('');
  const entityCards = (mod.entities||[]).map(ek=>{
    const e = ENTITIES[ek];
    const rows = entityRows(e);
    return `<div class="module-card" onclick="goTo('entity','${ek}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon(e.icon)}</div>
      <h4>${e.labelPlural}</h4>
      <p>${rows.length} enregistrement${rows.length>1?'s':''}</p>
    </div>`;
  }).join('');
  const reportCards = (mod.reports||[]).map(rk=>{
    const r = REPORTS[rk];
    return `<div class="module-card" onclick="goTo('report','${rk}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon(r.icon)}</div>
      <h4>${r.label}</h4>
      <p>Rapport</p>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <h2>${mod.label}</h2>
      <p>${mod.description}</p>
    </div>
    <div class="module-grid">${groupCards}${entityCards}${reportCards}</div>
  `;
}

function renderGroupPage(modKey, groupKey){
  const mod = MODULES[modKey];
  const group = (mod.groups||[]).find(g=>g.key===groupKey);
  if(!group) return renderModulePage(modKey);
  const cardsHtml = group.entities.map(ek=>{
    const e = ENTITIES[ek];
    const rows = entityRows(e);
    return `<div class="module-card" onclick="goTo('entity','${ek}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon(e.icon)}</div>
      <h4>${e.labelPlural}</h4>
      <p>${rows.length} enregistrement${rows.length>1?'s':''}</p>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;"><a style="cursor:pointer; color:var(--ink-soft);" onclick="goTo('module','${modKey}')">← ${mod.label.replace(/^\d+\.\s*/,'')}</a></p>
      <h2>${icon(group.icon)} ${group.label}</h2>
      <p>${group.description||''}</p>
    </div>
    <div class="module-grid">${cardsHtml}</div>
  `;
}

function renderReportPage(key){
  if(key==='soldes') return renderSoldesReport();
  if(key==='relances') return renderRelancesGlobales();
  if(key==='echeancesDatees') return renderEcheancesDateesReport();
  if(key==='caissePending') return renderCaissePendingReport();
  if(key==='caisseEtats') return renderCaisseEtatsReport();
  return '';
}

function renderSoldesReport(){
  const classesEcole = db.classes.filter(c=>c.ecoleId===currentEcoleId);
  const classeOptions = classesEcole.map(c=>`<option value="${c.id}" ${String(soldesFilterClasse)===String(c.id)?'selected':''}>${c.libelle}</option>`).join('');
  const classesToShow = soldesFilterClasse ? classesEcole.filter(c=>String(c.id)===String(soldesFilterClasse)) : classesEcole;

  let allRows = [];
  classesToShow.forEach(classe=>{
    const inscriptions = db.inscriptions.filter(i=>i.classeId===classe.id && i.statut==='VALIDEE');
    inscriptions.map(i=>computeSoldeRow(i, soldesFilterDateDebut||null, soldesFilterDateFin||null)).filter(r=>r.etu).forEach(r=>allRows.push({...r, classe, niveau:findById('niveaux', classe.niveauId)}));
  });
  allRows.sort((a,b)=> (a.classe.libelle.localeCompare(b.classe.libelle)) || a.etu.nom.localeCompare(b.etu.nom));

  const grandReduction = allRows.reduce((s,r)=>s+r.reduction,0);
  const grandScolarite = allRows.reduce((s,r)=>s+r.scolarite,0);
  const grandPaye = allRows.reduce((s,r)=>s+r.dejaPaye,0);
  const grandSolde = allRows.reduce((s,r)=>s+r.solde,0);
  const grandTaux = grandScolarite>0 ? (grandPaye/grandScolarite*100) : 0;

  const rowsHtml = allRows.length ? allRows.map((r,idx)=>`<tr>
      <td class="mono">${idx+1}</td>
      <td><a class="fk-link" onclick="goTo('detail','etudiants', '${r.etu.id}')">${r.etu.nom}</a></td>
      <td>${r.etu.prenoms}</td>
      <td>${r.niveau?r.niveau.libelle:'—'}</td>
      <td><a class="fk-link" onclick="goTo('detail','classes', '${r.classe.id}')">${r.classe.libelle}</a></td>
      <td>${fmtMoney(r.reduction)}</td>
      <td>${fmtMoney(r.scolarite)}</td>
      <td>${fmtMoney(r.dejaPaye)}</td>
      <td><b style="color:${tauxColor(r.taux)};">${r.taux.toFixed(1)} %</b></td>
      <td>${fmtMoney(Math.max(r.solde,0))}</td>
    </tr>`).join('') : `<tr class="empty-row"><td colspan="10">Aucun étudiant inscrit et validé pour cette sélection.</td></tr>`;

  return `
    <div class="page-head no-print">
      <h2>Suivi global des soldes</h2>
      <p>État consolidé des soldes de scolarité, réduction accordée, montant net, déjà payé, taux de recouvrement et reste à payer.</p>
    </div>
    <div class="kpi-row no-print">
      <div class="kpi-card"><div class="lbl">Étudiants suivis</div><div class="val tnum">${allRows.length}</div></div>
      <div class="kpi-card"><div class="lbl">Scolarité totale (net)</div><div class="val tnum">${fmtMoney(grandScolarite)}</div></div>
      <div class="kpi-card"><div class="lbl">Total encaissé</div><div class="val tnum">${fmtMoney(grandPaye)}</div></div>
      <div class="kpi-card"><div class="lbl">Solde restant dû</div><div class="val tnum">${fmtMoney(grandSolde)}</div></div>
    </div>
    <div class="panel-head no-print" style="padding:0 0 14px; border:none; background:none;">
      <div class="toolbar">
        <select onchange="setSoldesFilter(this.value)">
          <option value="">Toutes les classes</option>
          ${classeOptions}
        </select>
        <span style="display:flex; align-items:center; gap:6px; font-size:13px; color:var(--ink-soft);">Versements du
          <input type="date" value="${soldesFilterDateDebut}" onchange="setSoldesFilterDateDebut(this.value)">
          au
          <input type="date" value="${soldesFilterDateFin}" onchange="setSoldesFilterDateFin(this.value)">
        </span>
        <span class="ctx-pill">Taux global : <b style="color:${tauxColor(grandTaux)};">${grandTaux.toFixed(1)} %</b></span>
        <button class="btn btn-sm" onclick="exportSoldesCSV()">${icon('file-spreadsheet','icon-sm')} Excel</button>
        <button class="btn btn-sm" onclick="downloadPdf('suivi-des-soldes')">${icon('printer','icon-sm')} PDF</button>
      </div>
    </div>
    <div class="print-sheet" style="max-width:1100px;">
      <div class="solde-doc-head">
        <div class="solde-doc-logo" aria-hidden="true">${schoolLogoHtml(db.ecoles[0])}</div>
        <div class="solde-doc-title">SUIVI GLOBAL DES SOLDES</div>
      </div>
      <div class="solde-doc-sub">Classe : ${soldesFilterClasse && classesToShow[0] ? classesToShow[0].libelle : 'Toutes les classes'}${soldesDateRangeLabel()}</div>
      <table class="doc-table">
        <thead><tr><th>N°</th><th>Nom</th><th>Prénoms</th><th>Année étude</th><th>Classe</th><th>Réduction</th><th>Scolarité</th><th>Déjà payé</th><th>Taux</th><th>Solde</th></tr></thead>
        <tbody>${rowsHtml}</tbody>
        ${allRows.length ? `<tfoot><tr style="font-weight:700; background:var(--paper);">
          <td colspan="6">Nombre de lignes : ${allRows.length}</td>
          <td>${fmtMoney(grandScolarite)}</td><td>${fmtMoney(grandPaye)}</td>
          <td><b style="color:${tauxColor(grandTaux)};">${grandTaux.toFixed(1)} %</b></td>
          <td>${fmtMoney(grandSolde)}</td>
        </tr></tfoot>` : ''}
      </table>
      <div class="solde-doc-footer">
        ${db.ecoles[0] ? (ecoleParts(db.ecoles[0]).nom + (db.ecoles[0].ville ? ', ' + db.ecoles[0].ville : '')) : ''}<br>
        Édité le ${fmtDate(todayISO())}
      </div>
    </div>
  `;
}

function tauxColor(t){ if(t>=90) return 'var(--success)'; if(t>=50) return 'var(--warn)'; return 'var(--danger)'; }

function setSoldesFilter(v){ soldesFilterClasse = v; render(); }

function setSoldesFilterDateDebut(v){ soldesFilterDateDebut = v || ''; render(); }

function setSoldesFilterDateFin(v){ soldesFilterDateFin = v || ''; render(); }

function soldesDateRangeLabel(){
  if(!soldesFilterDateDebut && !soldesFilterDateFin) return '';
  if(soldesFilterDateDebut && soldesFilterDateFin) return ` · Versements du ${fmtDate(soldesFilterDateDebut)} au ${fmtDate(soldesFilterDateFin)}`;
  if(soldesFilterDateDebut) return ` · Versements à partir du ${fmtDate(soldesFilterDateDebut)}`;
  return ` · Versements jusqu'au ${fmtDate(soldesFilterDateFin)}`;
}

function schoolLogoHtml(e){
  if(e && e.logo) return `<img src="${e.logo}" alt="" style="width:100%; height:100%; object-fit:contain;">`;
  return e ? (ecoleParts(e).sigle||'É').slice(0,3) : 'É';
}

function renderRelancesGlobales(){
  const allRows = db.inscriptions.filter(i=>i.statut==='VALIDEE' && i.ecoleId===currentEcoleId).map(computeRelanceRow).filter(Boolean);
  const MOIS_FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  const monthKey = d => d ? d.slice(0,7) : '';
  const months = [...new Set(allRows.map(r=>monthKey(r.dateLimite)).filter(Boolean))].sort()
    .map(k=>{ const [y,m] = k.split('-').map(Number); return {key:k, label: MOIS_FR[m-1].charAt(0).toUpperCase()+MOIS_FR[m-1].slice(1)+' '+y}; });

  let rows = relancesFilterDate ? allRows.filter(r=>monthKey(r.dateLimite)===relancesFilterDate) : allRows;
  if(relancesFilterDateDebut) rows = rows.filter(r=>r.dateLimite && r.dateLimite>=relancesFilterDateDebut);
  if(relancesFilterDateFin) rows = rows.filter(r=>r.dateLimite && r.dateLimite<=relancesFilterDateFin);
  if(relancesFilterCycleId) rows = rows.filter(r=>r.niveau && r.niveau.cycleId===relancesFilterCycleId);
  if(relancesFilterNiveauId) rows = rows.filter(r=>r.niveau && r.niveau.id===relancesFilterNiveauId);
  if(relancesFilterClasseId) rows = rows.filter(r=>r.classe.id===relancesFilterClasseId);
  if(relancesFilterEtudiantId) rows = rows.filter(r=>r.etu.id===relancesFilterEtudiantId);

  const total = rows.reduce((s,r)=>s+r.total,0);
  const selMonth = months.find(m=>m.key===relancesFilterDate);
  const periodeLabel = selMonth ? selMonth.label : 'Toutes échéances en cours';

  const ids = rows.map(r=>r.etu.id);
  [...relancesSelection].forEach(id=>{ if(!ids.includes(id)) relancesSelection.delete(id); });
  const allChecked = ids.length>0 && ids.every(id=>relancesSelection.has(id));

  const cycles = db.cycles.filter(c=>c.ecoleId===currentEcoleId);
  const niveauxOpts = db.niveaux.filter(n=>n.ecoleId===currentEcoleId && (!relancesFilterCycleId || n.cycleId===relancesFilterCycleId));
  const classesOpts = db.classes.filter(c=>c.ecoleId===currentEcoleId && (!relancesFilterNiveauId || c.niveauId===relancesFilterNiveauId));
  const etudiantsOpts = [...new Map(allRows.map(r=>[r.etu.id, r.etu])).values()].sort((a,b)=>a.nom.localeCompare(b.nom));

  const tableRows = rows.length ? rows.map((r,idx)=>{
    const checked = relancesSelection.has(r.etu.id);
    return `<tr class="${checked?'row-selected':''}">
      <td class="no-print"><input type="checkbox" ${checked?'checked':''} onchange="toggleRelanceSelect('${r.etu.id}', this.checked)"></td>
      <td>${idx+1}</td>
      <td><a class="fk-link" onclick="goTo('detail','etudiants', '${r.etu.id}')">${r.etu.nom} ${r.etu.prenoms}</a></td>
      <td>${r.niveau?r.niveau.libelle:'—'}</td>
      <td><a class="fk-link" onclick="goTo('detail','classes', '${r.classe.id}')">${r.classe.libelle}</a></td>
      <td>${r.offre?r.offre.libelle:'—'}</td>
      <td>${r.rappel>0 ? fmtMoney(r.rappel) : '—'}</td>
      <td><b>${fmtMoney(r.total)}</b></td>
      <td>${fmtDate(r.dateLimite)}</td>
      <td class="no-print"><button class="btn btn-ghost btn-sm" onclick="goTo('relance','etudiants', '${r.etu.id}')">Lettre</button></td>
    </tr>`;
  }).join('') : `<tr><td colspan="10" style="text-align:center; color:#777;">Aucune relance en attente pour cette sélection.</td></tr>`;

  return `
    <div class="print-toolbar no-print" style="flex-wrap:wrap; gap:8px; align-items:center;">
        <select onchange="setRelancesFilterCycle(this.value)">
          <option value="">Tous les cycles</option>
          ${cycles.map(c=>`<option value="${c.id}" ${relancesFilterCycleId===c.id?'selected':''}>${c.libelle}</option>`).join('')}
        </select>
        <select onchange="setRelancesFilterNiveau(this.value)">
          <option value="">Tous les niveaux</option>
          ${niveauxOpts.map(n=>`<option value="${n.id}" ${relancesFilterNiveauId===n.id?'selected':''}>${n.libelle}</option>`).join('')}
        </select>
        <select onchange="setRelancesFilterClasse(this.value)">
          <option value="">Toutes les classes</option>
          ${classesOpts.map(c=>`<option value="${c.id}" ${relancesFilterClasseId===c.id?'selected':''}>${c.libelle}</option>`).join('')}
        </select>
        <select onchange="setRelancesFilterEtudiant(this.value)">
          <option value="">Tous les étudiants concernés</option>
          ${etudiantsOpts.map(e=>`<option value="${e.id}" ${relancesFilterEtudiantId===e.id?'selected':''}>${e.nom} ${e.prenoms}</option>`).join('')}
        </select>
        <select onchange="setRelancesFilter(this.value)">
          <option value="">Toutes les échéances en cours</option>
          ${months.map(m=>`<option value="${m.key}" ${relancesFilterDate===m.key?'selected':''}>${m.label}</option>`).join('')}
        </select>
        <span style="display:flex; align-items:center; gap:6px; font-size:13px; color:var(--ink-soft);">Du
          <input type="date" value="${relancesFilterDateDebut}" onchange="setRelancesFilterDateDebut(this.value)">
          au
          <input type="date" value="${relancesFilterDateFin}" onchange="setRelancesFilterDateFin(this.value)">
        </span>
        ${relancesSelection.size>0 ? `
          <span class="ctx-pill">${relancesSelection.size} sélectionné${relancesSelection.size>1?'s':''}</span>
          <button class="btn btn-primary" onclick="startRelanceBulk()">${icon('megaphone')} Générer les lettres (${relancesSelection.size})</button>
        ` : ''}
        <button class="btn ${relancesSelection.size>0?'btn-ghost':'btn-primary'}" onclick='openRelancesPrintChoice(${JSON.stringify(ids)})'>${icon('printer')} Imprimer / Enregistrer en PDF</button>
    </div>
    <div class="print-sheet" style="max-width:1040px;">
      ${docHeader('ÉTAT PRÉVISIONNEL DES RELANCES', [`Édité le ${fmtDate(todayISO())}`])}
      <div style="text-align:center; margin:-8px 0 18px; font-size:12.5px; color:#555;">Période : <b>${periodeLabel}</b></div>
      <table class="doc-table">
        <thead><tr><th class="no-print"><input type="checkbox" ${allChecked?'checked':''} onchange="toggleRelanceSelectAll(this.checked, '${JSON.stringify(ids)}')"></th><th>N°</th><th>Nom &amp; Prénoms</th><th>Niveau</th><th>Classe</th><th>Filière</th><th>Rappel période préc.</th><th>Montant à payer</th><th>Date limite</th><th class="no-print"></th></tr></thead>
        <tbody>${tableRows}</tbody>
        <tfoot><tr><td class="no-print"></td><td colspan="6" style="text-align:right;">Total à recouvrer (${rows.length} étudiant${rows.length>1?'s':''})</td><td><b>${fmtMoney(total)}</b></td><td></td><td class="no-print"></td></tr></tfoot>
      </table>
    </div>
  `;
}

function computeRelanceRow(inscription){
  const etu = findById('personnes', inscription.etudiantId);
  const classe = inscription.classeId ? findById('classes', inscription.classeId) : null;
  if(!etu || !classe) return null;
  const echeancier = db.echeanciers.find(e=>e.inscriptionId===inscription.id);
  if(!echeancier) return null;
  const lignes = db.lignesEcheance.filter(l=>l.echeancierId===echeancier.id).slice().sort((a,b)=>a.numeroTranche-b.numeroTranche);
  const rappel = lignes.filter(l=>l.statut==='EN_RETARD').reduce((s,l)=>s+Math.max(Number(l.montantDu)-Number(l.montantPaye||0),0),0);
  const prochaine = lignes.find(l=>l.statut==='ATTENDU' || l.statut==='PARTIEL');
  if(!prochaine && rappel<=0) return null;
  const montantPeriode = prochaine ? Math.max(Number(prochaine.montantDu)-Number(prochaine.montantPaye||0),0) : 0;
  const dateLimite = prochaine ? prochaine.dateEcheance : lignes.filter(l=>l.statut==='EN_RETARD').slice(-1)[0].dateEcheance;
  return {
    etu, classe,
    niveau: findById('niveaux', classe.niveauId),
    offre: findById('offres', classe.offreId),
    rappel, montantPeriode,
    total: rappel + montantPeriode,
    dateLimite
  };
}

function toggleRelanceSelect(id, checked){
  if(checked) relancesSelection.add(id); else relancesSelection.delete(id);
  render();
}

function setRelancesFilterCycle(v){ relancesFilterCycleId = v || null; relancesFilterNiveauId = null; relancesFilterClasseId = null; render(); }

function setRelancesFilterNiveau(v){ relancesFilterNiveauId = v || null; relancesFilterClasseId = null; render(); }

function setRelancesFilterClasse(v){ relancesFilterClasseId = v || null; render(); }

function setRelancesFilterEtudiant(v){ relancesFilterEtudiantId = v || null; render(); }

function setRelancesFilter(v){ relancesFilterDate = v; render(); }

function setRelancesFilterDateDebut(v){ relancesFilterDateDebut = v || ''; render(); }

function setRelancesFilterDateFin(v){ relancesFilterDateFin = v || ''; render(); }

function startRelanceBulk(){
  if(!relancesSelection.size){ showToast('Sélectionne au moins un étudiant.'); return; }
  relanceBulkIds = [...relancesSelection];
  goTo('relanceBulk');
}

function openRelancesPrintChoice(etuIds){
  if(!Array.isArray(etuIds)) etuIds = [];
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.id = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal" style="max-width:440px;">
      <div class="modal-head">
        <h3>Que veux-tu imprimer ?</h3>
        <button class="modal-close" onclick="closeModal()">×</button>
      </div>
      <div class="modal-body" style="display:flex; flex-direction:column; gap:10px;">
        <button class="btn btn-primary" style="justify-content:flex-start; text-align:left; padding:14px 16px; height:auto;" onclick='closeRelancesPrintChoiceAndBulk(${JSON.stringify(etuIds)})'>
          ${icon('megaphone','icon-sm')} <span style="margin-left:8px;"><b>Lettres de relance par étudiant</b><br><span style="font-weight:400; font-size:12.5px; opacity:.9;">Un courrier individuel par étudiant de la liste actuelle (${etuIds.length})</span></span>
        </button>
        <button class="btn btn-ghost" style="justify-content:flex-start; text-align:left; padding:14px 16px; height:auto;" onclick="closeModal(); downloadPdf('relances')">
          ${icon('file-text','icon-sm')} <span style="margin-left:8px;"><b>PDF récapitulatif</b><br><span style="font-weight:400; font-size:12.5px; color:var(--ink-faint);">Un seul tableau avec tous les étudiants et montants</span></span>
        </button>
      </div>
    </div>
  `;
  document.getElementById('modal-root').appendChild(overlay);
  overlay.addEventListener('click', e=>{ if(e.target===overlay) closeModal(); });
}

function closeRelancesPrintChoiceAndBulk(etuIds){
  if(!etuIds || !etuIds.length){ showToast('Aucun étudiant dans la liste actuelle.'); return; }
  closeModal();
  relanceBulkIds = etuIds;
  goTo('relanceBulk');
}

function docHeader(title, metaLines){
  const ecole = db.ecoles[0];
  return `
    <div class="doc-head">
      <div style="display:flex; align-items:center; gap:12px;">
        <div class="doc-head-logo" aria-hidden="true">${schoolLogoHtml(ecole)}</div>
        <div>
          <div class="ecole-name">${ecole ? (ecoleParts(ecole).sigle || ecoleParts(ecole).nom) : 'École'}</div>
          ${ecole && ecoleParts(ecole).sigle ? `<div class="ecole-sub">${ecoleParts(ecole).nom}</div>` : ''}
          <div class="ecole-sub">${ecole ? ecole.ville : ''}</div>
        </div>
      </div>
      <div class="doc-meta">${(metaLines||[]).join('<br>')}</div>
    </div>
    <div class="doc-title">${title}</div>
  `;
}

function toggleRelanceSelectAll(checked, idsJson){
  const ids = JSON.parse(idsJson);
  relancesSelection = checked ? new Set(ids) : new Set();
  render();
}

function renderEcheancesDateesReport(){
  const allRows = allLignesEcheanceRows();
  const dates = [...new Set(allRows.map(r=>r.ligne.dateEcheance))].sort();
  if(!echeancesDateesFilter && dates.length){
    const today = todayISO();
    echeancesDateesFilter = dates.find(d=>d>=today) || dates[dates.length-1];
  }
  const rows = echeancesDateesFilter ? allRows.filter(r=>r.ligne.dateEcheance===echeancesDateesFilter) : [];
  rows.sort((a,b)=> a.classe.libelle.localeCompare(b.classe.libelle) || a.etu.nom.localeCompare(b.etu.nom));

  let totalDu=0, totalPaye=0, totalReste=0;
  const tableRows = rows.length ? rows.map((r,idx)=>{
    totalDu += Number(r.ligne.montantDu); totalPaye += Number(r.ligne.montantPaye||0); totalReste += r.reste;
    return `<tr>
      <td>${idx+1}</td>
      <td><a class="fk-link" onclick="goTo('detail','etudiants', '${r.etu.id}')">${r.etu.nom} ${r.etu.prenoms}</a></td>
      <td><a class="fk-link" onclick="goTo('detail','classes', '${r.classe.id}')">${r.classe.libelle}</a></td>
      <td>${r.niveau?r.niveau.libelle:'—'}</td>
      <td>${r.ligne.libelle}</td>
      <td>${fmtMoney(r.ligne.montantDu)}</td>
      <td>${fmtMoney(r.ligne.montantPaye||0)}</td>
      <td><b>${fmtMoney(r.reste)}</b></td>
      <td>${titleCase(r.ligne.statut)}</td>
    </tr>`;
  }).join('') : `<tr><td colspan="9" style="text-align:center; color:#777;">${echeancesDateesFilter ? 'Aucune échéance à cette date.' : "Aucune échéance datée trouvée, les échéanciers n'ont pas encore été générés."}</td></tr>`;

  return `
    <div class="print-toolbar no-print" style="align-items:center;">
      <span class="ctx-pill" style="gap:8px;">Date d'échéance :
        <input type="date" value="${echeancesDateesFilter}" onchange="setEcheancesDateesFilter(this.value)" list="echeances-dates-list" style="border:none; background:none; font-weight:600; color:var(--ink); font-size:13px;">
      </span>
      <datalist id="echeances-dates-list">${dates.map(d=>`<option value="${d}">`).join('')}</datalist>
      <button class="btn btn-primary" onclick="downloadPdf('echeances-datees')">${icon('printer')} Imprimer / Enregistrer en PDF</button>
    </div>
    <div class="print-sheet" style="max-width:980px;">
      ${docHeader('ÉTAT DES ÉCHÉANCES', [`Édité le ${fmtDate(todayISO())}`])}
      <div style="text-align:center; margin:-8px 0 18px; font-size:12.5px; color:#555;">
        Échéances datées du <b>${echeancesDateesFilter ? fmtDate(echeancesDateesFilter) : '—'}</b>
      </div>
      <table class="doc-table">
        <thead><tr><th>N°</th><th>Nom &amp; Prénoms</th><th>Classe</th><th>Niveau</th><th>Tranche</th><th>Montant dû</th><th>Déjà payé</th><th>Reste à payer</th><th>Statut</th></tr></thead>
        <tbody>${tableRows}</tbody>
        <tfoot><tr>
          <td colspan="5">Total (${rows.length} échéance${rows.length>1?'s':''})</td>
          <td>${fmtMoney(totalDu)}</td><td>${fmtMoney(totalPaye)}</td><td>${fmtMoney(totalReste)}</td><td></td>
        </tr></tfoot>
      </table>
    </div>
  `;
}

function allLignesEcheanceRows(){
  return db.lignesEcheance.map(l=>{
    const echeancier = findById('echeanciers', l.echeancierId);
    const inscription = echeancier ? findById('inscriptions', echeancier.inscriptionId) : null;
    if(!inscription || inscription.ecoleId!==currentEcoleId || inscription.statut!=='VALIDEE') return null;
    const etu = findById('personnes', inscription.etudiantId);
    const classe = inscription.classeId ? findById('classes', inscription.classeId) : null;
    if(!etu || !classe) return null;
    const reste = Math.max(Number(l.montantDu) - Number(l.montantPaye||0), 0);
    return {
      ligne:l, inscription, etu, classe,
      niveau: findById('niveaux', classe.niveauId),
      offre: findById('offres', classe.offreId),
      reste
    };
  }).filter(Boolean);
}

function setEcheancesDateesFilter(v){ echeancesDateesFilter = v; render(); }

function renderCaissePendingReport(){
  const pending = db.inscriptions.filter(i=>i.statut==='EN_ATTENTE_PAIEMENT' && i.ecoleId===currentEcoleId)
    .slice().sort((a,b)=>new Date(a.dateDemande)-new Date(b.dateDemande));
  const ids = pending.map(i=>i.id);
  [...caisseSelection].forEach(id=>{ if(!ids.includes(id)) caisseSelection.delete(id); });
  const allChecked = ids.length>0 && ids.every(id=>caisseSelection.has(id));

  const rows = pending.length ? pending.map(i=>{
    const etu = findById('personnes', i.etudiantId);
    const classe = findById('classes', i.classeId);
    const missing = missingRequiredDocuments(i.id);
    const checked = caisseSelection.has(i.id);
    return `<tr class="row-link ${checked?'row-selected':''}">
      <td onclick="event.stopPropagation();"><input type="checkbox" ${checked?'checked':''} onchange="toggleCaisseSelect('${i.id}', this.checked)"></td>
      <td>${etu ? etu.prenoms+' '+etu.nom : '—'}</td>
      <td>${classe ? classe.libelle : '—'}</td>
      <td>${fmtDate(i.dateDemande)}</td>
      <td>${missing.length
        ? `<span style="color:var(--danger); display:inline-flex; align-items:center; gap:4px;">${icon('alert-triangle','icon-sm')} ${missing.length} manquant${missing.length>1?'s':''}</span>`
        : `<span style="color:var(--success); display:inline-flex; align-items:center; gap:4px;">${icon('check','icon-sm')} Complets</span>`}</td>
      <td><span class="badge b-warn"><span class="dot"></span>En attente de paiement</span></td>
      <td onclick="event.stopPropagation();"><button class="btn btn-primary btn-sm" onclick="startCaisseTraitement('${i.id}')">Traiter ${icon('arrow-right','icon-sm')}</button></td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="7">Aucune inscription en attente de paiement.</td></tr>`;

  return `
    <div class="page-head">
      <h2>Inscriptions en attente de paiement</h2>
      <p>Dossiers dont l'admission (étudiant, parent, classe, documents) est complète, reste à traiter la réduction, l'échéancier et le premier versement.</p>
    </div>
    <div class="panel">
      <div class="panel-head">
        <h3>${pending.length} en attente</h3>
        <div class="toolbar">
          ${caisseSelection.size>0 ? `
            <span class="ctx-pill">${caisseSelection.size} sélectionné${caisseSelection.size>1?'s':''}</span>
            <button class="btn btn-primary btn-sm" onclick="openBulkReductionModal()">${icon('ticket','icon-sm')} Appliquer une réduction</button>
          ` : ''}
        </div>
      </div>
      <table class="data">
        <thead><tr>
          <th style="width:34px;"><input type="checkbox" ${allChecked?'checked':''} onchange="toggleCaisseSelectAll(this.checked, '${JSON.stringify(ids)}')"></th>
          <th>Étudiant</th><th>Classe</th><th>Inscrit le</th><th>Documents</th><th>Statut</th><th></th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
  `;
}

function toggleCaisseSelect(id, checked){
  if(checked) caisseSelection.add(id); else caisseSelection.delete(id);
  render();
}

function startCaisseTraitement(inscriptionId){
  const inscription = findById('inscriptions', inscriptionId);
  if(!inscription){ showToast('Inscription introuvable.'); return; }
  if(inscription.statut!=='EN_ATTENTE_PAIEMENT'){ showToast("Cette inscription n'est pas en attente de paiement."); return; }
  wizard = {
    mode:'CAISSE', step:1, maxStep:1,
    data:{
      etudiantId: inscription.etudiantId,
      inscriptionId: inscription.id,
      classeId: inscription.classeId,
      anneeId: inscription.anneeId,
      arrears: studentArrears(inscription.etudiantId)
    }
  };
  goTo('wizard');
}

function studentArrears(etudiantId){
  const inscs = db.inscriptions.filter(i=>i.etudiantId===etudiantId);
  let total = 0;
  inscs.forEach(i=>{
    const ech = db.echeanciers.find(e=>e.inscriptionId===i.id);
    if(ech){
      const paye = db.versements.filter(v=>v.inscriptionId===i.id && v.statut==='ENREGISTRE').reduce((s,v)=>s+Number(v.montant),0);
      const solde = Number(ech.montantNet) - paye;
      if(solde>0) total += solde;
    }
  });
  return total;
}

function openBulkReductionModal(){
  const ids = [...caisseSelection];
  if(!ids.length){ showToast('Sélectionnez au moins un étudiant.'); return; }
  const reductionsOpts = db.reductions.filter(r=>r.active && r.ecoleId===currentEcoleId)
    .map(r=>`<option value="${r.id}">${r.libelle} (${r.type==='POURCENTAGE' ? r.valeur+' %' : fmtMoney(r.valeur)})</option>`).join('');
  const noms = ids.map(id=>{
    const insc = findById('inscriptions', id);
    const etu = insc ? findById('personnes', insc.etudiantId) : null;
    return etu ? etu.prenoms+' '+etu.nom : '—';
  });
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.id = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal">
      <div class="modal-head">
        <h3>Appliquer une réduction à ${ids.length} étudiant${ids.length>1?'s':''}</h3>
        <button class="modal-close" onclick="closeModal()">×</button>
      </div>
      <div class="modal-body">
        <div class="doc-note">${noms.join(' · ')}</div>
        <div class="field"><label>Réduction <span class="req">*</span></label>
          <select id="bulk-reduction-id">${reductionsOpts || '<option value="">Aucune réduction active pour cette école</option>'}</select>
        </div>
      </div>
      <div class="modal-foot">
        <button class="btn" onclick="closeModal()">Annuler</button>
        <button class="btn btn-primary" onclick="submitBulkReduction()">Appliquer au groupe</button>
      </div>
    </div>
  `;
  document.getElementById('modal-root').appendChild(overlay);
  overlay.addEventListener('click', e=>{ if(e.target===overlay) closeModal(); });
  enhanceSelects(overlay);
}

function enhanceSelects(root){
  (root||document).querySelectorAll('select:not(.s2-native)').forEach(upgradeSelectToS2);
}

function upgradeSelectToS2(select){
  if(select.dataset.s2) return;
  select.dataset.s2 = '1';
  const compact = select.classList.contains('ecole-select');
  const inToolbar = !!select.closest('.toolbar, .print-toolbar, .panel-head');
  const autoWidth = compact || inToolbar;

  const wrap = document.createElement('div');
  wrap.className = 'ssel' + (compact ? ' s2-compact' : (inToolbar ? ' s2-toolbar' : ''));
  select.parentNode.insertBefore(wrap, select);
  select.classList.add('s2-native');
  wrap.appendChild(select);

  const input = document.createElement('input');
  input.type = 'text';
  input.className = 'ssel-input s2-input';
  input.autocomplete = 'off';
  input.readOnly = false;
  wrap.appendChild(input);

  const list = document.createElement('div');
  list.className = 'ssel-list';
  wrap.appendChild(list);

  if(autoWidth){
    const labels = [...select.options].map(o=>o.textContent);
    const px = s2MeasureWidth(input, labels, compact ? 28 : 40);
    const floor = compact ? 40 : 150;
    const ceil = compact ? 460 : 460;
    wrap.style.width = Math.max(floor, Math.min(ceil, px)) + 'px';
  }

  function optsData(){
    return [...select.options].map(o=>({value:o.value, label:o.textContent}));
  }
  function sync(){
    const opt = select.options[select.selectedIndex];
    input.value = opt ? opt.textContent : '';
    input.disabled = select.disabled;
    input.placeholder = select.disabled ? '' : (select.getAttribute('data-placeholder')||'');
  }
  function renderOptsList(query){
    const q = (query||'').toLowerCase();
    const opts = optsData().filter(o=>!q || o.label.toLowerCase().includes(q));
    list.innerHTML = opts.length
      ? opts.map(o=>`<div class="ssel-opt ${o.value===select.value?'sel':''}" data-value="${o.value.replace(/"/g,'&quot;')}">${o.label}</div>`).join('')
      : `<div class="ssel-empty">Aucun résultat</div>`;
    list.classList.add('open');
  }
  input.addEventListener('focus', ()=>{ if(!input.disabled){ input.value=''; renderOptsList(''); } });
  input.addEventListener('input', ()=> renderOptsList(input.value));
  input.addEventListener('blur', ()=>{ setTimeout(()=>{ sync(); }, 150); });
  list.addEventListener('mousedown', e=>{
    const opt = e.target.closest('.ssel-opt');
    if(!opt) return;
    e.preventDefault();
    select.value = opt.getAttribute('data-value');
    sync();
    list.classList.remove('open');
    select.dispatchEvent(new Event('change', {bubbles:true}));
  });
  wrap.addEventListener('click', e=>e.stopPropagation());
  select.addEventListener('change', sync);
  sync();
}

function s2MeasureWidth(el, texts, extra){
  if(!s2MeasureWidth._ctx) s2MeasureWidth._ctx = document.createElement('canvas').getContext('2d');
  const ctx = s2MeasureWidth._ctx;
  const cs = getComputedStyle(el);
  ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
  let max = 0;
  texts.forEach(t=>{ const w = ctx.measureText(t||'').width; if(w>max) max = w; });
  return Math.ceil(max) + (extra||0);
}

function toggleCaisseSelectAll(checked, idsJson){
  const ids = JSON.parse(idsJson);
  caisseSelection = checked ? new Set(ids) : new Set();
  render();
}

function renderCaisseEtatsReport(){
  const annees = db.annees;
  if(!caisseEtatsAnneeId){ const ca = currentAnnee(); caisseEtatsAnneeId = ca ? ca.id : (annees[0]||{}).id; }
  const annee = findById('annees', caisseEtatsAnneeId);
  const classesEcole = db.classes.filter(c=>c.ecoleId===currentEcoleId);
  if(!caisseEtatsClasseId || !classesEcole.some(c=>c.id===caisseEtatsClasseId)) caisseEtatsClasseId = (classesEcole[0]||{}).id || null;
  const classe = findById('classes', caisseEtatsClasseId);
  const niveau = classe ? findById('niveaux', classe.niveauId) : null;

  const inscriptions = (classe && annee) ? db.inscriptions.filter(i=>i.classeId===classe.id && i.anneeId===annee.id && i.statut==='VALIDEE') : [];
  const rows = inscriptions.map(i=>computeSoldeRow(i, caisseEtatsDateDebut||null, caisseEtatsDateFin||null)).filter(r=>r.etu);
  rows.sort((a,b)=>a.etu.nom.localeCompare(b.etu.nom));

  const grandScolarite = rows.reduce((s,r)=>s+r.scolarite,0);
  const grandPaye = rows.reduce((s,r)=>s+r.dejaPaye,0);
  const grandSolde = rows.reduce((s,r)=>s+r.solde,0);
  const grandTaux = grandScolarite>0 ? (grandPaye/grandScolarite*100) : 0;

  const rowsHtml = rows.length ? rows.map((r,idx)=>`<tr>
      <td class="mono">${idx+1}</td>
      <td><a class="fk-link" onclick="goTo('detail','etudiants', '${r.etu.id}')">${r.etu.nom}</a></td>
      <td>${r.etu.prenoms}</td>
      <td>${niveau?niveau.libelle:'—'}</td>
      <td>${classe?classe.libelle:'—'}</td>
      <td>${fmtMoney(r.reduction)}</td>
      <td>${fmtMoney(r.scolarite)}</td>
      <td>${fmtMoney(r.dejaPaye)}</td>
      <td><b style="color:${tauxColor(r.taux)};">${r.taux.toFixed(1)} %</b></td>
      <td>${fmtMoney(Math.max(r.solde,0))}</td>
    </tr>`).join('') : `<tr class="empty-row"><td colspan="10">Aucun étudiant inscrit et validé dans cette classe pour cette année.</td></tr>`;

  return `
    <div class="page-head no-print">
      <h2>États par classe</h2>
      <p>Suivi des soldes de scolarité pour une classe donnée, réduction accordée, scolarité, déjà payé, taux de recouvrement et reste à payer.</p>
    </div>
    <div class="kpi-row no-print">
      <div class="kpi-card"><div class="lbl">Étudiants</div><div class="val tnum">${rows.length}</div></div>
      <div class="kpi-card"><div class="lbl">Scolarité totale</div><div class="val tnum">${fmtMoney(grandScolarite)}</div></div>
      <div class="kpi-card"><div class="lbl">Total encaissé</div><div class="val tnum">${fmtMoney(grandPaye)}</div></div>
      <div class="kpi-card"><div class="lbl">Solde restant dû</div><div class="val tnum">${fmtMoney(grandSolde)}</div></div>
    </div>
    <div class="panel-head no-print" style="padding:0 0 14px; border:none; background:none;">
      <div class="toolbar">
        <select onchange="setCaisseEtatsClasse(this.value)">${classesEcole.map(c=>`<option value="${c.id}" ${c.id===caisseEtatsClasseId?'selected':''}>${c.libelle}</option>`).join('')}</select>
        <select onchange="setCaisseEtatsAnnee(this.value)">${annees.map(a=>`<option value="${a.id}" ${a.id===caisseEtatsAnneeId?'selected':''}>${a.libelle}</option>`).join('')}</select>
        <span style="display:flex; align-items:center; gap:6px; font-size:13px; color:var(--ink-soft);">Versements du
          <input type="date" value="${caisseEtatsDateDebut}" onchange="setCaisseEtatsDateDebut(this.value)">
          au
          <input type="date" value="${caisseEtatsDateFin}" onchange="setCaisseEtatsDateFin(this.value)">
        </span>
        <span class="ctx-pill">Taux : <b style="color:${tauxColor(grandTaux)};">${grandTaux.toFixed(1)} %</b></span>
        <button class="btn btn-sm" onclick="exportCaisseEtatsExcel()">${icon('file-spreadsheet','icon-sm')} Excel</button>
        <button class="btn btn-sm" onclick="downloadPdf('etats')">${icon('printer','icon-sm')} PDF</button>
      </div>
    </div>
    <div class="print-sheet" style="max-width:1100px;">
      <div class="solde-doc-head">
        <div class="solde-doc-logo" aria-hidden="true">${schoolLogoHtml(db.ecoles[0])}</div>
        <div class="solde-doc-title">ÉTAT DES SOLDES PAR CLASSE</div>
      </div>
      <div class="solde-doc-sub">Classe : ${classe?classe.libelle:'—'} · Année académique : ${annee?annee.libelle:'—'}</div>
      <table class="doc-table">
        <thead><tr><th>N°</th><th>Nom</th><th>Prénoms</th><th>Année étude</th><th>Classe</th><th>Réduction</th><th>Scolarité</th><th>Déjà payé</th><th>Taux</th><th>Solde</th></tr></thead>
        <tbody>${rowsHtml}</tbody>
        ${rows.length ? `<tfoot><tr style="font-weight:700; background:var(--paper);">
          <td colspan="6">Nombre de lignes : ${rows.length}</td>
          <td>${fmtMoney(grandScolarite)}</td><td>${fmtMoney(grandPaye)}</td>
          <td><b style="color:${tauxColor(grandTaux)};">${grandTaux.toFixed(1)} %</b></td>
          <td>${fmtMoney(grandSolde)}</td>
        </tr></tfoot>` : ''}
      </table>
      <div class="solde-doc-footer">
        ${db.ecoles[0] ? (ecoleParts(db.ecoles[0]).nom + (db.ecoles[0].ville ? ', ' + db.ecoles[0].ville : '')) : ''}<br>
        Édité le ${fmtDate(todayISO())}
      </div>
    </div>
  `;
}

function setCaisseEtatsClasse(id){ caisseEtatsClasseId = id; render(); }

function setCaisseEtatsAnnee(id){ caisseEtatsAnneeId = id; caisseEtatsMoisKey = null; render(); }

function setCaisseEtatsDateDebut(v){ caisseEtatsDateDebut = v || ''; render(); }

function setCaisseEtatsDateFin(v){ caisseEtatsDateFin = v || ''; render(); }

function pdfName(v){ return String(v==null?'':v).normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^A-Za-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }

function ensureViewToggle(){
  const c = document.getElementById('content');
  const g = c.querySelector('.module-grid');
  if(!g){ return; }
  if(!c.querySelector('.view-toggle')){
    const t = document.createElement('div');
    t.className = 'view-toggle no-print';
    t.innerHTML = `<div class="vt" role="group" aria-label="Mode d'affichage"><button type="button" class="vt-btn" data-mode="cards" onclick="setViewMode('cards')">${icon('layout-grid','icon-sm')} Cartes</button><button type="button" class="vt-btn" data-mode="list" onclick="setViewMode('list')">${icon('menu','icon-sm')} Liste</button></div>`;
    g.parentNode.insertBefore(t, g);
  }
  applyViewMode();
}

function setViewMode(m){
  viewMode = m;
  try{ localStorage.setItem('registre.vue', m); }catch(e){}
  applyViewMode();
}

function applyViewMode(){
  document.querySelectorAll('#content .module-grid').forEach(g => g.classList.toggle('list', viewMode === 'list'));
  document.querySelectorAll('#content .view-toggle .vt-btn').forEach(b => {
    const on = b.dataset.mode === viewMode;
    b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

function renderMatieresPage(){
  if(!matieresPicker.offreId) return renderMatieresPickOffre();
  if(!matieresPicker.niveauId) return renderMatieresPickNiveau();
  if(!matieresPicker.periodeId) return renderMatieresPickPeriode();
  return renderMatieresFiltered();
}

function renderMatieresPickOffre(){
  const offres = db.offres.filter(o=>o.ecoleId===currentEcoleId)
    .map(o=>({o, count: db.matieres.filter(m=>m.ecoleId===currentEcoleId && (m.offreIds||[]).includes(o.id)).length}))
    .filter(x=>x.count>0)
    .sort((a,b)=>a.o.libelle.localeCompare(b.o.libelle));
  const cards = offres.map(({o, count})=>{
    return `<div class="module-card" onclick="setMatieresPickerOffre('${o.id}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon('graduation-cap')}</div>
      <h4>${o.libelle}</h4>
      <p>${count} matière${count>1?'s':''} associée${count>1?'s':''}</p>
    </div>`;
  }).join('');
  return `
    <div class="page-head" style="display:flex; justify-content:space-between; align-items:flex-end; gap:16px; flex-wrap:wrap;">
      <div>
        <h2>Matières</h2>
        <p>Choisis d'abord l'offre de formation (la filière), puis le niveau : une matière est propre à une filière donnée à un niveau donné, deux filières au même niveau (ex. Licence 1 Marketing et BTS 1 Comptabilité) n'ont pas forcément le même programme, sauf pour un éventuel tronc commun. Seules les offres ayant déjà des matières sont affichées ici.</p>
      </div>
      <button class="btn btn-primary btn-sm" onclick="openForm('matieres', null)">+ Nouveau</button>
    </div>
    <div class="module-grid">${cards || '<p class="muted">Aucune matière créée pour l\'instant, clique sur « + Nouveau ».</p>'}</div>
  `;
}

function setMatieresPickerOffre(id){ matieresPicker.offreId = id; matieresPicker.niveauId = null; matieresPicker.periodeId = null; render(); }

function renderMatieresPickNiveau(){
  const offre = findById('offres', matieresPicker.offreId);
  const niveaux = db.niveaux.filter(n=>n.ecoleId===currentEcoleId)
    .map(n=>({n, count: db.matieres.filter(m=>m.ecoleId===currentEcoleId && (m.offreIds||[]).includes(offre.id) && (m.niveauIds||[]).includes(n.id)).length}))
    .filter(x=>x.count>0)
    .sort((a,b)=>a.n.libelle.localeCompare(b.n.libelle));
  const cards = niveaux.map(({n, count})=>{
    return `<div class="module-card" onclick="setMatieresPickerNiveau('${n.id}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon('layers')}</div>
      <h4>${n.libelle}</h4>
      <p>${count} matière${count>1?'s':''} associée${count>1?'s':''}</p>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;"><a style="cursor:pointer; color:var(--ink-soft);" onclick="setMatieresPickerOffre(null)">← Changer d'offre</a></p>
      <h2>Matières, ${offre.libelle}</h2>
      <p>Choisis maintenant le niveau concerné (ex. 1ère année). Seuls les niveaux ayant déjà des matières pour cette offre sont affichés.</p>
    </div>
    <div class="module-grid">${cards || '<p class="muted">Aucune matière créée pour cette offre.</p>'}</div>
  `;
}

function setMatieresPickerNiveau(id){ matieresPicker.niveauId = id; matieresPicker.periodeId = null; render(); }

function renderMatieresPickPeriode(){
  const offre = findById('offres', matieresPicker.offreId);
  const niveau = findById('niveaux', matieresPicker.niveauId);
  const ca = currentAnnee();
  const cards = db.periodes.filter(p=>ca && p.anneeId===ca.id).map(p=>{
    const count = db.matieres.filter(m=>m.ecoleId===currentEcoleId && (m.offreIds||[]).includes(offre.id) && (m.niveauIds||[]).includes(niveau.id) && (m.periodeIds||[]).includes(p.id)).length;
    return `<div class="module-card" onclick="setMatieresPickerPeriode('${p.id}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon('calendar-days')}</div>
      <h4>${p.libelle}</h4>
      <p>${count} matière${count>1?'s':''}</p>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;">
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setMatieresPickerOffre(null)">← Offre</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setMatieresPickerNiveau(null)">Changer de niveau</a>
      </p>
      <h2>Matières, ${offre.libelle} · ${niveau.libelle}</h2>
      <p>Choisis maintenant la période (semestre) concernée, pour l'année académique en cours (${ca?ca.libelle:'—'}).</p>
    </div>
    <div class="module-grid">${cards || '<p class="muted">Aucune période définie pour l\'année en cours.</p>'}</div>
  `;
}

function setMatieresPickerPeriode(id){ matieresPicker.periodeId = id; render(); }

function renderMatieresFiltered(){
  const offre = findById('offres', matieresPicker.offreId);
  const niveau = findById('niveaux', matieresPicker.niveauId);
  const periode = findById('periodes', matieresPicker.periodeId);
  const rows = entityRows(ENTITIES.matieres).filter(m=>
    (m.offreIds||[]).includes(offre.id) && (m.niveauIds||[]).includes(niveau.id) && (m.periodeIds||[]).includes(periode.id));
  const mPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const mPage = Math.min(Math.max(1, tablePage.matieres||1), mPages); tablePage.matieres = mPage;
  const pageRowsM = rows.slice((mPage-1)*PAGE_SIZE, mPage*PAGE_SIZE);
  const trs = pageRowsM.length ? pageRowsM.map(m=>`<tr>
      <td>${m.libelle}</td>
      <td>${fieldDisplayValue({key:'offreIds', type:'multiselect', ref:'offres', display:'libelle'}, m)}</td>
      <td>${fieldDisplayValue({key:'niveauIds', type:'multiselect', ref:'niveaux', display:'libelle'}, m)}</td>
      <td>${fieldDisplayValue({key:'periodeIds', type:'multiselect', ref:'periodes', display:'libelle'}, m)}</td>
      <td>${m.coefficient}</td>
      <td>${m.credits}</td>
      <td class="row-actions" style="text-align:right; white-space:nowrap;">
        <button class="btn btn-ghost btn-sm" onclick="goTo('detail','matieres', '${m.id}')">Détails</button>
        <button class="btn btn-ghost btn-sm" onclick="openForm('matieres', '${m.id}')">Modifier</button>
        <button class="btn btn-danger-ghost btn-sm" onclick="deleteRow('matieres', '${m.id}')">Supprimer</button>
      </td>
    </tr>`).join('') : `<tr class="empty-row"><td colspan="7">Aucune matière pour cette offre, ce niveau et cette période.</td></tr>`;
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;">
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setMatieresPickerOffre(null)">← Offre</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setMatieresPickerNiveau(null)">Niveau</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setMatieresPickerPeriode(null)">Changer de période</a>
      </p>
      <h2>Matières, ${offre.libelle} · ${niveau.libelle} · ${periode.libelle}</h2>
      <p>${rows.length} matière${rows.length>1?'s':''} associée${rows.length>1?'s':''} à cette offre, ce niveau et cette période. Une matière peut être rattachée à plusieurs offres (tronc commun), niveaux et périodes.</p>
    </div>
    <div class="panel">
      <div class="panel-head">
        <h3>Matières</h3>
        <button class="btn btn-primary btn-sm" onclick="openForm('matieres', null, {offreIds:['${offre.id}'], niveauIds:['${niveau.id}'], periodeIds:['${periode.id}']})">+ Nouveau</button>
      </div>
      <div class="notes-grid-wrap">
      <table class="data">
        <thead><tr><th>Libellé</th><th>Offres</th><th>Niveaux</th><th>Périodes</th><th>Coef.</th><th>Crédits</th><th></th></tr></thead>
        <tbody>${trs}</tbody>
      </table>
      </div>
      ${pagerHtml('matieres', rows.length)}
    </div>
  `;
}

function pagerHtml(key, total){
  if(total <= PAGE_SIZE) return '';
  const pages = Math.ceil(total / PAGE_SIZE);
  const cur = Math.min(Math.max(1, tablePage[key] || 1), pages);
  const from = (cur - 1) * PAGE_SIZE + 1, to = Math.min(cur * PAGE_SIZE, total);
  let nums = [];
  if(pages <= 7){ for(let p=1;p<=pages;p++) nums.push(p); }
  else { nums = [1]; if(cur > 3) nums.push('…'); for(let p=Math.max(2,cur-1); p<=Math.min(pages-1,cur+1); p++) nums.push(p); if(cur < pages-2) nums.push('…'); nums.push(pages); }
  const btns = nums.map(p => p==='…' ? `<span class="pg-gap">…</span>` : `<button type="button" class="pg ${p===cur?'on':''}" ${p===cur?'aria-current="page"':''} onclick="setTablePage('${key}',${p})">${p}</button>`).join('');
  return `<div class="pager no-print">
    <span class="pager-info">${from}–${to} sur ${total}</span>
    <div class="pager-nav">
      <button type="button" class="pg" aria-label="Page précédente" ${cur===1?'disabled':''} onclick="setTablePage('${key}',${cur-1})">${icon('chevron-left','icon-sm')}</button>
      ${btns}
      <button type="button" class="pg" aria-label="Page suivante" ${cur===pages?'disabled':''} onclick="setTablePage('${key}',${cur+1})">${icon('chevron-right','icon-sm')}</button>
    </div>
  </div>`;
}

function setTablePage(key, n){ tablePage[key] = n; render(); }

function renderNotesPage(){
  if(!notesPicker.classeId) return renderNotesPickClasse();
  if(!notesPicker.matiereId) return renderNotesPickMatiere();
  if(!notesPicker.periodeId) return renderNotesPickPeriode();
  return renderNotesSaisie();
}

function renderNotesPickClasse(){
  const classes = db.classes.filter(c=>c.ecoleId===currentEcoleId)
    .map(c=>({c, effectif: db.inscriptions.filter(i=>i.classeId===c.id && i.statut!=='ANNULEE').length}))
    .filter(x=>x.effectif>0);
  const groups = {};
  classes.forEach(x=>{
    const offre = findById('offres', x.c.offreId);
    const key = offre ? offre.libelle : 'Autre';
    (groups[key] = groups[key] || []).push(x);
  });
  const groupKeys = Object.keys(groups).sort((a,b)=>a.localeCompare(b));
  const sectionsHtml = groupKeys.map(gk=>{
    const items = groups[gk].sort((a,b)=>a.c.libelle.localeCompare(b.c.libelle));
    const cards = items.map(({c, effectif})=>{
      const niveau = findById('niveaux', c.niveauId);
      return `<div class="module-card" onclick="setNotesPickerClasse('${c.id}')">
        <span class="mod-arrow">→</span>
        <div class="mod-ico">${icon('tag')}</div>
        <h4>${c.libelle}</h4>
        <p>${niveau ? niveau.libelle : '—'} · ${effectif} élève${effectif>1?'s':''}</p>
      </div>`;
    }).join('');
    return `<div style="margin-bottom:22px;">
      <div style="font-size:13px; font-weight:700; color:var(--ink-faint); text-transform:uppercase; letter-spacing:.03em; margin:0 0 10px;">${gk}</div>
      <div class="module-grid">${cards}</div>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <h2>Notes</h2>
      <p>Choisis d'abord la classe à noter. Le niveau et la liste des élèves en découlent automatiquement. Seules les classes ayant au moins un élève inscrit sont affichées, regroupées par filière.</p>
    </div>
    ${sectionsHtml || '<p class="muted">Aucune classe avec des élèves inscrits pour cette école.</p>'}
  `;
}

function setNotesPickerClasse(id){
  notesPicker = {classeId:id, matiereId:null, periodeId:null, pendingColumns:[]};
  render();
}

function renderNotesPickMatiere(){
  const classe = findById('classes', notesPicker.classeId);
  const niveau = findById('niveaux', classe.niveauId);
  const offre = findById('offres', classe.offreId);
  const matieres = db.matieres.filter(m=>m.ecoleId===currentEcoleId &&
    (m.offreIds||[]).includes(classe.offreId) && (m.niveauIds||[]).includes(classe.niveauId));
  const cards = matieres.map(m=>`<div class="module-card" onclick="setNotesPickerMatiere('${m.id}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon('book')}</div>
      <h4>${m.libelle}</h4>
      <p>Coef. ${m.coefficient} · ${m.code}</p>
    </div>`).join('');
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;"><a style="cursor:pointer; color:var(--ink-soft);" onclick="setNotesPickerClasse(null)">← Changer de classe</a></p>
      <h2>Notes, ${classe.libelle}</h2>
      <p>${offre ? offre.libelle : '—'} · Niveau ${niveau ? niveau.libelle : '—'}. Choisis la matière à noter.</p>
    </div>
    <div class="module-grid">${cards || '<p class="muted">Aucune matière associée à cette offre et ce niveau. Ajoute-la d’abord depuis « Matières ».</p>'}</div>
  `;
}

function setNotesPickerMatiere(id){ notesPicker.matiereId = id; notesPicker.periodeId = null; notesPicker.pendingColumns = []; render(); }

function renderNotesPickPeriode(){
  const classe = findById('classes', notesPicker.classeId);
  const matiere = findById('matieres', notesPicker.matiereId);
  const periodes = db.periodes.filter(p=>p.anneeId===classe.anneeId && (matiere.periodeIds||[]).includes(p.id));
  const cards = periodes.map(p=>`<div class="module-card" onclick="setNotesPickerPeriode('${p.id}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon('calendar-days')}</div>
      <h4>${p.libelle}</h4>
      <p>${fmtDate(p.dateDebut)} → ${fmtDate(p.dateFin)}</p>
    </div>`).join('');
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;">
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setNotesPickerClasse(null)">← Classe</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setNotesPickerMatiere(null)">Changer de matière</a>
      </p>
      <h2>Notes, ${classe.libelle} · ${matiere.libelle}</h2>
      <p>Choisis la période concernée par cette évaluation.</p>
    </div>
    <div class="module-grid">${cards || '<p class="muted">Cette matière n’est programmée sur aucune période de l’année en cours de cette classe.</p>'}</div>
  `;
}

function setNotesPickerPeriode(id){ notesPicker.periodeId = id; notesPicker.pendingColumns = []; render(); }

function renderNotesSaisie(){
  const classe = findById('classes', notesPicker.classeId);
  const matiere = findById('matieres', notesPicker.matiereId);
  const periode = findById('periodes', notesPicker.periodeId);

  const inscriptions = db.inscriptions
    .filter(i=>i.classeId===classe.id && i.statut!=='ANNULEE')
    .map(i=>({insc:i, etu:findById('personnes', i.etudiantId)}))
    .filter(x=>!!x.etu)
    .sort((a,b)=> a.etu.nom.localeCompare(b.etu.nom));

  const columns = notesGridColumns(matiere.id, periode.id, classe.id);
  const typeCounters = {};
  const colMeta = columns.map(c=>{
    typeCounters[c.typeEvaluation] = (typeCounters[c.typeEvaluation]||0) + 1;
    return {...c, label: `${titleCase(c.typeEvaluation)} ${typeCounters[c.typeEvaluation]}`};
  });

  const byInsc = {};
  inscriptions.forEach(({insc})=>{ byInsc[insc.id] = {}; });
  db.notes.forEach(n=>{
    if(n.matiereId===matiere.id && n.periodeId===periode.id && byInsc[n.inscriptionId]){
      byInsc[n.inscriptionId][n.typeEvaluation+'|'+n.dateEvaluation] = n.valeur;
    }
  });

  const theadCols = colMeta.map(c=>`<th style="text-align:center; min-width:118px;">
      <div>${c.label}</div>
      <div class="muted" style="font-weight:400; font-size:10.6px; margin-top:2px;">${fmtDate(c.dateEvaluation)}</div>
      <button class="col-del" title="Supprimer cette évaluation et ses notes" onclick="removeNotesColumn('${c.typeEvaluation}','${c.dateEvaluation}')">Supprimer ${icon('x','icon-sm')}</button>
    </th>`).join('');

  const rows = inscriptions.length ? inscriptions.map(({insc,etu})=>{
    const cells = colMeta.length ? colMeta.map(c=>{
      const key = c.typeEvaluation+'|'+c.dateEvaluation;
      const val = byInsc[insc.id][key];
      return `<td style="text-align:center;">
        <input type="number" min="0" max="20" step="0.25" class="grade-input" data-insc="${insc.id}" data-type="${c.typeEvaluation}" data-date="${c.dateEvaluation}" value="${val!=null?val:''}" placeholder="—"
          oninput="this.classList.toggle('out-of-range', this.value!=='' && (Number(this.value)<0 || Number(this.value)>20))">
      </td>`;
    }).join('') : `<td class="muted">Ajoute une évaluation pour commencer la saisie →</td>`;
    return `<tr><td class="sticky-col">${etu.nom} ${etu.prenoms}<div class="muted" style="font-size:11px;">${etu.numeroEtudiant||'—'}</div></td>${cells}</tr>`;
  }).join('') : `<tr class="empty-row"><td class="sticky-col">—</td><td colspan="${Math.max(colMeta.length,1)}">Aucun élève avec une inscription active dans cette classe.</td></tr>`;

  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;">
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setNotesPickerClasse(null)">← Classe</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setNotesPickerMatiere(null)">Matière</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setNotesPickerPeriode(null)">Période</a>
      </p>
      <h2>Notes, ${classe.libelle} · ${matiere.libelle} · ${periode.libelle}</h2>
      <p>Chaque colonne est une évaluation (devoir, interrogation, TP…) identifiée par son type et sa date. Ajoute une colonne à chaque nouvelle évaluation, la grille reste défilable horizontalement au fil du semestre.</p>
    </div>
    <div class="panel">
      <div class="panel-head">
        <h3>Élèves de la classe</h3>
        <button class="btn btn-primary btn-sm" onclick="saveNotesGrid('${classe.id}', '${matiere.id}', '${periode.id}')">Enregistrer les notes</button>
      </div>
      <div class="toolbar" style="padding:0 20px 16px; align-items:flex-end;">
        <div class="field" style="margin:0;">
          <label>Nouvelle évaluation</label>
          <select id="new-col-type">
            ${ENUMS.typeEvaluation.map(t=>`<option value="${t}">${titleCase(t)}</option>`).join('')}
          </select>
        </div>
        <div class="field" style="margin:0;">
          <label>Date</label>
          <input type="date" id="new-col-date" value="${todayISO()}">
        </div>
        <button class="btn btn-ghost btn-sm" onclick="addNotesColumn(document.getElementById('new-col-type').value, document.getElementById('new-col-date').value)">+ Ajouter la colonne</button>
      </div>
      <div class="notes-grid-wrap">
        <table class="data notes-grid">
          <thead><tr><th class="sticky-col">Élève</th>${theadCols || '<th class="muted">Aucune évaluation créée pour l’instant</th>'}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    </div>
  `;
}

function notesGridColumns(matiereId, periodeId, classeId){
  const inscIds = db.inscriptions.filter(i=>i.classeId===classeId).map(i=>i.id);
  const notes = db.notes.filter(n=>n.matiereId===matiereId && n.periodeId===periodeId && inscIds.includes(n.inscriptionId));
  const map = new Map();
  notes.forEach(n=>{ const k=n.typeEvaluation+'|'+n.dateEvaluation; if(!map.has(k)) map.set(k, {typeEvaluation:n.typeEvaluation, dateEvaluation:n.dateEvaluation}); });
  (notesPicker.pendingColumns||[]).forEach(c=>{ const k=c.typeEvaluation+'|'+c.dateEvaluation; if(!map.has(k)) map.set(k, c); });
  return [...map.values()].sort((a,b)=> a.dateEvaluation===b.dateEvaluation ? a.typeEvaluation.localeCompare(b.typeEvaluation) : a.dateEvaluation.localeCompare(b.dateEvaluation));
}

function addNotesColumn(type, date){
  if(!type || !date){ showToast("Choisis un type et une date pour la nouvelle évaluation."); return; }
  const cols = notesGridColumns(notesPicker.matiereId, notesPicker.periodeId, notesPicker.classeId);
  if(cols.some(c=>c.typeEvaluation===type && c.dateEvaluation===date)){
    showToast('Une évaluation de ce type existe déjà à cette date.');
    return;
  }
  notesPicker.pendingColumns = notesPicker.pendingColumns || [];
  notesPicker.pendingColumns.push({typeEvaluation:type, dateEvaluation:date});
  render();
}

function renderBulletinsPage(){
  if(!bulletinsPicker.classeId) return renderBulletinsPickClasse();
  if(!bulletinsPicker.periodeId) return renderBulletinsPickPeriode();
  return renderBulletinsGrid();
}

function renderBulletinsPickClasse(){
  const classes = db.classes.filter(c=>c.ecoleId===currentEcoleId)
    .map(c=>({c, effectif: db.inscriptions.filter(i=>i.classeId===c.id && i.statut==='VALIDEE').length}))
    .filter(x=>x.effectif>0);
  const groups = {};
  classes.forEach(x=>{
    const offre = findById('offres', x.c.offreId);
    const key = offre ? offre.libelle : 'Autre';
    (groups[key] = groups[key] || []).push(x);
  });
  const groupKeys = Object.keys(groups).sort((a,b)=>a.localeCompare(b));
  const sectionsHtml = groupKeys.map(gk=>{
    const items = groups[gk].sort((a,b)=>a.c.libelle.localeCompare(b.c.libelle));
    const cards = items.map(({c, effectif})=>{
      const niveau = findById('niveaux', c.niveauId);
      return `<div class="module-card" onclick="setBulletinsPickerClasse('${c.id}')">
        <span class="mod-arrow">→</span>
        <div class="mod-ico">${icon('file-check')}</div>
        <h4>${c.libelle}</h4>
        <p>${niveau ? niveau.libelle : '—'} · ${effectif} élève${effectif>1?'s':''}</p>
      </div>`;
    }).join('');
    return `<div style="margin-bottom:22px;">
      <div style="font-size:13px; font-weight:700; color:var(--ink-faint); text-transform:uppercase; letter-spacing:.03em; margin:0 0 10px;">${gk}</div>
      <div class="module-grid">${cards}</div>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <h2>Bulletins</h2>
      <p>Choisis la classe. La moyenne, les crédits validés et le rang de chaque élève sont calculés à partir des notes déjà saisies, seule l'appréciation reste à ta charge. Seules les classes ayant au moins un élève inscrit sont affichées, regroupées par filière.</p>
    </div>
    ${sectionsHtml || '<p class="muted">Aucune classe avec des élèves inscrits pour cette école.</p>'}
  `;
}

function setBulletinsPickerClasse(id){ bulletinsPicker = {classeId:id, periodeId:null}; render(); }

function renderBulletinsPickPeriode(){
  const classe = findById('classes', bulletinsPicker.classeId);
  const periodes = db.periodes.filter(p=>p.anneeId===classe.anneeId).slice().sort((a,b)=>a.ordre-b.ordre);
  const cards = periodes.map(p=>{
    const count = db.inscriptions.filter(i=>i.classeId===classe.id && i.statut==='VALIDEE' && db.bulletins.some(b=>b.inscriptionId===i.id && b.periodeId===p.id)).length;
    return `<div class="module-card" onclick="setBulletinsPickerPeriode('${p.id}')">
      <span class="mod-arrow">→</span>
      <div class="mod-ico">${icon('calendar-days')}</div>
      <h4>${p.libelle}</h4>
      <p>${count} bulletin${count>1?'s':''} déjà généré${count>1?'s':''}</p>
    </div>`;
  }).join('');
  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;"><a style="cursor:pointer; color:var(--ink-soft);" onclick="setBulletinsPickerClasse(null)">← Changer de classe</a></p>
      <h2>Bulletins, ${classe.libelle}</h2>
      <p>Choisis la période à clôturer pédagogiquement.</p>
    </div>
    <div class="module-grid">${cards || '<p class="muted">Aucune période définie pour l’année académique de cette classe.</p>'}</div>
  `;
}

function setBulletinsPickerPeriode(id){ bulletinsPicker.periodeId = id; render(); }

function renderBulletinsGrid(){
  const classe = findById('classes', bulletinsPicker.classeId);
  const niveau = findById('niveaux', classe.niveauId);
  const periode = findById('periodes', bulletinsPicker.periodeId);
  const offered = creditsOffered(periode.id, classe.id);

  const inscriptions = db.inscriptions
    .filter(i=>i.classeId===classe.id && i.statut==='VALIDEE')
    .map(i=>({insc:i, etu:findById('personnes', i.etudiantId)}))
    .filter(x=>!!x.etu)
    .sort((a,b)=> a.etu.nom.localeCompare(b.etu.nom));

  const rows = inscriptions.length ? inscriptions.map(({insc,etu})=>{
    const existing = db.bulletins.find(b=>b.inscriptionId===insc.id && b.periodeId===periode.id);
    const live = computeBulletinMoyenne(insc.id, periode.id, classe.id);
    const moyenne = existing ? existing.moyenne : live;
    const moyText = moyenne!=null ? `<b>${Number(moyenne).toFixed(2)}/20</b>${!existing && live!=null ? ' <span class="muted">(non généré)</span>' : ''}` : '<span class="muted">, aucune note</span>';
    const credits = existing ? existing.creditsValides : computeCreditsValides(insc.id, periode.id, classe.id);
    const { rang, total } = computeRang(insc.id, periode.id, classe.id);
    const mention = computeMention(moyenne);
    return `<tr>
      <td>${etu.nom} ${etu.prenoms}</td>
      <td>${moyText}</td>
      <td>${moyenne!=null ? `${credits ?? 0} / ${offered}` : '—'}</td>
      <td>${moyenne!=null && rang ? `${rang} / ${total}` : '—'}</td>
      <td>${mention ? `<span class="badge ${mention==='Ajourné(e)'?'b-danger':'b-success'}"><span class="dot"></span>${mention}</span>` : '—'}</td>
      <td style="min-width:220px;">
        <input type="text" class="grade-input" style="width:100%; text-align:left;" id="appr-${insc.id}" value="${existing && existing.appreciation ? existing.appreciation.replace(/"/g,'&quot;') : ''}" placeholder="Appréciation…">
      </td>
      <td style="text-align:right; white-space:nowrap;">
        <button class="btn btn-primary btn-sm" onclick="saveBulletinRow('${insc.id}', '${periode.id}')">${existing?'Recalculer':'Générer'}</button>
        <button class="btn btn-ghost btn-sm" onclick="goTo('releve-notes','inscriptions', '${insc.id}')">Relevé</button>
      </td>
    </tr>`;
  }).join('') : `<tr class="empty-row"><td colspan="7">Aucun élève avec une inscription validée dans cette classe.</td></tr>`;

  return `
    <div class="page-head">
      <p class="crumb" style="margin:0 0 8px;">
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setBulletinsPickerClasse(null)">← Classe</a>
        <span class="crumb-sep">/</span>
        <a style="cursor:pointer; color:var(--ink-soft);" onclick="setBulletinsPickerPeriode(null)">Changer de période</a>
      </p>
      <h2>Bulletins, ${classe.libelle} · ${periode.libelle}</h2>
      <p>Niveau ${niveau ? niveau.libelle : '—'} · moyenne de passage ${niveau ? niveau.moyennePassage : 10}/20. Moyenne, crédits et rang sont recalculés depuis les notes de la période (RG : impossible tant qu'aucune note n'est saisie pour l'élève).</p>
    </div>
    <div class="panel">
      <div class="panel-head">
        <h3>Élèves de la classe</h3>
        <button id="btn-generer-tous-bulletins" class="btn btn-primary btn-sm" onclick="saveAllBulletins('${classe.id}', '${periode.id}')">Générer tous les bulletins</button>
      </div>
      <table class="data">
        <thead><tr><th>Élève</th><th>Moyenne</th><th>Crédits</th><th>Rang</th><th>Mention</th><th>Appréciation</th><th></th></tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
  `;
}

function computeCreditsValides(inscriptionId, periodeId, classeId){
  const matieres = matieresForClasse(classeId, periodeId);
  let total = 0;
  matieres.forEach(m=>{
    const moy = matiereMoyenne(inscriptionId, m.id, periodeId);
    if(moy!=null && moy>=10) total += Number(m.credits||0);
  });
  return total;
}

function computeRang(inscriptionId, periodeId, classeId){
  const classmates = db.inscriptions.filter(i=>i.classeId===classeId && i.statut==='VALIDEE');
  const scored = classmates.map(i=>({id:i.id, moy: computeBulletinMoyenne(i.id, periodeId, classeId)})).filter(s=>s.moy!=null);
  scored.sort((a,b)=>b.moy-a.moy);
  const idx = scored.findIndex(s=>s.id===inscriptionId);
  return {rang: idx>=0 ? idx+1 : null, total: scored.length};
}

function renderWizard(){
  if(!wizard) wizard = {mode:null, step:0, data:{}, maxStep:0};
  let body;
  const isDone = wizard.mode && wizard.step < (wizard.maxStep||0) && wizard.step < wizardTotalSteps();
  if(!wizard.mode){
    body = wizardStep0();
  } else if(wizard.mode==='NOUVELLE'){
    if(wizard.step===1) body = wizardStepEtudiant();
    else if(wizard.step===2) body = wizardStepParent();
    else if(wizard.step===3) body = wizardStepInscription();
    else if(wizard.step===4) body = wizardStepDocuments();
    else body = wizard.data.fullDemo ? wizardStepFinal() : wizardStepInscriptionDone();
  } else if(wizard.mode==='CAISSE'){
    if(wizard.step===1) body = wizardStepEcheancier();
    else if(wizard.step===2) body = wizardStepVersement();
    else body = wizardStepFinal();
    if(wizard.step===1 || wizard.step===2){
      body = `<div style="display:flex; gap:20px; align-items:flex-start; flex-wrap:wrap;">
        <div style="width:260px; flex:none;">${wizardStudentSidebarCard()}</div>
        <div style="flex:1; min-width:320px;">${body}</div>
      </div>`;
    }
  } else {
    if(wizard.step===1) body = wizardStepSelectEtudiant();
    else if(wizard.step===2) body = wizardStepInscription();
    else if(wizard.step===3) body = wizardStepDocuments();
    else body = wizard.data.fullDemo ? wizardStepFinal() : wizardStepInscriptionDone();
  }
  const skipBtn = (wizard.mode && wizard.mode!=='CAISSE' && wizard.step<wizardTotalSteps()) ? `<button class="btn btn-ghost" onclick="wizardSkipToEnd()">${icon('skip-forward')} Passer directement au résultat</button>` : '';
  return `
    <div class="page-head" style="display:flex; justify-content:space-between; align-items:flex-end; gap:16px; flex-wrap:wrap;">
      <div>
        <h2>Parcours de démonstration</h2>
        <p>${wizard.mode ? "Ce parcours crée de vrais enregistrements dans les tables ci-contre. Tu peux ensuite les retrouver dans les modules correspondants." : "Choisis le type de démarche pour démarrer le bon parcours."}</p>
      </div>
      ${skipBtn}
    </div>
    ${wizard.mode ? wizardStepsBar() : ''}
    ${body}
  `;
}

function wizardTotalSteps(){
  if(wizard.mode==='CAISSE') return 3;
  return wizard.mode==='NOUVELLE' ? 4 : 3;
}

function wizardStep0(){
  return `
    <div style="display:flex; gap:16px; flex-wrap:wrap;">
      <div class="module-card" style="flex:1; min-width:240px;" onclick="chooseWizardMode('NOUVELLE')">
        <span class="mod-arrow">→</span>
        <div class="mod-ico">${icon('user-plus')}</div>
        <h4>Nouvelle inscription</h4>
        <p>Un étudiant qui n'existe pas encore dans le registre : ses informations, celles d'un parent/tuteur et le lien de parenté, puis l'inscription.</p>
      </div>
      <div class="module-card" style="flex:1; min-width:240px;" onclick="chooseWizardMode('REINSCRIPTION')">
        <span class="mod-arrow">→</span>
        <div class="mod-ico">${icon('repeat')}</div>
        <h4>Réinscription</h4>
        <p>Un étudiant déjà connu : vérification des arriérés éventuels et de sa moyenne pour le passage en classe supérieure, puis la nouvelle inscription.</p>
      </div>
    </div>
  `;
}

function wizardRecapEtudiant(){
  const etu = findById('personnes', wizard.data.etudiantId);
  return wizardRecapCard(
    `Étape 1 sur ${wizardTotalSteps()} · Module Personnes → entité Étudiant`,
    'Étudiant déjà enregistré',
    [
      ['Nom complet', etu ? etu.prenoms+' '+etu.nom : '—'],
      ['Numéro étudiant', etu ? (etu.numeroEtudiant||'—') : '—'],
      ['Sexe', etu ? titleCase(etu.sexe) : '—'],
      ['Date de naissance', etu ? fmtDate(etu.dateNaissance) : '—']
    ],
    etu ? `openForm('personnes', '${etu.id}')` : ''
  );
}

function wizardRecapCard(eyebrow, title, rows, editOnclick){
  return `
    <div class="wizard-card">
      <div class="eyebrow">${eyebrow}</div>
      <h3>${title}</h3>
      <div class="doc-note ok" style="margin:14px 0;">${icon('check','icon-sm')} Cette étape a déjà été enregistrée. Tu peux avancer, ou modifier l'enregistrement si besoin.</div>
      <div class="detail-grid">${rows.map(r=>`<div class="kv"><div class="k">${r[0]}</div><div class="v">${r[1]}</div></div>`).join('')}</div>
      <div class="wizard-foot" style="margin-top:16px; justify-content:space-between;">
        ${wizardBackBtn()}
        <div style="display:flex; gap:8px;">
          ${editOnclick ? `<button class="btn btn-ghost" onclick="${editOnclick}">Modifier</button>` : ''}
          <button class="btn btn-primary" onclick="wizardAdvance()">Continuer →</button>
        </div>
      </div>
    </div>
  `;
}

function wizardBackBtn(){
  if(wizard.mode==='CAISSE' && wizard.step<=1) return `<button class="btn btn-ghost" onclick="goTo('report','caissePending')">← Retour à la Caisse</button>`;
  if(wizard.step<=1) return `<button class="btn btn-ghost" onclick="resetWizard()">← Changer de type de parcours</button>`;
  return `<button class="btn btn-ghost" onclick="wizardGoToStep(${wizard.step-1})">← Précédent</button>`;
}

function resetWizard(){ wizard = {mode:null, step:0, data:{}, maxStep:0}; render(); }

/** `chooseWizardMode` de la maquette : démarre le parcours « Nouvelle inscription » ou « Réinscription » choisi en tête du parcours de démonstration. */
function chooseWizardMode(mode){
  wizard = {mode, step:1, maxStep:1, data:{}};
  render();
}

function wizardGoToStep(n){
  if(n<1 || n>(wizard.maxStep||1)) return;
  wizard.step = n;
  render();
}

function wizardAdvance(){ wizard.step += 1; render(); }

function wizardStepEtudiant(){
  const ex = wizard.data.etudiantId ? findById('personnes', wizard.data.etudiantId) : null;
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape 1 sur ${wizardTotalSteps()} · Module Personnes → entité Étudiant</div>
      <h3>${ex ? 'Modifier l\'étudiant' : 'Créer un étudiant'}</h3>
      <div class="desc">On commence par enregistrer la personne qui va être inscrite. Ces champs correspondent à la classe <b>Étudiant</b> (héritant de <b>Personne</b>).</div>
      <div class="field-grid">
        <div class="field"><label>Prénoms <span class="req">*</span></label><input id="w-prenoms" value="${ex ? ex.prenoms : 'Fatou'}"></div>
        <div class="field"><label>Nom <span class="req">*</span></label><input id="w-nom" value="${ex ? ex.nom : 'Coulibaly'}"></div>
        <div class="field"><label>Sexe</label><select id="w-sexe">
          <option value="FEMININ" ${(ex?ex.sexe:'FEMININ')==='FEMININ'?'selected':''}>FEMININ</option>
          <option value="MASCULIN" ${(ex?ex.sexe:'')==='MASCULIN'?'selected':''}>MASCULIN</option>
        </select></div>
        <div class="field"><label>Date de naissance</label><input type="date" id="w-dn" value="${ex ? ex.dateNaissance : '2003-05-10'}"></div>
        <div class="field"><label>Numéro d'étudiant</label><input id="w-numetu" value="${ex && ex.numeroEtudiant ? ex.numeroEtudiant : ''}" placeholder="généré automatiquement si vide"></div>
        <div class="field"><label>Date d'entrée</label><input type="date" id="w-dateentree" value="${ex && ex.dateEntree ? ex.dateEntree : todayISO()}"></div>
        <div class="field"><label>Téléphone</label><input id="w-etu-tel" value="${ex && ex.telephone ? ex.telephone : ''}" placeholder="07 00 00 00 00"></div>
        <div class="field"><label>Email</label><input id="w-etu-email" value="${ex && ex.email ? ex.email : ''}" placeholder="etudiant@exemple.ci"></div>
      </div>
      <div class="wizard-foot">
        ${wizardBackBtn()}
        <button class="btn btn-primary" onclick="wizardCreateEtudiant()">${ex ? 'Enregistrer et continuer' : 'Valider et continuer'} →</button>
      </div>
    </div>
  `;
}

function wizardRecapParent(){
  const parent = findById('personnes', wizard.data.parentId);
  const lien = db.liensParentaux.find(l=>l.etudiantId===wizard.data.etudiantId && l.parentId===wizard.data.parentId);
  return wizardRecapCard(
    `Étape 2 sur ${wizardTotalSteps()} · Module Personnes → entités Parent + Lien parental`,
    'Parent déjà enregistré',
    [
      ['Nom complet', parent ? parent.prenoms+' '+parent.nom : '—'],
      ['Téléphone', parent ? (parent.telephone||'—') : '—'],
      ['Type de lien', lien ? titleCase(lien.typeLien) : '—'],
      ['Payeur', lien && lien.estPayeur ? 'Oui' : 'Non']
    ],
    parent ? `openForm('personnes', '${parent.id}')` : ''
  );
}

function wizardStepParent(){
  const ex = wizard.data.parentId ? findById('personnes', wizard.data.parentId) : null;
  const lien = ex ? db.liensParentaux.find(l=>l.etudiantId===wizard.data.etudiantId && l.parentId===wizard.data.parentId) : null;
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape 2 sur ${wizardTotalSteps()} · Module Personnes → entités Parent + Lien parental</div>
      <h3>${ex ? 'Modifier le parent / tuteur' : 'Informations du parent / tuteur'}</h3>
      <div class="desc">On rattache un parent ou tuteur à l'étudiant, avec le type de lien de parenté.</div>
      <div class="field-grid">
        <div class="field"><label>Prénoms <span class="req">*</span></label><input id="w-p-prenoms" value="${ex ? ex.prenoms : 'Jean-Paul'}"></div>
        <div class="field"><label>Nom <span class="req">*</span></label><input id="w-p-nom" value="${ex ? ex.nom : 'Coulibaly'}"></div>
        <div class="field"><label>Sexe</label><select id="w-p-sexe">
          <option value="MASCULIN" ${(ex?ex.sexe:'MASCULIN')==='MASCULIN'?'selected':''}>MASCULIN</option>
          <option value="FEMININ" ${(ex?ex.sexe:'')==='FEMININ'?'selected':''}>FEMININ</option>
        </select></div>
        <div class="field"><label>Date de naissance <span class="req">*</span></label><input type="date" id="w-p-dn" value="${ex ? ex.dateNaissance : '1975-03-12'}"></div>
        <div class="field"><label>Téléphone</label><input id="w-p-tel" value="${ex && ex.telephone ? ex.telephone : '0102003040'}"></div>
        <div class="field"><label>Email</label><input id="w-p-email" value="${ex && ex.email ? ex.email : ''}" placeholder="parent@exemple.ci"></div>
        <div class="field"><label>Profession</label><input id="w-p-profession" value="${ex && ex.profession ? ex.profession : ''}" placeholder="ex. Ingénieur BTP"></div>
        <div class="field"><label>Employeur</label><input id="w-p-employeur" value="${ex && ex.employeur ? ex.employeur : ''}" placeholder="ex. CIE"></div>
        <div class="field"><label>Type de lien</label><select id="w-p-lien">
          <option value="PERE" ${(lien?lien.typeLien:'')==='PERE'?'selected':''}>Père</option>
          <option value="MERE" ${(lien?lien.typeLien:'')==='MERE'?'selected':''}>Mère</option>
          <option value="TUTEUR" ${(lien?lien.typeLien:'')==='TUTEUR'?'selected':''}>Tuteur</option>
          <option value="AUTRE" ${(lien?lien.typeLien:'')==='AUTRE'?'selected':''}>Autre</option>
        </select></div>
        <div class="field"><label>Ordre de priorité</label><input type="number" id="w-p-ordre" value="${lien && lien.ordrePriorite!=null ? lien.ordrePriorite : 1}" min="1"></div>
      </div>
      <div class="field-check-row">
        <div class="field-check"><input type="checkbox" id="w-p-payeur" ${!lien || lien.estPayeur ? 'checked' : ''}><label style="margin:0;">Payeur</label></div>
        <div class="field-check"><input type="checkbox" id="w-p-urgence" ${!lien || lien.estContactUrgence ? 'checked' : ''}><label style="margin:0;">Contact d'urgence</label></div>
      </div>
      <div class="wizard-foot" style="margin-top:16px;">
        ${wizardBackBtn()}
        <button class="btn btn-primary" onclick="wizardCreateParent()">${ex ? 'Enregistrer et continuer' : 'Valider et continuer'} →</button>
      </div>
    </div>
  `;
}

function wizardRecapInscription(){
  const insc = findById('inscriptions', wizard.data.inscriptionId);
  const classe = insc && insc.classeId ? findById('classes', insc.classeId) : null;
  const isReinsc = wizard.mode==='REINSCRIPTION';
  return wizardRecapCard(
    `Étape ${isReinsc?2:3} sur ${wizardTotalSteps()} · Module Inscription → entité Inscription`,
    'Inscription déjà créée',
    [
      ['Numéro', insc ? insc.numero : '—'],
      ['Classe', classe ? classe.libelle : '—'],
      ['Type', insc ? titleCase(insc.typeInscription) : '—'],
      ['Statut', insc ? titleCase(insc.statut) : '—']
    ],
    insc ? `openForm('inscriptions', '${insc.id}')` : ''
  );
}

function wizardStepInscription(){
  const annee = currentAnnee();
  const isReinsc = wizard.mode==='REINSCRIPTION';
  const ex = wizard.data.inscriptionId ? findById('inscriptions', wizard.data.inscriptionId) : null;
  const classesEcole = db.classes.filter(c=>c.ecoleId===currentEcoleId);
  const selectedClasseId = ex ? ex.classeId : wizard.data.suggestedClasseId;
  const classesOpts = classesEcole
    .map(c=>`<option value="${c.id}" ${selectedClasseId===c.id?'selected':''}>${c.libelle}</option>`).join('');
  const initialClasseId = selectedClasseId || (classesEcole[0]||{}).id;
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape ${isReinsc?2:3} sur ${wizardTotalSteps()} · Module Inscription → entité Inscription</div>
      <h3>${ex ? "Modifier l'inscription" : (isReinsc ? 'Confirmer la réinscription' : "Créer l'inscription")}</h3>
      <div class="desc">On rattache l'étudiant à une classe pour l'année académique courante (${annee.libelle}).${isReinsc && !ex ? " La classe suggérée d'après sa moyenne est pré-sélectionnée, modifiable si besoin." : ''}</div>
      <div class="field-grid">
        <div class="field"><label>Classe</label><select id="w-classe" onchange="wizardOnClasseChange()">${classesOpts}</select></div>
        <div class="field"><label>Type d'inscription</label><select id="w-type">
          ${isReinsc ? `<option value="REINSCRIPTION" selected>Réinscription</option>` : `<option value="NOUVELLE" selected>Nouvelle</option>`}
        </select></div>
        <div class="field"><label>Date de demande</label><input type="date" id="w-datedemande" value="${ex && ex.dateDemande ? ex.dateDemande : todayISO()}"></div>
      </div>
      <div class="doc-note" id="w-frais-preview">${wizardFraisPreviewHTML(initialClasseId)}</div>
      <div class="wizard-foot">
        ${wizardBackBtn()}
        <button class="btn btn-primary" onclick="wizardCreateInscription('${annee.id}')">${ex ? 'Enregistrer et continuer' : 'Valider et continuer'} →</button>
      </div>
    </div>
  `;
}

function wizardOnClasseChange(){
  const classeId = document.getElementById('w-classe').value;
  const box = document.getElementById('w-frais-preview');
  if(box) box.innerHTML = wizardFraisPreviewHTML(classeId);
}

function wizardFraisPreviewHTML(classeId){
  const classe = findById('classes', classeId);
  if(!classe) return `Aucun tarif configuré pour cette classe.`;
  const tarifScol = wizardTarifForClasse(classeId);
  const tarifInsc = wizardFraisInscriptionForClasse(classeId);
  const parts = [];
  if(tarifInsc) parts.push(`Frais d'inscription : <b>${fmtMoney(tarifInsc.montant)}</b>, à régler en une fois, non exonérable`);
  if(tarifScol) parts.push(`Frais de scolarité : <b>${fmtMoney(tarifScol.montant)}</b> en ${tarifScol.nombreTranches} tranche${tarifScol.nombreTranches>1?'s':''}`);
  if(!parts.length) return `Aucun tarif configuré pour cette classe.`;
  return `Frais pour <b>${classe.libelle}</b> :<br>${parts.join('<br>')}`;
}

function wizardTarifForClasse(classeId){
  const classe = findById('classes', classeId);
  const tarif = classe ? db.tarifications.find(t=>isTarifKind(t,'SCOLARITE') && t.niveauId===classe.niveauId && t.ecoleId===currentEcoleId) : null;
  return tarif || db.tarifications[0] || null;
}

function wizardFraisInscriptionForClasse(classeId){
  const classe = findById('classes', classeId);
  if(!classe) return null;
  return db.tarifications.find(t=>isTarifKind(t,'INSCRIPTION') && t.niveauId===classe.niveauId && t.ecoleId===currentEcoleId) || null;
}

function wizardRecapDocuments(){
  const types = typesDocumentForClasse(wizard.data.classeId);
  const requis = types.filter(t=>t.obligatoire).length;
  const validesCount = (wizard.data.documentIds||[]).length;
  const isReinsc = wizard.mode==='REINSCRIPTION';
  return wizardRecapCard(
    `Étape ${isReinsc?3:4} sur ${wizardTotalSteps()} · Module Inscription → entité Documents du dossier`,
    'Dossier documentaire déjà traité',
    [
      ['Documents obligatoires pour cette offre/niveau', String(requis)],
      ['Documents validés lors du parcours', String(validesCount)]
    ],
    `goTo('detail','inscriptions', '${wizard.data.inscriptionId}')`
  );
}

function wizardStepDocuments(){
  const classe = findById('classes', wizard.data.classeId);
  const isReinsc = wizard.mode==='REINSCRIPTION';
  const types = typesDocumentForClasse(wizard.data.classeId);
  const dejaValides = wizard.data.inscriptionId ? new Set(db.documentsDossier.filter(d=>d.inscriptionId===wizard.data.inscriptionId && d.statut==='VALIDE').map(d=>d.typeDocumentId)) : null;
  const rows = types.map(t=>`
    <label class="field-check" style="display:flex; align-items:flex-start; gap:10px; margin-bottom:12px;">
      <input type="checkbox" class="w-doc-check" data-id="${t.id}" ${dejaValides ? (dejaValides.has(t.id)?'checked':'') : (t.obligatoire?'checked':'')} style="margin-top:3px;">
      <span>
        <b>${t.libelle}</b>${t.obligatoire?' <span class="req">*</span>':''}
        <br><span class="muted" style="font-size:11.5px;">${t.formatAccepte||'—'}</span>
      </span>
    </label>`).join('');
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape ${isReinsc?3:4} sur ${wizardTotalSteps()} · Module Inscription → entité Documents du dossier</div>
      <h3>Dossier documentaire</h3>
      <div class="desc">Les pièces exigées dépendent de l'offre et du niveau de <b>${classe.libelle}</b>, deux filières au même niveau peuvent avoir des exigences différentes. Coche celles que l'étudiant a déjà fournies, elles seront enregistrées comme validées.</div>
      ${types.length ? `<label class="field-check" style="display:flex; align-items:center; gap:10px; margin-bottom:14px; padding:10px 14px; border-radius:10px; background:var(--primary-soft); color:var(--primary-dark);">
        <input type="checkbox" id="w-doc-check-all" onchange="document.querySelectorAll('.w-doc-check').forEach(c=>c.checked=this.checked)" style="width:18px; height:18px; accent-color:var(--primary-dark);">
        <b>Tout cocher</b>
      </label>
      ${rows}` : `<div class="doc-note">Aucun type de document configuré pour cette offre et ce niveau.</div>`}
      <button class="btn btn-ghost btn-sm" style="margin-bottom:14px;" onclick="openForm('typesDocument', null, {offreIds:['${classe.offreId}'], niveauIds:['${classe.niveauId}']})">+ ${types.length ? 'Ajouter un autre' : 'Créer un'} type de document</button>
      <div class="wizard-foot">
        ${wizardBackBtn()}
        <button class="btn btn-primary" onclick="wizardValidateDocuments()">Continuer →</button>
      </div>
    </div>
  `;
}

function wizardStepFinal(){
  const etudiant = findById('personnes', wizard.data.etudiantId);
  const inscription = findById('inscriptions', wizard.data.inscriptionId);
  const classe = findById('classes', wizard.data.classeId);
  const versementInsc = findById('versements', wizard.data.versementInscriptionId);
  const versementScol = wizard.data.versementScolariteId ? findById('versements', wizard.data.versementScolariteId) : null;
  const recuInsc = findById('recus', wizard.data.recuInscId);
  const recuScol = wizard.data.recuScolId ? findById('recus', wizard.data.recuScolId) : null;
  const versementsExtra = (wizard.data.versementExtraIds||[]).map(id=>findById('versements', id)).filter(Boolean);
  const totalExtra = versementsExtra.reduce((s,v)=>s+Number(v.montant),0);
  const totalVerseAujourdhui = Number(versementInsc.montant) + (versementScol ? Number(versementScol.montant) : 0) + totalExtra;
  const carte = findById('cartesEtudiantes', wizard.data.carteId);
  const lignes = db.lignesEcheance.filter(l=>l.echeancierId===wizard.data.echeancierId);
  const totalDu = lignes.reduce((s,l)=>s+l.montantDu,0);
  const resteAPayer = totalDu - (versementScol ? Number(versementScol.montant) : 0);
  const echeancier = findById('echeanciers', wizard.data.echeancierId);
  const isReinsc = wizard.mode==='REINSCRIPTION';
  const isCaisse = wizard.mode==='CAISSE';
  const skipPersonnes = isReinsc || isCaisse;
  const skipInscriptionDocs = isCaisse;
  const reductionsAppliquees = db.reductionsAppliquees.filter(r=>r.inscriptionId===inscription.id);
  const totalReduction = reductionsAppliquees.reduce((s,r)=>s+Number(r.montantCalcule),0);
  const reductionRow = totalReduction>0
    ? `<div class="r-row"><span>Réduction appliquée</span><span>− ${fmtMoney(totalReduction)}</span></div>`
    : '';

  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape ${wizardTotalSteps()} sur ${wizardTotalSteps()} · Modules 5. Finance + 4. Inscription → Reçu et Carte étudiante</div>
      <h3>Reçu et carte émis</h3>
      <div class="desc">Le parcours a créé un enregistrement lié dans ${skipInscriptionDocs ? 'le module Finance' : `chacun des modules ${skipPersonnes?'':'Personnes, '}Inscription et Finance`}. Récapitulatif :</div>
      <div class="receipt">
        <div class="r-seal">${icon('check')}</div>
        <div class="r-eyebrow">Reçu(s) de paiement</div>
        <div class="r-title">${recuInsc.numero}${recuScol?' · '+recuScol.numero:''}</div>
        <div class="r-row"><span>Étudiant</span><span>${etudiant.prenoms} ${etudiant.nom}</span></div>
        <div class="r-row"><span>Inscription</span><span>${inscription.numero}, ${classe.libelle}</span></div>
        <div class="r-row"><span>Carte étudiante</span><span>${carte.numeroCarte}</span></div>
        <div class="r-row"><span>Scolarité brute (échéancier)</span><span>${fmtMoney(echeancier.montantBrut)}</span></div>
        ${reductionRow}
        <div class="r-row"><span>Scolarité nette</span><span>${fmtMoney(echeancier.montantNet)}</span></div>
        <div class="r-row"><span>Frais d'inscription réglés</span><span>${fmtMoney(versementInsc.montant)}</span></div>
        <div class="r-row"><span>1er versement de scolarité</span><span>${versementScol ? fmtMoney(versementScol.montant) : 'Non réglé à ce stade'}</span></div>
        ${versementsExtra.map(v=>{
          const type = findById('tarifications', v.tarificationId);
          return `<div class="r-row"><span>${type?type.libelle:'Autre frais'} (réglé aujourd'hui)</span><span>${fmtMoney(v.montant)}</span></div>`;
        }).join('')}
        <div class="r-row"><span>Total versé aujourd'hui</span><span><b>${fmtMoney(totalVerseAujourdhui)}</b></span></div>
        <div class="r-row"><span>Mode de paiement</span><span>${titleCase(versementInsc.modePaiement)}</span></div>
        <div class="r-row"><span>Reste à payer (scolarité)</span><span>${fmtMoney(Math.max(resteAPayer,0))}</span></div>
      </div>
      <div class="wizard-foot">
        ${wizardBackBtn()}
        <div style="display:flex; gap:8px;">
          <button class="btn" onclick="resetWizard()">Recommencer un nouveau parcours</button>
          <button class="btn btn-primary" onclick="openRecuInscription('${inscription.id}', ['${versementInsc.id}'${versementScol?", '"+versementScol.id+"'":''}${versementsExtra.length?", '"+versementsExtra.map(v=>v.id).join("', '")+"'":''}])">Imprimer le reçu</button>
          <button class="btn btn-primary" onclick="goTo('detail','cartesEtudiantes', '${carte.id}')">Voir la carte étudiante</button>
        </div>
      </div>
    </div>
  `;
}

function openRecuInscription(inscriptionId, versementIds){
  recuInscriptionContext = {inscriptionId, versementIds};
  setRecuInscriptionContext({inscriptionId, versementIds});
  goTo('recu-inscription');
}

function wizardStepInscriptionDone(){
  const etudiant = findById('personnes', wizard.data.etudiantId);
  const inscription = findById('inscriptions', wizard.data.inscriptionId);
  const classe = findById('classes', wizard.data.classeId);
  return `
    <div class="wizard-card">
      <div class="eyebrow">Dossier d'inscription complet</div>
      <div class="doc-note ok" style="margin-bottom:16px;">
        ${icon('check','icon-sm')} L'étudiant, le parent, l'inscription et les documents sont enregistrés.
      </div>
      <h3>Prêt pour la Caisse</h3>
      <div class="desc">
        <b>${etudiant.prenoms} ${etudiant.nom}</b> est inscrit${etudiant.sexe==='FEMININ'?'e':''} en <b>${classe ? classe.libelle : '—'}</b>
        avec le statut <span class="badge b-warn"><span class="dot"></span>En attente de paiement</span>.
        La suite (réduction, échéancier, versement, reçu et carte) se traite maintenant depuis la Caisse, c'est là que le comptable prend le relais.
      </div>
      <div class="wizard-foot">
        <button class="btn btn-ghost" onclick="resetWizard()">Recommencer une nouvelle inscription</button>
        <div style="display:flex; gap:8px;">
          <button class="btn btn-ghost" onclick="goTo('detail','inscriptions', '${inscription.id}')">Voir le dossier</button>
          <button class="btn btn-primary" onclick="startCaisseTraitement('${inscription.id}')">Traiter en Caisse maintenant →</button>
        </div>
      </div>
    </div>
  `;
}

function wizardRecapEcheancier(){
  const ech = findById('echeanciers', wizard.data.echeancierId);
  const lignes = ech ? db.lignesEcheance.filter(l=>l.echeancierId===ech.id) : [];
  const isReinsc = wizard.mode==='REINSCRIPTION';
  return wizardRecapCard(
    `Étape ${wizardStepLabel(5,4,1)} sur ${wizardTotalSteps()} · Module Finance → entité Échéancier`,
    'Échéancier déjà généré',
    [
      ['Montant brut', ech ? fmtMoney(ech.montantBrut) : '—'],
      ['Montant net', ech ? fmtMoney(ech.montantNet) : '—'],
      ['Nombre de tranches', String(lignes.length)],
      ['Statut', ech ? titleCase(ech.statut) : '—']
    ],
    ech ? `openForm('echeanciers', '${ech.id}')` : ''
  );
}

function wizardStepLabel(nouvelleN, reinscN, caisseN){
  if(wizard.mode==='CAISSE') return caisseN;
  return wizard.mode==='REINSCRIPTION' ? reinscN : nouvelleN;
}

function wizardStudentSidebarCard(){
  const etudiant = findById('personnes', wizard.data.etudiantId);
  const classe = findById('classes', wizard.data.classeId);
  const inscription = findById('inscriptions', wizard.data.inscriptionId);
  const niveau = classe ? findById('niveaux', classe.niveauId) : null;
  const offre = classe ? findById('offres', classe.offreId) : null;
  const arrears = wizard.data.arrears || 0;
  const nom = etudiant ? `${etudiant.prenoms} ${etudiant.nom}` : '—';
  const dejaAppliquees = db.reductionsAppliquees.filter(r=>r.inscriptionId===wizard.data.inscriptionId);
  const items = [
    ['Classe', classe ? classe.libelle : '—'],
    ['Niveau', niveau ? niveau.libelle : '—'],
    ['Filière', offre ? offre.libelle : '—'],
    ['Type', inscription ? titleCase(inscription.typeInscription) : '—'],
  ];
  if(arrears>0) items.push(['Arriéré dû', fmtMoney(arrears)]);
  if(dejaAppliquees.length) items.push(['Réduction(s)', dejaAppliquees.map(r=>{
    const red = findById('reductions', r.reductionId);
    return `${red?red.libelle:'Réduction'} (− ${fmtMoney(r.montantCalcule)})`;
  }).join(', ')]);
  return `
    <div class="panel" style="padding:18px 16px;">
      <div style="display:flex; align-items:center; gap:10px; padding-bottom:14px; margin-bottom:14px; border-bottom:1px solid var(--border, #e2e2e2);">
        <div class="pf-avatar" style="width:40px; height:40px; font-size:14px;">${initialsOf(nom)}</div>
        <div>
          <div class="k muted" style="font-size:11.5px;">Étudiant</div>
          <div class="v" style="font-weight:700;">${nom}</div>
        </div>
      </div>
      <div style="display:flex; flex-direction:column; gap:12px;">
        ${items.map(([k,v])=>`<div class="kv"><div class="k muted" style="font-size:11.5px;">${k}</div><div class="v">${v}</div></div>`).join('')}
      </div>
    </div>
  `;
}

function wizardStepEcheancier(){
  const classe = findById('classes', wizard.data.classeId);
  const niveauForTarif = classe ? findById('niveaux', classe.niveauId) : null;
  const prefillNiveauId = niveauForTarif ? niveauForTarif.id : '';
  const prefillCycleId = niveauForTarif ? niveauForTarif.cycleId : '';
  const prefillAnneeId = wizard.data.anneeId || '';
  const tarif = wizardTarifForClasse(wizard.data.classeId) || db.tarifications[0];
  if(!tarif){
    return `
      <div class="wizard-card">
        <div class="eyebrow">Étape ${wizardStepLabel(5,4,1)} sur ${wizardTotalSteps()} · Module Finance → entités Réduction + Échéancier</div>
        <h3>Réduction</h3>
        <div class="doc-note warn">${icon('alert-triangle','icon-sm')} Aucune tarification configurée pour ce niveau.</div>
        <button type="button" class="btn btn-primary btn-sm" onclick="openForm('tarifications', null, {niveauId:'${prefillNiveauId}', cycleId:'${prefillCycleId}', anneeId:'${prefillAnneeId}'})">${icon('plus','icon-sm')} Créer une tarification</button>
        <div class="wizard-foot">${wizardBackBtn()}</div>
      </div>
    `;
  }
  const arrears = wizard.data.arrears || 0;
  const dejaAppliquees = db.reductionsAppliquees.filter(r=>r.inscriptionId===wizard.data.inscriptionId);
  const reductionsOpts = db.reductions.filter(r=>r.active && r.ecoleId===currentEcoleId)
    .map(r=>`<option value="${r.id}">${r.libelle} (${r.type==='POURCENTAGE' ? r.valeur+' %' : fmtMoney(r.valeur)})</option>`).join('');
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape ${wizardStepLabel(5,4,1)} sur ${wizardTotalSteps()} · Module Finance → entités Réduction + Échéancier</div>
      <h3>Réduction</h3>
      <div style="display:flex; gap:12px; flex-wrap:wrap; margin-bottom:16px;">
        <div style="flex:1; min-width:200px; padding:14px 16px; border-radius:10px; background:var(--grey-s);">
          <div class="k muted" style="font-size:11.5px; margin-bottom:4px;">Tarif de base (${(calendrierTranches((currentAnnee()||{}).id).length) || tarif.nombreTranches} tranches)</div>
          <div style="font-size:20px; font-weight:700;">${fmtMoney(tarif.montant)}</div>
        </div>
        ${arrears>0 ? `<div style="flex:1; min-width:200px; padding:14px 16px; border-radius:10px; background:var(--danger-soft); color:var(--danger);">
          <div style="font-size:11.5px; margin-bottom:4px;">Arriéré détecté · ajouté au montant brut</div>
          <div style="font-size:20px; font-weight:700;">${fmtMoney(arrears)}</div>
        </div>` : ''}
      </div>
      ${dejaAppliquees.length ? `
      <div class="doc-note ok">${icon('check','icon-sm')} ${dejaAppliquees.length>1 ? `${dejaAppliquees.length} réductions déjà appliquées depuis la Caisse (${fmtMoney(dejaAppliquees.reduce((s,r)=>s+Number(r.montantCalcule),0))}), elles seront automatiquement déduites du montant brut.` : `Une réduction est déjà appliquée depuis la Caisse (${fmtMoney(dejaAppliquees.reduce((s,r)=>s+Number(r.montantCalcule),0))}), elle sera automatiquement déduite du montant brut.`}</div>
      ` : `
      <div class="field">
        <label>Réduction à appliquer (optionnel)</label>
        <div style="display:flex; gap:8px;">
          <select id="w-reduction" style="flex:1;"><option value="">Aucune réduction</option>${reductionsOpts}</select>
          ${!reductionsOpts ? `<button type="button" class="btn btn-ghost btn-sm" onclick="openForm('reductions')">${icon('plus','icon-sm')} Nouvelle</button>` : ''}
        </div>
      </div>`}

      <div class="wizard-foot">
        ${wizardBackBtn()}
        <button class="btn btn-primary" onclick="wizardCreateEcheancier('${tarif.id}')">${wizard.data.echeancierId ? 'Enregistrer et continuer' : 'Générer et continuer'} →</button>
      </div>
    </div>
  `;
}

function wizardRemoveFraisSupp(idx){
  wizard.data.fraisSupp.splice(idx,1);
  render();
}

function wizardAddFraisVersement(slot){
  const tarifId = document.getElementById(`w-frais-${slot}-tarif`).value;
  const tarif = findById('tarifications', tarifId);
  if(!tarif){ showToast('Choisis un type de frais.'); return; }
  if(!wizard.data[slot]) wizard.data[slot] = [];
  wizard.data[slot].push({montant:Number(tarif.montant), tarificationId:tarif.id});
  render();
}

function wizardRemoveFraisVersement(slot, idx){
  wizard.data[slot].splice(idx,1);
  render();
}

function calendrierTranches(anneeId){
  return db.tranches.filter(t => t.anneeId === anneeId).slice().sort((a, b) => a.ordre - b.ordre);
}

function wizardAddFraisSupp(){
  const tarifId = document.getElementById('w-frais-tarif').value;
  const tarif = findById('tarifications', tarifId);
  if(!tarif){ showToast('Choisis une tarification.'); return; }
  if(!wizard.data.fraisSupp) wizard.data.fraisSupp = [];
  wizard.data.fraisSupp.push({montant:Number(tarif.montant), tarificationId:tarif.id});
  render();
}

function wizardRecapVersement(){
  const vInsc = wizard.data.versementInscriptionId ? findById('versements', wizard.data.versementInscriptionId) : null;
  const vScol = wizard.data.versementScolariteId ? findById('versements', wizard.data.versementScolariteId) : null;
  const isReinsc = wizard.mode==='REINSCRIPTION';
  const typeLabel = v => { const t = v ? findById('tarifications', v.tarificationId) : null; return t ? t.libelle : 'Frais'; };
  const rows = [];
  if(vInsc) rows.push([`${typeLabel(vInsc)} réglés`, fmtMoney(vInsc.montant)]);
  rows.push([vScol ? `${typeLabel(vScol)} (2e versement)` : '2e versement', vScol ? fmtMoney(vScol.montant) : 'Non réglé à ce stade']);
  if(vInsc) rows.push(['Mode de paiement', titleCase(vInsc.modePaiement)]);
  if(vInsc) rows.push(['Date', fmtDate(vInsc.datePaiement)]);
  return wizardRecapCard(
    `Étape ${wizardStepLabel(6,5,2)} sur ${wizardTotalSteps()} · Module Finance → entité Versement`,
    'Versement(s) déjà enregistré(s)',
    rows,
    vInsc ? `openForm('versements', '${vInsc.id}')` : ''
  );
}

function wizardStepVersement(){
  const lignes = db.lignesEcheance.filter(l=>l.echeancierId===wizard.data.echeancierId).slice().sort((a,b)=>a.numeroTranche-b.numeroTranche);
  const first = lignes[0];
  const isReinsc = wizard.mode==='REINSCRIPTION';
  const classe = findById('classes', wizard.data.classeId);
  const tarifInsc = wizardFraisInscriptionForClasse(wizard.data.classeId);
  const montantInsc = tarifInsc ? Number(tarifInsc.montant) : 0;
  const rows = lignes.map(l=>`<tr><td>${l.libelle}</td><td>${fmtMoney(l.montantDu)}</td><td>${fmtDate(l.dateEcheance)}</td></tr>`).join('');
  const tarifsNiveau = classe ? db.tarifications.filter(t=>t.niveauId===classe.niveauId && t.ecoleId===currentEcoleId) : [];
  const exVersInsc = wizard.data.versementInscriptionId ? findById('versements', wizard.data.versementInscriptionId) : null;
  const exVersScol = wizard.data.versementScolariteId ? findById('versements', wizard.data.versementScolariteId) : null;
  const selectedTarifInscId = exVersInsc ? exVersInsc.tarificationId : (tarifInsc && tarifInsc.id);
  const tarifScolDefaut = wizardTarifForClasse(wizard.data.classeId);
  const selectedTarifScolId = exVersScol ? exVersScol.tarificationId : (tarifScolDefaut && tarifScolDefaut.id);
  const montantScolValue = exVersScol ? exVersScol.montant : (first?first.montantDu:0);
  const modeValue = exVersInsc ? exVersInsc.modePaiement : 'MOBILE_MONEY';
  const dateValue = exVersInsc ? exVersInsc.datePaiement : todayISO();
  const modeOpts = [['MOBILE_MONEY','MOBILE MONEY'],['ESPECES','ESPÈCES'],['VIREMENT','VIREMENT'],['CHEQUE','CHÈQUE']]
    .map(([v,l])=>`<option value="${v}" ${modeValue===v?'selected':''}>${l}</option>`).join('');
  if(!wizard.data.fraisVersement1) wizard.data.fraisVersement1 = [];
  if(!wizard.data.fraisVersement2) wizard.data.fraisVersement2 = [];
  const fraisVersementOpts = tarifsNiveau.map(t=>`<option value="${t.id}">${t.libelle}, ${fmtMoney(t.montant)}</option>`).join('');
  const fraisVersementRows = slot => wizard.data[slot].map((f,idx)=>{
    const type = findById('tarifications', f.tarificationId);
    return `<div class="fk-added-row">
      <span>${type?type.libelle:'—'}</span>
      <b>${fmtMoney(f.montant)}</b>
      <button class="btn-icon" onclick="wizardRemoveFraisVersement('${slot}', ${idx})" title="Retirer">${icon('x','icon-sm')}</button>
    </div>`;
  }).join('');
  const fraisVersementBlock = slot => `
    <div class="field" style="margin-top:12px; margin-bottom:0;">
      <label>Ajouter un autre frais réglé avec ce versement (optionnel)</label>
      <div style="display:flex; gap:8px;">
        <select id="w-frais-${slot}-tarif" style="flex:1;">${fraisVersementOpts || '<option value="">Aucune tarification disponible pour ce niveau</option>'}</select>
        ${tarifsNiveau.length ? `<button type="button" class="btn btn-ghost btn-sm" onclick="wizardAddFraisVersement('${slot}')">+ Ajouter</button>` : ''}
      </div>
      ${wizard.data[slot].length ? `<div class="fk-added-list">${fraisVersementRows(slot)}</div><div class="doc-note" style="margin-top:8px;">Total frais ajoutés : <b>${fmtMoney(wizard.data[slot].reduce((s,f)=>s+Number(f.montant),0))}</b></div>` : ''}
    </div>
  `;
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape ${wizardStepLabel(6,5,2)} sur ${wizardTotalSteps()} · Module Finance → entité Versement</div>
      <h3>${exVersInsc ? 'Modifier le(s) versement(s)' : 'Enregistrer le(s) versement(s)'}</h3>

      <div style="display:flex; gap:12px; padding:16px; margin-bottom:14px; border-radius:10px; background:var(--orange-s);">
        <div style="width:24px; height:24px; border-radius:50%; background:var(--orange); color:var(--on-orange); display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:700; flex:none;">1</div>
        <div style="flex:1; min-width:0;">
          <div style="font-weight:700; color:var(--orange-t); margin-bottom:10px;">Versement 1 — Frais d'inscription, à régler aujourd'hui : ${fmtMoney(montantInsc)}</div>
          <input type="hidden" id="w-type-insc" value="${selectedTarifInscId||''}">
          ${fraisVersementBlock('fraisVersement1')}
        </div>
      </div>

      <div class="field">
        <label>Règle-t-il aussi un premier versement de scolarité aujourd'hui ?</label>
        <select id="w-pay-choice" onchange="wizardOnPayChoiceChange()">
          <option value="INSC_PLUS_SCOL" ${!exVersInsc || exVersScol ? 'selected' : ''}>Oui, versement supplémentaire aujourd'hui</option>
          <option value="INSC_ONLY" ${exVersInsc && !exVersScol ? 'selected' : ''}>Non, un seul versement pour l'instant</option>
        </select>
      </div>

      <div id="w-scol-wrap" style="display:flex; gap:12px; padding:16px; margin-bottom:16px; border-radius:10px; background:var(--primary-soft);">
        <div style="width:24px; height:24px; border-radius:50%; background:var(--primary); color:var(--on-primary); display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:700; flex:none;">2</div>
        <div style="flex:1; min-width:0;">
          <div style="font-weight:700; color:var(--primary-dark); margin-bottom:10px;">Versement 2 — Scolarité</div>
          <input type="hidden" id="w-type-scol" value="${selectedTarifScolId||''}">
          <details style="margin-bottom:12px;">
            <summary style="cursor:pointer; font-size:13px; color:var(--primary-dark); font-weight:600;">Voir l'échéancier complet (${lignes.length} tranches)</summary>
            <table class="lines-table" style="margin-top:8px;"><thead><tr><th>Tranche</th><th>Montant dû</th><th>Échéance</th></tr></thead><tbody>${rows}</tbody></table>
          </details>
          <div class="field">
            <label>Montant du versement (F CFA)</label>
            <input type="number" id="w-montant-scol" value="${montantScolValue}">
          </div>
        </div>
      </div>

      <div class="field-grid">
        <div class="field"><label>Mode de paiement</label><select id="w-mode">${modeOpts}</select></div>
        <div class="field"><label>Date de paiement</label><input type="date" id="w-datepaiement" value="${dateValue}"></div>
      </div>
      <div class="wizard-foot">
        ${wizardBackBtn()}
        <button class="btn btn-primary" onclick="wizardCreateVersement()">${exVersInsc ? 'Enregistrer et continuer' : 'Enregistrer et continuer'} →</button>
      </div>
    </div>
  `;
}

function wizardOnPayChoiceChange(){
  const wrap = document.getElementById('w-scol-wrap');
  if(wrap) wrap.style.display = document.getElementById('w-pay-choice').value==='INSC_ONLY' ? 'none' : '';
}

/** Classe suggérée pour une réinscription : niveau suivant dans la même offre si l'étudiant est admis d'après son dernier bilan annuel, sinon son niveau actuel. */
function suggestedClasseForReinscription(etudiantId){
  const inscs = db.inscriptions.filter(i=>i.etudiantId===etudiantId && i.classeId).slice().sort((a,b)=>String(b.dateDemande||'').localeCompare(String(a.dateDemande||'')));
  const last = inscs[0];
  if(!last) return null;
  const classe = findById('classes', last.classeId);
  if(!classe) return null;
  const bilan = computeBilanAnnuel(last);
  const no = db.niveauOffre.find(n=>n.offreId===classe.offreId && n.niveauId===classe.niveauId);
  const annee = currentAnnee();
  const targetNiveauId = (bilan && bilan.decision==='ADMIS' && no)
    ? (db.niveauOffre.find(n=>n.offreId===classe.offreId && n.ordreDansOffre===no.ordreDansOffre+1)||{}).niveauId
    : classe.niveauId;
  if(!targetNiveauId) return null;
  const target = db.classes.find(c=>c.offreId===classe.offreId && c.niveauId===targetNiveauId && c.ecoleId===currentEcoleId && (!annee || c.anneeId===annee.id));
  return target ? target.id : null;
}

/** Rappel affiché sous la recherche d'étudiant : arriérés en cours et résultat de la dernière année, informatif (ne bloque pas la réinscription). */
function wizardEtudiantCheckHTML(etudiantId){
  const etu = findById('personnes', etudiantId);
  if(!etu) return '';
  const arrears = studentArrears(etudiantId);
  const inscs = db.inscriptions.filter(i=>i.etudiantId===etudiantId && i.classeId).slice().sort((a,b)=>String(b.dateDemande||'').localeCompare(String(a.dateDemande||'')));
  const bilan = inscs[0] ? computeBilanAnnuel(inscs[0]) : null;
  const bilanHtml = bilan
    ? `Moyenne annuelle ${bilan.moyenneAnnuelle}/20 (seuil ${bilan.seuil}) : <b>${bilan.decision==='ADMIS'?'Admis(e)':'Redouble'}</b>`
    : `Aucun bulletin trouvé pour l'année précédente.`;
  const arrearsHtml = arrears>0 ? `Arriéré en cours : <b>${fmtMoney(arrears)}</b>` : `Aucun arriéré en cours.`;
  return `<div class="doc-note ${arrears>0?'warn':'ok'}" style="margin-top:10px;">${icon(arrears>0?'alert-triangle':'check','icon-sm')} ${etu.prenoms} ${etu.nom} — ${bilanHtml}<br>${arrearsHtml}</div>`;
}

/** Câble la recherche d'étudiant de `wizardStepSelectEtudiant` (l'équivalent de `initFormSearchableFks`/`initCascadeInscription`, pour un champ hors formulaire). */
function initWizardEtudiantSelect(){
  const sel = document.getElementById('w-ssel-etudiant');
  if(!sel) return;
  const options = db.personnes.filter(p=>p.role==='ETUDIANT' && (!currentEcoleId || (db.inscriptions||[]).some(i=>i.etudiantId===p.id && i.ecoleId===currentEcoleId)))
    .map(p=>({value:String(p.id), label: p.prenoms+' '+p.nom+(p.numeroEtudiant?' · '+p.numeroEtudiant:'')}));
  sselSetOptions(sel, options);
  initSSel(sel, (value)=>{
    const etudiantId = value || null;
    wizard.data.reinscriptionEtudiantId = etudiantId;
    const btn = document.getElementById('w-etudiant-continue');
    if(btn) btn.disabled = !etudiantId;
    const box = document.getElementById('w-etudiant-check');
    if(box) box.innerHTML = etudiantId ? wizardEtudiantCheckHTML(etudiantId) : '';
  });
}

function wizardStepSelectEtudiant(){
  return `
    <div class="wizard-card">
      <div class="eyebrow">Étape 1 sur ${wizardTotalSteps()} · Module Personnes → sélection d'un étudiant existant</div>
      <h3>Sélectionner l'étudiant à réinscrire</h3>
      <div class="desc">Recherche parmi les étudiants déjà enregistrés dans le registre.</div>
      <div class="field">
        <label>Étudiant</label>
        <div class="ssel" id="w-ssel-etudiant">
          <input type="text" class="ssel-input" placeholder="Rechercher un étudiant…" autocomplete="off">
          <input type="hidden" class="ssel-value">
          <div class="ssel-list"></div>
        </div>
      </div>
      <div id="w-etudiant-check"></div>
      <div class="wizard-foot">
        ${wizardBackBtn()}
        <button class="btn btn-primary" id="w-etudiant-continue" onclick="wizardConfirmReinscriptionEtudiant()" disabled>Continuer →</button>
      </div>
    </div>
  `;
}

function wizardConfirmReinscriptionEtudiant(){
  if(!wizard.data.reinscriptionEtudiantId){ showToast('Sélectionne un étudiant.'); return; }
  wizard.data.etudiantId = wizard.data.reinscriptionEtudiantId;
  wizard.data.arrears = studentArrears(wizard.data.etudiantId);
  wizard.data.suggestedClasseId = suggestedClasseForReinscription(wizard.data.etudiantId);
  wizard.step = 2;
  wizard.maxStep = Math.max(wizard.maxStep||0, 2);
  render();
}

function wizardSkipToEnd(){
  if(!wizard.mode) wizard.mode = 'NOUVELLE';
  if(wizard.mode==='NOUVELLE'){
    if(!wizard.data.etudiantId){
      const id = nextId('personnes');
      db.personnes.push({id, nom:'Coulibaly', prenoms:'Fatou', sexe:'FEMININ', dateNaissance:'2003-05-10',
        numeroEtudiant:'ET-'+new Date().getFullYear()+'-'+String(id).padStart(4,'0'), dateEntree:todayISO(),
        telephone:'0700000000', email:'fatou.coulibaly@exemple.ci', role:'ETUDIANT'});
      logAudit('CREATION', 'personnes', id);
      wizard.data.etudiantId = id;
    }
    if(!wizard.data.parentId){
      const pid = nextId('personnes');
      db.personnes.push({id:pid, nom:'Coulibaly', prenoms:'Jean-Paul', sexe:'MASCULIN', dateNaissance:'',
        telephone:'0102003040', email:'jp.coulibaly@exemple.ci', profession:'Commerçant', employeur:'Indépendant', role:'PARENT'});
      logAudit('CREATION', 'personnes', pid);
      const lid = nextId('liensParentaux');
      db.liensParentaux.push({id:lid, etudiantId:wizard.data.etudiantId, parentId:pid, typeLien:'PERE', estPayeur:true, estContactUrgence:true, ordrePriorite:1});
      logAudit('CREATION', 'liensParentaux', lid);
      wizard.data.parentId = pid;
    }
  } else if(!wizard.data.etudiantId){
    const first = db.personnes.find(p=>p.role==='ETUDIANT');
    wizard.data.etudiantId = first ? first.id : null;
    wizard.data.arrears = wizard.data.etudiantId ? studentArrears(wizard.data.etudiantId) : 0;
  }
  if(!wizard.data.inscriptionId){
    const classe = db.classes.find(c=>c.ecoleId===currentEcoleId) || db.classes[0];
    const annee = currentAnnee();
    const id = nextId('inscriptions');
    db.inscriptions.push({id, numero:generateNumero('inscriptions', id), etudiantId:wizard.data.etudiantId,
      classeId:classe.id, anneeId:annee.id, typeInscription: wizard.mode==='REINSCRIPTION' ? 'REINSCRIPTION' : 'NOUVELLE',
      statut:'VALIDEE', dateDemande:todayISO(), ecoleId:currentEcoleId});
    logAudit('CREATION', 'inscriptions', id);
    logStatutInscription(id, null, 'VALIDEE', 'Création via « Passer directement au résultat »');
    wizard.data.inscriptionId = id;
    wizard.data.classeId = classe.id;
  }
  if(!wizard.data.documentIds){
    const types = typesDocumentForClasse(wizard.data.classeId);
    const validatedIds = types.map(t=>{
      const id = nextId('documentsDossier');
      db.documentsDossier.push({id, inscriptionId:wizard.data.inscriptionId, typeDocumentId:t.id, statut:'VALIDE', dateDepot:todayISO(), motifRejet:''});
      logAudit('CREATION', 'documentsDossier', id);
      return id;
    });
    wizard.data.documentIds = validatedIds;
  }
  if(!wizard.data.echeancierId){
    const classe = findById('classes', wizard.data.classeId);
    const tarif = wizardTarifForClasse(wizard.data.classeId);
    const arrears = wizard.data.arrears || 0;
    const montantBrut = Number(tarif.montant) + arrears;
    const echeancierId = nextId('echeanciers');
    db.echeanciers.push({id:echeancierId, inscriptionId:wizard.data.inscriptionId, montantBrut, montantRemise:0, montantNet:montantBrut, statut:'A_JOUR'});
    logAudit('CREATION', 'echeanciers', echeancierId);
    lignesFromNombreVersements(echeancierId, montantBrut, tarif.nombreTranches);
    wizard.data.echeancierId = echeancierId;
  }
  if(!wizard.data.versementInscriptionId){
    const lignes = db.lignesEcheance.filter(l=>l.echeancierId===wizard.data.echeancierId).slice().sort((a,b)=>a.numeroTranche-b.numeroTranche);
    const first = lignes[0];
    const tarifInsc = wizardFraisInscriptionForClasse(wizard.data.classeId);
    const montantInsc = tarifInsc ? Number(tarifInsc.montant) : 0;

    const idInsc = nextId('versements');
    db.versements.push({id:idInsc, numero:generateNumero('versements', idInsc), inscriptionId:wizard.data.inscriptionId,
      montant:montantInsc, typeFraisId:2, datePaiement:todayISO(), modePaiement:'MOBILE_MONEY', statut:'ENREGISTRE'});
    logAudit('CREATION', 'versements', idInsc);
    wizard.data.versementInscriptionId = idInsc;

    const idScol = nextId('versements');
    db.versements.push({id:idScol, numero:generateNumero('versements', idScol), inscriptionId:wizard.data.inscriptionId,
      montant:first.montantDu, typeFraisId:1, datePaiement:todayISO(), modePaiement:'MOBILE_MONEY', statut:'ENREGISTRE'});
    logAudit('CREATION', 'versements', idScol);
    imputerVersement(idScol, first.id, Number(first.montantDu));
    wizard.data.versementScolariteId = idScol;
    wizard.data.versementId = idScol;
  }
  wizard.data.fullDemo = true;
  wizard.step = wizardTotalSteps()+1;
  wizard.maxStep = wizard.step;
  showToast('Parcours généré, voici le résultat.');
  render();
}

function lignesFromNombreVersements(echeancierId, montantNet, nombreVersements){
  const n = Math.max(1, Math.round(Number(nombreVersements) || 1));
  const annee = currentAnnee();
  const cal = annee ? calendrierTranches(annee.id) : [];
  if(cal.length > 0){
    /* calendrier de l'année : une ligne par tranche, pour tous les étudiants (le nombre demandé est ignoré) */
    const nbCal = cal.length;
    let cumulCal = 0;
    cal.forEach((t, i) => {
      const montant = i === nbCal - 1 ? Math.round(montantNet - cumulCal) : Math.round(montantNet / nbCal);
      cumulCal += montant;
      const lid = nextId('lignesEcheance');
      db.lignesEcheance.push({id:lid, echeancierId, numeroTranche:i+1, libelle:t.libelle, montantDu:montant, montantPaye:0, dateEcheance:t.dateEcheance, statut:'ATTENDU'});
      logAudit('CREATION', 'lignesEcheance', lid);
    });
    return;
  }
  const start = annee ? new Date(Math.max(new Date(annee.dateDebut), new Date(todayISO()))) : new Date(todayISO());
  const end = annee ? new Date(annee.dateFin) : new Date(new Date(todayISO()).getTime() + 300*86400000);
  const spanMs = Math.max(end - start, n*7*86400000); // au moins 7 jours d'écart entre tranches
  let cumul = 0;
  for(let i=0; i<n; i++){
    const isLast = i===n-1;
    const montant = isLast ? Math.round(montantNet - cumul) : Math.round(montantNet / n);
    cumul += montant;
    const dueDate = new Date(start.getTime() + spanMs * (i+1)/n);
    const lid = nextId('lignesEcheance');
    db.lignesEcheance.push({id:lid, echeancierId, numeroTranche:i+1, libelle: n===1 ? 'Tranche unique' : `Tranche ${i+1}/${n}`,
      montantDu:montant, montantPaye:0, dateEcheance:dueDate.toISOString().slice(0,10), statut:'ATTENDU'});
    logAudit('CREATION', 'lignesEcheance', lid);
  }
}

function wizardStepsBar(){
  const stepsNouvelle = [
    {label:'Étudiant', detail: wizard.data.etudiantId ? nameOfPersonne(wizard.data.etudiantId) : ''},
    {label:'Parent', detail: wizard.data.parentId ? nameOfPersonne(wizard.data.parentId) : ''},
    {label:'Inscription', detail: wizard.data.inscriptionId ? (findById('inscriptions',wizard.data.inscriptionId)||{}).numero : ''},
    {label:'Documents', detail: wizard.data.documentIds ? wizard.data.documentIds.length+' validé'+(wizard.data.documentIds.length>1?'s':'') : ''}
  ];
  const stepsReinscription = [
    {label:'Étudiant', detail: wizard.data.etudiantId ? nameOfPersonne(wizard.data.etudiantId) : ''},
    {label:'Inscription', detail: wizard.data.inscriptionId ? (findById('inscriptions',wizard.data.inscriptionId)||{}).numero : ''},
    {label:'Documents', detail: wizard.data.documentIds ? wizard.data.documentIds.length+' validé'+(wizard.data.documentIds.length>1?'s':'') : ''}
  ];
  const stepsCaisse = [
    {label:'Réduction', detail: wizard.data.echeancierId ? fmtMoney((findById('echeanciers',wizard.data.echeancierId)||{}).montantNet) : ''},
    {label:'Versement', detail: wizard.data.versementId ? fmtMoney((findById('versements',wizard.data.versementId)||{}).montant) : ''},
    {label:'Reçu & carte', detail: ''}
  ];
  const steps = wizard.mode==='CAISSE' ? stepsCaisse : (wizard.mode==='NOUVELLE' ? stepsNouvelle : stepsReinscription);
  return `<div class="wizard-steps">${steps.map((s,i)=>{
    const n=i+1;
    const done = n < (wizard.maxStep||0) || (n<wizard.step);
    const cls = n===wizard.step ? 'current' : (done ? 'done' : '');
    const text = (done && s.detail) ? `${s.label}, ${s.detail}` : s.label;
    const clickable = n<=(wizard.maxStep||1) && n!==wizard.step;
    return `<div class="wstep ${cls} ${clickable?'clickable':''}" ${clickable?`onclick="wizardGoToStep(${n})"`:''}><span class="dot">${(done && n!==wizard.step)?icon('check'):n}</span><span>${text}</span></div>`;
  }).join('')}</div>`;
}

function nameOfPersonne(id){ const p = findById('personnes', id); return p ? p.prenoms+' '+p.nom : ''; }

function openForm(key, id, prefill){
  const entity = ENTITIES[key];
  const storeKey = entity.storageKey || entity.key;
  const existing = id ? findById(storeKey, id) : null;
  const fieldPieces = entity.fields.map(f=>{
    const val = existing ? (f.computeValue ? f.computeValue(existing) : existing[f.key]) : (prefill && prefill[f.key]!==undefined ? prefill[f.key] : (f.default!==undefined ? (typeof f.default==='function' ? f.default() : f.default) : ''));
    if(f.type==='multiselect'){
      const selected = Array.isArray(val) ? val.map(String) : [];
      let opts_ = db[f.ref];
      if(f.filter) opts_ = opts_.filter(f.filter);
      if(ENTITIES[f.ref] && ENTITIES[f.ref].ecoleScope && currentEcoleId){
        opts_ = opts_.filter(o => ENTITIES[f.ref].ecoleScope(o) === currentEcoleId);
      }
      const labelOf = o => typeof f.display==='function' ? f.display(o) : o[f.display];
      const hiddenChecks = opts_.map(o=>`<input type="checkbox" class="ms-check" data-field="${f.key}" value="${o.id}" id="ms-${f.key}-${o.id}" ${selected.includes(String(o.id))?'checked':''} style="display:none;">`).join('');
      const rows = opts_.map(o=>{
        const isOn = selected.includes(String(o.id));
        return `<div class="toglist-item ${isOn?'active':''}" id="toglist-${f.key}-${o.id}" onclick="tagselToggle('${f.key}', '${o.id}')">
          ${isOn ? `<span class="toglist-check">${icon('check')}</span>` : ''}<span>${labelOf(o)}</span>
        </div>`;
      }).join('');
      return `<div class="field">
        <label>${f.label}${f.required?' <span class="req">*</span>':''}</label>
        <div class="toglist">${rows || '<div class="toglist-item muted">Aucune option disponible.</div>'}</div>
        <div>${hiddenChecks}</div>
      </div>`;
    }
    if(f.type==='fk' && f.cascadeClasse){
      return `<div data-cascade="${f.key}" style="display:flex; flex-direction:column; gap:13px;">
        <div class="field">
          <label>Classe <span class="req">*</span></label>
          <div class="ssel ssel-classe">
            <input type="text" class="ssel-input" placeholder="Rechercher une classe…" autocomplete="off">
            <input type="hidden" class="ssel-value">
            <div class="ssel-list"></div>
          </div>
        </div>
        <div class="field">
          <label>Étudiant <span class="req">*</span></label>
          <div class="ssel ssel-etudiant">
            <input type="text" class="ssel-input" placeholder="Choisissez d'abord une classe…" autocomplete="off" disabled>
            <input type="hidden" class="ssel-value">
            <div class="ssel-list"></div>
          </div>
        </div>
      </div>`;
    }
    if(f.type==='select'){
      const opts = f.options.map(o=>`<option value="${o}" ${val===o?'selected':''}>${titleCase(o)}</option>`).join('');
      return `<div class="field"><label>${f.label}${f.required?' <span class="req">*</span>':''}</label>
        <select data-field="${f.key}"><option value="">—</option>${opts}</select></div>`;
    }
    if(f.type==='boolean'){
      return `<div class="field field-check"><input type="checkbox" data-field="${f.key}" ${val?'checked':''}><label style="margin:0;">${f.label}</label></div>`;
    }
    if(f.type==='fk' && f.ref==='personnes'){
      let opts_ = db.personnes;
      if(f.filter) opts_ = opts_.filter(f.filter);
      const currentLabel = val ? (()=>{ const t=opts_.find(o=>String(o.id)===String(val)) || findById('personnes', val); if(!t) return ''; return typeof f.display==='function' ? f.display(t) : t[f.display]; })() : '';
      return `<div class="field">
        <label>${f.label}${f.required?' <span class="req">*</span>':''}</label>
        <div class="ssel" data-field="${f.key}">
          <input type="text" class="ssel-input" placeholder="Rechercher…" autocomplete="off" value="${currentLabel}">
          <input type="hidden" class="ssel-value" value="${val!==undefined && val!==null ? val : ''}">
          <div class="ssel-list"></div>
        </div>
      </div>`;
    }
    if(f.type==='fk'){
      let opts_ = db[f.ref];
      if(f.filter) opts_ = opts_.filter(f.filter);
      if(ENTITIES[f.ref] && ENTITIES[f.ref].ecoleScope && currentEcoleId){
        opts_ = opts_.filter(o => ENTITIES[f.ref].ecoleScope(o) === currentEcoleId);
      }
      const opts = opts_.map(o=>{
        const label = typeof f.display==='function' ? f.display(o) : o[f.display];
        return `<option value="${o.id}" ${String(val)===String(o.id)?'selected':''}>${label}</option>`;
      }).join('');
      return `<div class="field"><label>${f.label}${f.required?' <span class="req">*</span>':''}</label>
        <select data-field="${f.key}"><option value="">—</option>${opts}</select></div>`;
    }
    if(f.type==='image'){
      const uid = 'img-' + f.key + '-' + Math.random().toString(36).slice(2,8);
      return `<div class="field">
        <label>${f.label}${f.required?' <span class="req">*</span>':''}</label>
        <div style="display:flex; align-items:center; gap:14px;">
          <div class="logo-preview-box" id="${uid}-preview">${val ? `<img src="${val}" alt="">` : icon('image','icon-sm')}</div>
          <div style="display:flex; flex-direction:column; gap:6px;">
            <input type="file" accept="image/*" onchange="handleImageFieldChange(this, '${uid}')">
            <button type="button" class="btn btn-ghost btn-sm" id="${uid}-clear" onclick="clearImageField('${uid}')" style="align-self:flex-start; ${val?'':'display:none;'}">Retirer le logo</button>
          </div>
        </div>
        <input type="hidden" data-field="${f.key}" value="${val||''}" id="${uid}-hidden">
      </div>`;
    }
    const type = f.type==='number' ? 'number' : (f.type==='date' ? 'date' : 'text');
    return `<div class="field"><label>${f.label}${f.required?' <span class="req">*</span>':''}</label>
      <input type="${type}" data-field="${f.key}" value="${val!==undefined && val!==null ? val : ''}" placeholder="${f.placeholder||''}"></div>`;
  });
  // Les champs booléens consécutifs (Cumulable, Active…) tiennent sur la même ligne plutôt qu'empilés un par un.
  let fieldsHtml = '';
  for(let i=0; i<entity.fields.length;){
    if(entity.fields[i].type==='boolean'){
      let j = i;
      const group = [];
      while(j<entity.fields.length && entity.fields[j].type==='boolean'){ group.push(fieldPieces[j]); j++; }
      fieldsHtml += group.length>1 ? `<div class="field-check-row">${group.join('')}</div>` : group[0];
      i = j;
    } else {
      fieldsHtml += fieldPieces[i];
      i++;
    }
  }

  let extraHtml = '';
  if(key==='unitesEnseignement' && !existing){
    const preselected = (prefill && prefill.ecueInlineIds) || [];
    const candidates = db.matieres.filter(m=>m.ecoleId===currentEcoleId).sort((a,b)=>a.libelle.localeCompare(b.libelle));
    const rows = candidates.length ? candidates.map(m=>{
      const curUe = m.ueId ? findById('unitesEnseignement', m.ueId) : null;
      const isChecked = preselected.includes(m.id);
      return `<label class="ecue-pick-row">
        <input type="checkbox" class="ecue-inline-check" value="${m.id}" ${isChecked?'checked':''}>
        <span class="ecue-pick-name"><b>${m.libelle}</b> <span class="mono" style="color:var(--ink-faint);">(${m.credits} cr.)</span></span>
        <span class="ecue-pick-cur">${curUe ? 'actuellement dans '+curUe.code : 'sans UE'}</span>
      </label>`;
    }).join('') : `<div class="doc-note">Aucune matière existante pour l'instant.</div>`;
    extraHtml = `<div class="field">
      <label>ECUE à rattacher (facultatif)</label>
      <p style="font-size:12.5px; color:var(--ink-faint); margin:2px 0 8px;">Coche les matières existantes à inclure dans cette UE dès sa création, ou crée-en une nouvelle. Tu pourras en ajouter ou en retirer ensuite depuis sa fiche.</p>
      <button type="button" class="btn btn-ghost btn-sm" style="margin-bottom:10px;" onclick="createMatiereFromUeForm()">${icon('plus','icon-sm')} Nouvelle matière</button>
      <div class="ecue-pick-list">${rows}</div>
    </div>`;
  }

  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.id = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal">
      <div class="modal-head">
        <h3>${existing ? 'Modifier' : 'Nouveau'}, ${entity.label}</h3>
        <button class="modal-close" onclick="closeModal()">×</button>
      </div>
      <div class="modal-body" id="modal-fields">${fieldsHtml}${extraHtml}</div>
      <div class="modal-foot">
        <button class="btn" onclick="closeModal()">Annuler</button>
        <button class="btn btn-primary" onclick="submitForm('${key}', ${existing ? `'${existing.id}'` : 'null'})">Enregistrer</button>
      </div>
    </div>
  `;
  document.getElementById('modal-root').appendChild(overlay);
  overlay.addEventListener('click', e=>{ if(e.target===overlay) closeModal(); });
  initCascadeInscription(overlay, existing);
  initFormSearchableFks(overlay, entity);
  enhanceSelects(overlay);
}

function tagselToggle(fieldKey, valueId){
  const cb = document.getElementById(`ms-${fieldKey}-${valueId}`);
  if(!cb) return;
  cb.checked = !cb.checked;
  const row = document.getElementById(`toglist-${fieldKey}-${valueId}`);
  if(row){
    row.classList.toggle('active', cb.checked);
    let check = row.querySelector('.toglist-check');
    if(cb.checked && !check){
      row.insertAdjacentHTML('afterbegin', `<span class="toglist-check">${icon('check')}</span>`);
    } else if(!cb.checked && check){
      check.remove();
    }
  }
}

function handleImageFieldChange(input, uid){
  const file = input.files && input.files[0];
  if(!file) return;
  if(!file.type.startsWith('image/')){ showToast('Choisis un fichier image.'); input.value=''; return; }
  if(file.size > 800*1024){ showToast('Image trop lourde (max ~800 Ko) — choisis une image plus légère.'); input.value=''; return; }
  const reader = new FileReader();
  reader.onload = e=>{
    const dataUrl = e.target.result;
    const hidden = document.getElementById(uid+'-hidden');
    if(hidden) hidden.value = dataUrl;
    const preview = document.getElementById(uid+'-preview');
    if(preview) preview.innerHTML = `<img src="${dataUrl}" alt="">`;
    const clearBtn = document.getElementById(uid+'-clear');
    if(clearBtn) clearBtn.style.display = '';
  };
  reader.readAsDataURL(file);
}

function clearImageField(uid){
  const hidden = document.getElementById(uid+'-hidden');
  if(hidden) hidden.value = '';
  const preview = document.getElementById(uid+'-preview');
  if(preview) preview.innerHTML = icon('image','icon-sm');
  const clearBtn = document.getElementById(uid+'-clear');
  if(clearBtn) clearBtn.style.display = 'none';
}

function initCascadeInscription(container, existingRow){
  container.querySelectorAll('[data-cascade]').forEach(wrap=>{
    const fieldKey = wrap.getAttribute('data-cascade');
    const classeSel = wrap.querySelector('.ssel-classe');
    const etuSel = wrap.querySelector('.ssel-etudiant');
    const classeOptions = db.classes.filter(c=>!currentEcoleId || c.ecoleId===currentEcoleId).map(c=>{
      const niveau = findById('niveaux', c.niveauId), annee = findById('annees', c.anneeId);
      return {value:String(c.id), label:`${c.libelle}, ${niveau?niveau.libelle:''} (${annee?annee.libelle:''})`};
    });
    sselSetOptions(classeSel, classeOptions);
    function refreshEtudiants(classeId){
      const opts = db.inscriptions.filter(i=>String(i.classeId)===String(classeId) && i.statut==='VALIDEE').map(i=>{
        const etu = findById('personnes', i.etudiantId);
        return etu ? {value:String(etu.id), label: etu.prenoms+' '+etu.nom} : null;
      }).filter(Boolean);
      sselSetOptions(etuSel, opts);
    }
    initSSel(classeSel, (classeId)=>{
      etuSel.querySelector('.ssel-input').disabled = false;
      etuSel.querySelector('.ssel-input').placeholder = 'Rechercher un étudiant…';
      sselSetValue(etuSel, '', '');
      refreshEtudiants(classeId);
    });
    initSSel(etuSel, ()=>{});
    if(existingRow){
      const insc = findById('inscriptions', existingRow[fieldKey]);
      const classe = insc && insc.classeId ? findById('classes', insc.classeId) : null;
      if(classe){
        sselSetValue(classeSel, String(classe.id), classeOptions.find(o=>o.value===String(classe.id))?.label || classe.libelle);
        refreshEtudiants(classe.id);
        const etu = findById('personnes', insc.etudiantId);
        if(etu){
          sselSetValue(etuSel, String(etu.id), etu.prenoms+' '+etu.nom);
          etuSel.querySelector('.ssel-input').disabled = false;
        }
      }
    }
  });
}

function sselSetOptions(sselEl, options){ sselEl.__options = options; }

function initSSel(sselEl, onSelect){
  const input = sselEl.querySelector('.ssel-input');
  input.addEventListener('focus', ()=>{ if(!input.disabled) sselRenderList(sselEl, ''); });
  input.addEventListener('input', ()=>{ sselSetValue(sselEl, '', input.value); sselRenderList(sselEl, input.value); });
  sselEl.querySelector('.ssel-list').addEventListener('click', e=>{
    const opt = e.target.closest('.ssel-opt');
    if(!opt) return;
    sselSetValue(sselEl, opt.getAttribute('data-value'), opt.textContent);
    sselEl.querySelector('.ssel-list').classList.remove('open');
    if(onSelect) onSelect(opt.getAttribute('data-value'));
  });
  sselEl.addEventListener('click', e=>e.stopPropagation());
}

function sselRenderList(sselEl, query){
  const list = sselEl.querySelector('.ssel-list');
  const opts = (sselEl.__options||[]).filter(o=>!query || o.label.toLowerCase().includes(query.toLowerCase()));
  list.innerHTML = opts.length ? opts.map(o=>`<div class="ssel-opt" data-value="${o.value}">${o.label}</div>`).join('')
    : `<div class="ssel-empty">Aucun résultat</div>`;
  list.classList.add('open');
}

function sselSetValue(sselEl, value, label){
  sselEl.querySelector('.ssel-value').value = value;
  sselEl.querySelector('.ssel-input').value = label;
  sselEl.__selectedLabel = label;
}

function initFormSearchableFks(container, entity){
  container.querySelectorAll('.ssel[data-field]').forEach(sel=>{
    const fieldKey = sel.getAttribute('data-field');
    const f = entity.fields.find(x=>x.key===fieldKey);
    if(!f || f.type!=='fk') return;
    let opts_ = db[f.ref];
    if(f.filter) opts_ = opts_.filter(f.filter);
    if(ENTITIES[f.ref] && ENTITIES[f.ref].ecoleScope && currentEcoleId){
      opts_ = opts_.filter(o => ENTITIES[f.ref].ecoleScope(o) === currentEcoleId);
    }
    const options = opts_.map(o=>({value:String(o.id), label: typeof f.display==='function' ? f.display(o) : o[f.display]}));
    sselSetOptions(sel, options);
    initSSel(sel, ()=>{});
  });
}

/** Toutes les fonctions du HTML reprises ici : les gestionnaires « onclick » du balisage les appellent par leur nom. */
export const legacyGlobals = { fieldDisplayValue, renderDetailPage, pickQuickFacts, profileInfoCards, offreNiveauxLabel, extraTabsFor, paymentsTableHtml, computeBulletinMoyenne, matieresForClasse, matieresForOffreNiveauPeriode, matiereMoyenne, creditsOffered, computeBilanAnnuel, computeMention, semestreManquantHtml, studentInscriptionsTab, studentPaymentsTab, tauxFill, studentParentsTab, studentNotesTab, setNotesFilterPeriode, setDetailTab, setNotesFilterMatiere, studentBulletinsTab, parentChildrenTab, initialsOf, renderGuidePage, renderModulePage, renderGroupPage, renderReportPage, renderSoldesReport, tauxColor, setSoldesFilter, setSoldesFilterDateDebut, setSoldesFilterDateFin, schoolLogoHtml, renderRelancesGlobales, computeRelanceRow, toggleRelanceSelect, setRelancesFilterCycle, setRelancesFilterNiveau, setRelancesFilterClasse, setRelancesFilterEtudiant, setRelancesFilter, setRelancesFilterDateDebut, setRelancesFilterDateFin, startRelanceBulk, openRelancesPrintChoice, closeRelancesPrintChoiceAndBulk, docHeader, toggleRelanceSelectAll, renderEcheancesDateesReport, allLignesEcheanceRows, setEcheancesDateesFilter, renderCaissePendingReport, toggleCaisseSelect, startCaisseTraitement, studentArrears, openBulkReductionModal, enhanceSelects, upgradeSelectToS2, s2MeasureWidth, toggleCaisseSelectAll, renderCaisseEtatsReport, setCaisseEtatsClasse, setCaisseEtatsAnnee, setCaisseEtatsDateDebut, setCaisseEtatsDateFin, pdfName, ensureViewToggle, setViewMode, applyViewMode, renderMatieresPage, renderMatieresPickOffre, setMatieresPickerOffre, renderMatieresPickNiveau, setMatieresPickerNiveau, renderMatieresPickPeriode, setMatieresPickerPeriode, renderMatieresFiltered, pagerHtml, setTablePage, renderNotesPage, renderNotesPickClasse, setNotesPickerClasse, renderNotesPickMatiere, setNotesPickerMatiere, renderNotesPickPeriode, setNotesPickerPeriode, renderNotesSaisie, notesGridColumns, addNotesColumn, renderBulletinsPage, renderBulletinsPickClasse, setBulletinsPickerClasse, renderBulletinsPickPeriode, setBulletinsPickerPeriode, renderBulletinsGrid, computeCreditsValides, computeRang, renderWizard, wizardTotalSteps, wizardStep0, chooseWizardMode, wizardRecapEtudiant, wizardRecapCard, wizardBackBtn, resetWizard, wizardGoToStep, wizardAdvance, wizardStepEtudiant, wizardRecapParent, wizardStepParent, wizardRecapInscription, wizardStepInscription, wizardOnClasseChange, wizardFraisPreviewHTML, wizardTarifForClasse, wizardFraisInscriptionForClasse, wizardRecapDocuments, wizardStepDocuments, wizardStepFinal, openRecuInscription, wizardStepInscriptionDone, wizardRecapEcheancier, wizardStepLabel, wizardStepEcheancier, wizardRemoveFraisSupp, calendrierTranches, wizardAddFraisSupp, wizardAddFraisVersement, wizardRemoveFraisVersement, wizardRecapVersement, wizardStepVersement, wizardOnPayChoiceChange, wizardStepSelectEtudiant, wizardConfirmReinscriptionEtudiant, wizardSkipToEnd, lignesFromNombreVersements, wizardStepsBar, nameOfPersonne, openForm, tagselToggle, handleImageFieldChange, clearImageField, initCascadeInscription, sselSetOptions, initSSel, sselRenderList, sselSetValue, initFormSearchableFks }
/** Les variables d'état de la maquette (filtres, sélections…), lisibles et modifiables depuis l'application. */
export const legacyState = { get wizard() { return wizard }, set wizard(x) { wizard = x }, get detailActiveRecord() { return detailActiveRecord }, set detailActiveRecord(x) { detailActiveRecord = x }, get detailActiveTab() { return detailActiveTab }, set detailActiveTab(x) { detailActiveTab = x }, get notesFilterPeriodeId() { return notesFilterPeriodeId }, set notesFilterPeriodeId(x) { notesFilterPeriodeId = x }, get notesFilterMatiereId() { return notesFilterMatiereId }, set notesFilterMatiereId(x) { notesFilterMatiereId = x }, get soldesFilterClasse() { return soldesFilterClasse }, set soldesFilterClasse(x) { soldesFilterClasse = x }, get soldesFilterDateDebut() { return soldesFilterDateDebut }, set soldesFilterDateDebut(x) { soldesFilterDateDebut = x }, get soldesFilterDateFin() { return soldesFilterDateFin }, set soldesFilterDateFin(x) { soldesFilterDateFin = x }, get relancesFilterDate() { return relancesFilterDate }, set relancesFilterDate(x) { relancesFilterDate = x }, get relancesFilterCycleId() { return relancesFilterCycleId }, set relancesFilterCycleId(x) { relancesFilterCycleId = x }, get relancesFilterNiveauId() { return relancesFilterNiveauId }, set relancesFilterNiveauId(x) { relancesFilterNiveauId = x }, get relancesFilterClasseId() { return relancesFilterClasseId }, set relancesFilterClasseId(x) { relancesFilterClasseId = x }, get relancesFilterEtudiantId() { return relancesFilterEtudiantId }, set relancesFilterEtudiantId(x) { relancesFilterEtudiantId = x }, get relancesFilterDateDebut() { return relancesFilterDateDebut }, set relancesFilterDateDebut(x) { relancesFilterDateDebut = x }, get relancesFilterDateFin() { return relancesFilterDateFin }, set relancesFilterDateFin(x) { relancesFilterDateFin = x }, get relancesSelection() { return relancesSelection }, set relancesSelection(x) { relancesSelection = x }, get relanceBulkIds() { return relanceBulkIds }, set relanceBulkIds(x) { relanceBulkIds = x }, get echeancesDateesFilter() { return echeancesDateesFilter }, set echeancesDateesFilter(x) { echeancesDateesFilter = x }, get caisseSelection() { return caisseSelection }, set caisseSelection(x) { caisseSelection = x }, get caisseEtatsAnneeId() { return caisseEtatsAnneeId }, set caisseEtatsAnneeId(x) { caisseEtatsAnneeId = x }, get caisseEtatsClasseId() { return caisseEtatsClasseId }, set caisseEtatsClasseId(x) { caisseEtatsClasseId = x }, get caisseEtatsMoisKey() { return caisseEtatsMoisKey }, set caisseEtatsMoisKey(x) { caisseEtatsMoisKey = x }, get caisseEtatsDateDebut() { return caisseEtatsDateDebut }, set caisseEtatsDateDebut(x) { caisseEtatsDateDebut = x }, get caisseEtatsDateFin() { return caisseEtatsDateFin }, set caisseEtatsDateFin(x) { caisseEtatsDateFin = x }, get viewMode() { return viewMode }, set viewMode(x) { viewMode = x }, get matieresPicker() { return matieresPicker }, set matieresPicker(x) { matieresPicker = x }, get notesPicker() { return notesPicker }, set notesPicker(x) { notesPicker = x }, get bulletinsPicker() { return bulletinsPicker }, set bulletinsPicker(x) { bulletinsPicker = x }, get recuInscriptionContext() { return recuInscriptionContext }, set recuInscriptionContext(x) { recuInscriptionContext = x } }
export { renderDetailPage, renderModulePage, renderGroupPage, renderReportPage, renderMatieresPage, renderNotesPage, renderBulletinsPage, renderWizard, renderGuidePage, openForm, enhanceSelects, ensureViewToggle, initWizardEtudiantSelect }
